"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4977,5154],{

/***/ 55175:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Spinner-Logo.1e17ddd9.gif","height":100,"width":100});

/***/ }),

/***/ 98901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "OnboardingForm": function() { return /* binding */ OnboardingForm; },
  "bookMeeting": function() { return /* binding */ bookMeeting; },
  "default": function() { return /* binding */ get_started; },
  "getStartedWrapperStyles": function() { return /* binding */ getStartedWrapperStyles; },
  "useSignUpStyles": function() { return /* binding */ useSignUpStyles; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./src/components/onboarding/OnboardingDesignWrapper.tsx
var OnboardingDesignWrapper = __webpack_require__(4977);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(79895);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(14310);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(55517);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(80797);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AppBar/AppBar.js
var AppBar = __webpack_require__(45258);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Toolbar/Toolbar.js
var Toolbar = __webpack_require__(28358);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tabs/Tabs.js + 5 modules
var Tabs = __webpack_require__(92553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tab/Tab.js
var Tab = __webpack_require__(41423);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/components/shared/MetaTagGenerator.tsx
var MetaTagGenerator = __webpack_require__(65154);
// EXTERNAL MODULE: ./src/components/onboarding/CustomTextField.tsx
var CustomTextField = __webpack_require__(27290);
// EXTERNAL MODULE: ./src/utility/services/hubSpot.ts
var hubSpot = __webpack_require__(56227);
// EXTERNAL MODULE: ./src/utility/validation/email.ts
var validation_email = __webpack_require__(30831);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(87066);
// EXTERNAL MODULE: ./node_modules/@auth0/nextjs-auth0/dist/client/index.js
var client = __webpack_require__(73606);
// EXTERNAL MODULE: ./src/utility/services/authActions.tsx
var authActions = __webpack_require__(63846);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/constants/common.js
var common = __webpack_require__(31196);
// EXTERNAL MODULE: ./src/constants/analyticsMeta.ts + 8 modules
var analyticsMeta = __webpack_require__(66306);
// EXTERNAL MODULE: ./src/components/content-ai-tools/components/DescribeQuestion.tsx
var DescribeQuestion = __webpack_require__(93867);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputLabel/InputLabel.js
var InputLabel = __webpack_require__(96394);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Select/Select.js + 4 modules
var Select = __webpack_require__(94924);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(85639);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(30585);
;// CONCATENATED MODULE: ./src/components/onboarding/CustomSelect.tsx




var CustomSelect = function(param) {
    var label = param.label, options = param.options, _id = param.id, id = _id === void 0 ? "custom-select" : _id, value = param.value, onChange = param.onChange, _error = param.error, error = _error === void 0 ? false : _error, _errorMessage = param.errorMessage, errorMessage = _errorMessage === void 0 ? "" : _errorMessage, _info = param.info, info = _info === void 0 ? "" : _info, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? true : _fullWidth, _limitWidth = param.limitWidth, limitWidth = _limitWidth === void 0 ? false : _limitWidth;
    var classes = (0,CustomTextField/* customInputUseStyles */.j)();
    var ref = (0,react.useState)(false), tooltipOpen = ref[0], setTooltipOpen = ref[1];
    //   const tooltipRef = useRef(null);
    var handleTooltipToggle = function() {
        setTooltipOpen(!tooltipOpen);
    };
    //   useEffect(() => {
    //     const handleClickOutside = (event) => {
    //       if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
    //         setTooltipOpen(false); // Close tooltip if click is outside
    //       }
    //     };
    //     // Add when the tooltip is open and remove when it is closed
    //     if (info && tooltipOpen) {
    //       document.addEventListener('mousedown', handleClickOutside);
    //     }
    //     return () => {
    //       document.removeEventListener('mousedown', handleClickOutside);
    //     };
    //   }, [tooltipOpen, info]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
        variant: "outlined",
        error: error,
        className: "".concat(classes.selectFormControl, " ").concat(classes.formControl, " ").concat(fullWidth ? "w-100" : "", " ").concat(limitWidth ? classes.maxWidth : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                htmlFor: id,
                className: "".concat(classes.staticLabel, " ").concat(classes.inputLabel, " ").concat(error ? "Mui-error" : ""),
                shrink: false,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                labelId: "".concat(id, "-label"),
                id: id,
                value: value,
                onChange: onChange,
                displayEmpty: true,
                className: classes.selectEmpty,
                fullWidth: fullWidth,
                renderValue: value ? undefined : function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classes.placeholder,
                        children: "Please select one"
                    });
                },
                children: options.map(function(option, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        value: option.value,
                        children: option.label
                    }, index);
                })
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                style: {
                    marginLeft: "0px"
                },
                children: errorMessage
            })
        ]
    });
};
/* harmony default export */ var onboarding_CustomSelect = (CustomSelect);

// EXTERNAL MODULE: ./node_modules/@rollbar/react/dist/useRollbar.js
var useRollbar = __webpack_require__(87015);
// EXTERNAL MODULE: ./src/utility/common.js + 1 modules
var utility_common = __webpack_require__(5969);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/List.js
var List = __webpack_require__(62822);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js
var ListItem = __webpack_require__(50998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(46869);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CheckCircle.js
var CheckCircle = __webpack_require__(81395);
// EXTERNAL MODULE: ./src/utility/services/uiHelpers.js
var uiHelpers = __webpack_require__(4465);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/auth0-js/dist/auth0.min.esm.js
var auth0_min_esm = __webpack_require__(95550);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js
var createStyles = __webpack_require__(35117);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Stepper/Stepper.js
var Stepper = __webpack_require__(4686);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Step/Step.js
var Step = __webpack_require__(91594);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/StepLabel/StepLabel.js + 3 modules
var StepLabel = __webpack_require__(2876);
;// CONCATENATED MODULE: ./src/components/content-ai-tools/components/StepperGetstarted.tsx






var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {
            width: "100%",
            color: "#51D497",
            background: "#FBFBFD",
            "& .MuiStepIcon-active": {
                color: "white",
                borderRadius: "50%",
                border: "1.5px solid #51D497",
                "& .MuiStepIcon-text": {
                    color: "#51D497 !important",
                    fill: "unset",
                    fontWeight: "700",
                    fontSize: "14px"
                }
            },
            "& .MuiStepIcon-completed": {
                color: "#51D497"
            },
            "& .Mui-disabled .MuiStepIcon-root": {
                color: "lightgray"
            },
            "& .MuiStepper-root": {
                padding: "10px 0px 20px 0px",
                backgroundColor: "#f6f7f9 !important"
            },
            "& .MuiStepLabel-label": {
                whiteSpace: "nowrap"
            },
            "& .MuiStepLabel-active": {
                color: "#1D3557"
            }
        },
        backButton: {
            marginRight: theme.spacing(1)
        },
        instructions: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        }
    });
});
function getSteps() {
    return [
        "Verify Email",
        "Pay for Plan",
        "Set Password"
    ];
}
var StepperGetStarted = function(param) {
    var activeStep = param.activeStep;
    var classes = useStyles();
    var steps = getSteps();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stepper/* default */.Z, {
            activeStep: activeStep,
            alternativeLabel: true,
            children: steps.map(function(label) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Step/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StepLabel/* default */.Z, {
                        children: label
                    })
                }, label);
            })
        })
    });
};

// EXTERNAL MODULE: ./src/utility/services/customHooks/index.ts + 4 modules
var customHooks = __webpack_require__(89147);
;// CONCATENATED MODULE: ./src/components/content-ai-tools/components/VerifyToolsUser.tsx



















var VerifyToolsUser = function(param) {
    var handleChangePlan = param.handleChangePlan, _showStepper = param.showStepper, showStepper = _showStepper === void 0 ? false : _showStepper;
    var planName = sessionStorage.getItem("selected-tools-plan") || "Free";
    var toolsUser = sessionStorage.getItem("tools-user-auth");
    var ref = (0,react.useState)(""), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react.useState)(""), firstName = ref1[0], setFirstName = ref1[1];
    var ref2 = (0,react.useState)(""), lastName = ref2[0], setLastName = ref2[1];
    var ref3 = (0,react.useState)(""), planId = ref3[0], setPlanId = ref3[1];
    var ref4 = (0,react.useState)(false), checked = ref4[0], setChecked = ref4[1];
    var ref5 = (0,react.useState)(""), checkboxError = ref5[0], setCheckboxError = ref5[1];
    var ref6 = (0,react.useState)(false), receiveEmailsChecked = ref6[0], setReceiveEmailsChecked = ref6[1];
    var ref7 = (0,react.useState)(false), showRequestLoader = ref7[0], setShowRequestLoader = ref7[1];
    var ref8 = (0,react.useState)(false), showCodeInput = ref8[0], setShowCodeInput = ref8[1];
    var ref9 = (0,react.useState)(false), showVerifyLoader = ref9[0], setShowVerifyLoader = ref9[1];
    var ref10 = (0,react.useState)(false), showSuccessEmailVerification = ref10[0], setShowSuccessEmailVerification = ref10[1];
    var ref11 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), verifiedEmail = ref11[0], setVerifiedEmail = ref11[1];
    var ref12 = (0,react.useState)(true), showCreatePassword = ref12[0], setShowCreatePassword = ref12[1];
    var ref13 = (0,react.useState)(""), password = ref13[0], setPassword = ref13[1];
    var ref14 = (0,react.useState)(""), password2 = ref14[0], setPassword2 = ref14[1];
    var ref15 = (0,react.useState)(""), code = ref15[0], setCode = ref15[1];
    var ref16 = (0,react.useState)([]), passwordError = ref16[0], setPasswordError = ref16[1];
    var ref17 = (0,react.useState)(false), userExists = ref17[0], setUserExists = ref17[1];
    var ref18 = (0,react.useState)(false), createAccountLoading = ref18[0], setCreateAccountLoading = ref18[1];
    var ref19 = (0,react.useState)(false), createGoogleAccountLoading = ref19[0], setCreateGoogleAccountLoading = ref19[1];
    var ref20 = (0,_sliced_to_array/* default */.Z)((0,customHooks/* useQalert */.to)(), 2), _ = ref20[0], toggleSnackBar = ref20[1];
    var ref21 = (0,react.useState)(false), manualLogin = ref21[0], setManualLogin = ref21[1];
    var ref22 = (0,react.useState)({}), error = ref22[0], setError = ref22[1];
    var ref23 = (0,react.useState)({}), errorMessage = ref23[0], setErrorMessage = ref23[1];
    var ref24 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), activeStep = ref24[0], setActiveStep = ref24[1];
    var router = (0,next_router.useRouter)();
    var qttr_tools_auth = js_cookie/* default.get */.Z.get("qttr_tools_auth");
    var handleSubmitAndVerify = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var allValid, newError, newErrorMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        allValid = true; // Flag to track if all validations pass
                        newError = (0,_object_spread/* default */.Z)({}, error);
                        newErrorMessage = (0,_object_spread/* default */.Z)({}, errorMessage);
                        _ctx.prev = 3;
                        setShowRequestLoader(true);
                        if (!email) {
                            newErrorMessage.email = "* Required";
                            newError.email = true;
                            allValid = false;
                        } else if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
                            newErrorMessage.email = "invalid Email";
                            newError.email = true;
                            allValid = false;
                        } else {
                            newErrorMessage.email = "";
                            newError.email = false;
                        }
                        if (!firstName) {
                            newErrorMessage.firstName = "* Required";
                            newError.firstName = true;
                        } else {
                            newErrorMessage.firstName = "";
                            newError.firstName = false;
                        }
                        if (!lastName) {
                            newErrorMessage.lastName = "* Required";
                            newError.lastName = true;
                        } else {
                            newErrorMessage.lastName = "";
                            newError.lastName = false;
                        }
                        if (!checked) {
                            setCheckboxError(" Please indicate that you have read and agree to the Terms of Use and Privacy Policy!");
                        }
                        allValid = allValid && !newError.firstName && !newError.lastName && checked;
                        if (!allValid) {
                            _ctx.next = 20;
                            break;
                        }
                        (0,analyticsMeta/* trackAnalyticsEvent */.ec)({
                            eventName: "Verify Email Form Submitted",
                            payload: {
                                label: "Verify Email Form shown",
                                firstName: firstName,
                                lastName: lastName,
                                email: email,
                                recieve_marketing_emails: receiveEmailsChecked,
                                component_name: analyticsMeta/* COMPONENT_NAMES.contentai_ai_tools */.Xm.contentai_ai_tools,
                                screen_name: analyticsMeta/* SCREEN_NAMES.contentai_ai_tools */.iz.contentai_ai_tools
                            }
                        });
                        _ctx.next = 14;
                        return axios/* default.post */.Z.post("/api/join-content-ai/request-otp", {
                            email: email,
                            fullName: "".concat(firstName, " ").concat(lastName)
                        }, {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        });
                    case 14:
                        setShowCodeInput(true);
                        if (window && window.analytics) {
                            window.analytics.identify(email, {
                                email: email,
                                name: "".concat(firstName, " ").concat(lastName),
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq,
                                company_name: ""
                            });
                        }
                        (0,analyticsMeta/* setUserAttribute */.gT)("firstName", firstName);
                        (0,analyticsMeta/* setUserAttribute */.gT)("lastName", lastName);
                        (0,analyticsMeta/* setUserAttribute */.gT)("email", email);
                        (0,analyticsMeta/* setUserAttribute */.gT)("recieve_marketing_emails", receiveEmailsChecked);
                    case 20:
                        _ctx.next = 25;
                        break;
                    case 22:
                        _ctx.prev = 22;
                        _ctx.t0 = _ctx["catch"](3);
                        console.error("error : handleSubmitAndVerify", _ctx.t0);
                    case 25:
                        _ctx.prev = 25;
                        setShowRequestLoader(false);
                        return _ctx.finish(25);
                    case 28:
                        setErrorMessage(newErrorMessage);
                        setError(newError);
                    case 30:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    22,
                    25,
                    28
                ]
            ]);
        }));
        return function handleSubmitAndVerify() {
            return _ref.apply(this, arguments);
        };
    }();
    var verifyOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var newError, newErrorMessage, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        newError = (0,_object_spread/* default */.Z)({}, error);
                        newErrorMessage = (0,_object_spread/* default */.Z)({}, errorMessage);
                        _ctx.prev = 2;
                        if (!code) {
                            newErrorMessage.code = "* Required";
                            newError.code = true;
                        } else {
                            newErrorMessage.code = "";
                            newError.code = false;
                        }
                        setShowVerifyLoader(true);
                        _ctx.next = 7;
                        return axios/* default.post */.Z.post("/api/join-content-ai/verify-otp", {
                            email: email,
                            otp: code,
                            firstName: firstName,
                            lastName: lastName,
                            fullName: "".concat(firstName, " ").concat(lastName)
                        }, {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        });
                    case 7:
                        res = _ctx.sent;
                        setVerifiedEmail(true);
                        handleNext();
                        setShowCodeInput(false);
                        setShowCreatePassword(true);
                        (0,analyticsMeta/* trackAnalyticsEvent */.ec)({
                            eventName: "Verified Email with OTP",
                            payload: {
                                label: "Verified Email with OTP",
                                component_name: analyticsMeta/* COMPONENT_NAMES.contentai_ai_tools */.Xm.contentai_ai_tools,
                                screen_name: analyticsMeta/* SCREEN_NAMES.contentai_ai_tools */.iz.contentai_ai_tools
                            }
                        });
                        (0,analyticsMeta/* setUserAttribute */.gT)("last_verified_at", new Date().toISOString());
                        (0,analyticsMeta/* setUserAttribute */.gT)("email_verified_with", "Manual");
                        _ctx.next = 22;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](2);
                        console.error("error : verifyOtp", _ctx.t0);
                        newErrorMessage.code = "Invalid OTP";
                        newError.code = true;
                    case 22:
                        _ctx.prev = 22;
                        setShowVerifyLoader(false);
                        return _ctx.finish(22);
                    case 25:
                        setErrorMessage(newErrorMessage);
                        setError(newError);
                    case 27:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    17,
                    22,
                    25
                ]
            ]);
        }));
        return function verifyOtp() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleVerifyWithEmail = function() {
        var statePayload = {
            // Encode the current location or any other data you want to preserve
            redirectUri: "/get-started?tab=ai-tools",
            isFromUnlockOption: false
        };
        (0,analyticsMeta/* trackAnalyticsEvent */.ec)({
            eventName: "Button click",
            eventFor: "Custom Button",
            payload: {
                label: "Complete Verification with google",
                component_name: analyticsMeta/* COMPONENT_NAMES.contentai_ai_tools */.Xm.contentai_ai_tools,
                screen_name: analyticsMeta/* SCREEN_NAMES.contentai_ai_tools */.iz.contentai_ai_tools,
                isQwaDashboard: false
            }
        });
        var state = encodeURIComponent(JSON.stringify(statePayload));
        window.location.href = "https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=".concat("84677137319-62vtko0r2hh16tqce0lnsfsg5aupul2s.apps.googleusercontent.com", "&redirect_uri=").concat("https://www.quattr.com", "/api/goauth/callback&scope=email%20profile&access_type=online&state=").concat(state);
    };
    var validatePassword = function(password, password2) {
        // Regular expressions for password rules
        var lengthRegex = /.{8,}/;
        var uppercaseRegex = /[A-Z]/;
        var lowercaseRegex = /[a-z]/;
        var digitRegex = /\d/;
        var specialCharRegex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
        // Error messages
        var errors = [];
        // Check if passwords match
        if (!password || !password2) {
            errors.push("Password fields can't be empty");
        } else if (password !== password2) {
            errors.push("Passwords provided do not match");
        } else if (!lengthRegex.test(password)) {
            errors.push("Should contain at least 8 characters");
        } else if (!uppercaseRegex.test(password)) {
            errors.push("Should contain one capital case letter");
        } else if (!lowercaseRegex.test(password)) {
            errors.push("Should contain one small case letter");
        } else if (!digitRegex.test(password)) {
            errors.push("Should contain one numerical digit");
        } else if (!specialCharRegex.test(password)) {
            errors.push("Should contain one special character");
        }
        setPasswordError(errors);
        return (errors === null || errors === void 0 ? void 0 : errors.length) === 0;
    };
    var handlePasswordSet = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var isValid, ref, ref1, payload, config, response, ref2, payload1, config1, response1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setCreateAccountLoading(true);
                        isValid = validatePassword(password, password2);
                        if (!(isValid && !manualLogin)) {
                            _ctx.next = 31;
                            break;
                        }
                        _ctx.prev = 3;
                        ;
                        payload = {
                            email: email,
                            firstname: firstName,
                            lastname: lastName,
                            password: password,
                            planId: planId,
                            qwa_tools_subscription_status: common/* SUBSCRIPTION_STATUS.SUBSCRIPTION_ACTIVATED */.qq.SUBSCRIPTION_ACTIVATED
                        };
                        config = {
                            method: "POST",
                            url: "/api/join-content-ai/setup-tools-user",
                            data: payload
                        };
                        _ctx.next = 9;
                        return axios/* default.request */.Z.request(config);
                    case 9:
                        response = _ctx.sent;
                        if (!(response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.created_at)) {
                            _ctx.next = 16;
                            break;
                        }
                        if (window === null || window === void 0 ? void 0 : window.analytics) {
                            window.analytics.track("Created Account", {
                                option: "Created Account",
                                email: email,
                                isQwaDashboard: false
                            });
                        } else {
                            (0,analyticsMeta/* segmentEventApi */.Ey)("Created Account", {
                                option: "Created Account",
                                email: email,
                                isQwaDashboard: false
                            }, "track");
                        }
                        _ctx.next = 14;
                        return handleAutoLogin();
                    case 14:
                        _ctx.next = 23;
                        break;
                    case 16:
                        _ctx.next = 18;
                        return handleAutoLogin();
                    case 18:
                        setUserExists(true);
                        console.error("User Already Exists !");
                        if (window === null || window === void 0 ? void 0 : window.analytics) {
                            window.analytics.track("User Already Exists", {
                                option: "User Already Exists",
                                email: email,
                                isQwaDashboard: false
                            });
                        } else {
                            (0,analyticsMeta/* segmentEventApi */.Ey)("User With Already Exists", {
                                option: "User Already Exists",
                                email: email,
                                isQwaDashboard: false
                            }, "track");
                        }
                        setCreateAccountLoading(false);
                        router.push("/login");
                    case 23:
                        _ctx.next = 29;
                        break;
                    case 25:
                        _ctx.prev = 25;
                        _ctx.t0 = _ctx["catch"](3);
                        setCreateAccountLoading(false);
                        console.error("Error: creating new user ", _ctx.t0);
                    case 29:
                        _ctx.next = 49;
                        break;
                    case 31:
                        if (!(isValid && manualLogin)) {
                            _ctx.next = 48;
                            break;
                        }
                        ;
                        _ctx.next = 35;
                        return (0,authActions.signOut)({
                            callbackUrl: "/get-started?tab=ai-tools&&manualLogin=true",
                            redirect: false
                        });
                    case 35:
                        payload1 = {
                            email: email,
                            newPassword: password
                        };
                        config1 = {
                            method: "POST",
                            url: "/api/join-content-ai/update-tools-users-password",
                            data: payload1
                        };
                        _ctx.next = 39;
                        return axios/* default.request */.Z.request(config1);
                    case 39:
                        response1 = _ctx.sent;
                        if (!(response1 === null || response1 === void 0 ? void 0 : (ref2 = response1.data) === null || ref2 === void 0 ? void 0 : ref2.data)) {
                            _ctx.next = 45;
                            break;
                        }
                        _ctx.next = 43;
                        return handleAutoLogin();
                    case 43:
                        _ctx.next = 46;
                        break;
                    case 45:
                        {
                            router.push("/login");
                        }
                    case 46:
                        _ctx.next = 49;
                        break;
                    case 48:
                        {
                            setCreateAccountLoading(false);
                        }
                    case 49:
                        if (window === null || window === void 0 ? void 0 : window.analytics) {
                            window.analytics.track("Clicked on Create Account", {
                                option: "Clicked on Create Account",
                                isValidPassword: isValid,
                                isQwaDashboard: false
                            });
                        } else {
                            (0,analyticsMeta/* segmentEventApi */.Ey)("Clicked on Create Account", {
                                option: "Clicked on Create Account",
                                isValidPassword: isValid,
                                isQwaDashboard: false
                            }, "track");
                        }
                    case 50:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    25
                ]
            ]);
        }));
        return function handlePasswordSet() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAutoLogin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var state, auth0Obj, payload, result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setCreateAccountLoading(true);
                        state = (0,v4/* default */.Z)(); // Generates a new, unique state for each session
                        sessionStorage.setItem("auth_state", state); // Store state in sessionStorage for later validation
                        auth0Obj = new auth0_min_esm/* default.WebAuth */.ZP.WebAuth({
                            domain: "https://auth.quattr.com",
                            clientID: "EG9H83MUzcmpkBE30xNxngbEZMgo30fJ",
                            connection: "qwa-users-prod-db",
                            scope: "openid profile email",
                            audience: "https://quattr.com/api/",
                            responseType: "code",
                            redirectUri: "".concat("https://www.quattr.com", "/user-auth"),
                            state: state
                        });
                        payload = {
                            email: email
                        };
                        _ctx.next = 8;
                        return auth0Obj.login({
                            email: payload.email,
                            realm: "qwa-users-prod-db",
                            password: password,
                            onRedirecting: function(doAuth) {
                                doAuth();
                            }
                        });
                    case 8:
                        result = _ctx.sent;
                        if (result === null || result === void 0 ? void 0 : result.data) {
                            console.log("Auto Login success !");
                            if (window.analytics) {
                                window.analytics.identify("".concat(payload === null || payload === void 0 ? void 0 : payload.email), {
                                    email: payload === null || payload === void 0 ? void 0 : payload.email
                                });
                                window.analytics.track("Auto Login Success", {
                                    option: "Auto Login Success",
                                    email: payload === null || payload === void 0 ? void 0 : payload.email,
                                    isQwaDashboard: true
                                });
                            } else {
                                (0,analyticsMeta/* segmentEventApi */.Ey)("Auto Login Success", {
                                    option: "Auto Login Success",
                                    email: payload === null || payload === void 0 ? void 0 : payload.email,
                                    isQwaDashboard: true
                                }, "track");
                            }
                        }
                        _ctx.next = 16;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error("Error", _ctx.t0);
                        if (window.analytics) {
                            window.analytics.track("Unable to Auto Login", {
                                option: "Auto Login Error",
                                email: email,
                                isQwaDashboard: false
                            });
                        } else {
                            (0,analyticsMeta/* segmentEventApi */.Ey)("Unable to Auto Login", {
                                option: "Auto Login Error",
                                email: email,
                                isQwaDashboard: false
                            }, "track");
                        }
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function handleAutoLogin() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleToolsSignupWithGoogle = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, payload, config, response, payload1, payload2, payload3;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setCreateGoogleAccountLoading(true);
                        if (!manualLogin) {
                            _ctx.next = 5;
                            break;
                        }
                        {
                            router.push({
                                pathname: "/api/google-signup-for-tools-user",
                                query: {
                                    email: email,
                                    planId: planId
                                }
                            });
                        }
                        _ctx.next = 19;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        ;
                        payload = {
                            email: email,
                            firstname: firstName,
                            lastname: lastName,
                            planId: planId,
                            qwa_tools_subscription_status: common/* SUBSCRIPTION_STATUS.SUBSCRIPTION_ACTIVATED */.qq.SUBSCRIPTION_ACTIVATED
                        };
                        config = {
                            method: "POST",
                            url: "/api/join-content-ai/setup-tools-user-with-google",
                            data: payload
                        };
                        _ctx.next = 11;
                        return axios/* default.request */.Z.request(config);
                    case 11:
                        response = _ctx.sent;
                        if (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.created_at) {
                            router.push({
                                pathname: "/api/google-signup-for-tools-user",
                                query: {
                                    email: email,
                                    planId: planId
                                }
                            });
                            if (window.analytics) {
                                window.analytics.track("Success", {
                                    label: "Success creating tools account in auth0",
                                    reference: "redirected to google auth page"
                                });
                            } else {
                                payload1 = {
                                    email: email,
                                    instance_type: utility_common/* USER_CLASSIFICATION.QWA_TOOLS */.Cf8.QWA_TOOLS,
                                    user_type: utility_common/* USER_CLASSIFICATION.QWA_TOOLS */.Cf8.QWA_TOOLS,
                                    label: "Success creating tools account in auth0",
                                    reference: "redirected to google auth page"
                                };
                                (0,analyticsMeta/* segmentEventApi */.Ey)("Success creating tools account in auth0", payload1, "track");
                            }
                        } else {
                            if (window.analytics) {
                                window.analytics.track("Error", {
                                    label: "Error creating tools account with Google"
                                });
                            } else {
                                payload2 = {
                                    email: email,
                                    instance_type: utility_common/* USER_CLASSIFICATION.QWA_TOOLS */.Cf8.QWA_TOOLS,
                                    user_type: utility_common/* USER_CLASSIFICATION.QWA_TOOLS */.Cf8.QWA_TOOLS,
                                    label: "Error creating tools account with Google"
                                };
                                (0,analyticsMeta/* segmentEventApi */.Ey)("Error", payload2, "track");
                            }
                        }
                        _ctx.next = 19;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](5);
                        console.error("Error: creating new user ", _ctx.t0);
                        if (window.analytics) {
                            window.analytics.track("Error", {
                                label: "Error creating tools account with Google"
                            });
                        } else {
                            payload3 = {
                                email: email,
                                instance_type: utility_common/* USER_CLASSIFICATION.QWA_TOOLS */.Cf8.QWA_TOOLS,
                                user_type: utility_common/* USER_CLASSIFICATION.QWA_TOOLS */.Cf8.QWA_TOOLS,
                                label: "Error creating tools account with Google"
                            };
                            (0,analyticsMeta/* segmentEventApi */.Ey)("Error", payload3, "track");
                            setCreateGoogleAccountLoading(false);
                        }
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    15
                ]
            ]);
        }));
        return function handleToolsSignupWithGoogle() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleNext = function() {
        setActiveStep(function(prevActiveStep) {
            return prevActiveStep + 1;
        });
    };
    var handleBack = function() {
        setActiveStep(function(prevActiveStep) {
            return prevActiveStep - 1;
        });
    };
    (0,react.useEffect)(function() {
        var sessionUser = toolsUser ? JSON.parse(toolsUser) : null;
        if (sessionUser) {
            setEmail(sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.email);
            setFirstName(sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.firstName);
            setLastName(sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.lastName);
            setPlanId(sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.planId);
        }
    }, [
        toolsUser
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var manualLoginQuery = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.manualLogin;
        if (manualLoginQuery === "true") {
            setManualLogin(true);
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "verify-tools-user-wrapper",
        children: [
            showStepper ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperGetStarted, {
                activeStep: activeStep
            }) : null,
            showCodeInput ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "opt-verification-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "opt-verification-header",
                        children: "Complete verification to create account"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextField/* default */.Z, {
                        label: "Enter Code",
                        value: code,
                        placeholder: "000000",
                        // fullWidth
                        whiteBg: true,
                        error: error === null || error === void 0 ? void 0 : error.code,
                        isOtp: true,
                        errorMessage: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.code,
                        onChange: function(e) {
                            setCode(e.target.value);
                        },
                        isOnToolsVerify: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "reset-create-new-pass-btn",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                fullWidth: true,
                                variant: "contained",
                                disabled: showVerifyLoader,
                                className: "create-new-pass-btn",
                                onClick: verifyOtp,
                                children: [
                                    showVerifyLoader ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        version: "1.1",
                                        id: "loader",
                                        style: {
                                            fill: "#1D3557"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                id: "one",
                                                d: "M5,25H0V0h5V25z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                id: "two",
                                                d: "M15,25h-5V0h5V25z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                id: "three",
                                                d: "M25,25h-5V0h5V25z"
                                            })
                                        ]
                                    }) : null,
                                    showVerifyLoader ? "Please wait..." : "Complete Verification"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                fullWidth: true,
                                variant: "outlined",
                                disabled: showRequestLoader,
                                style: {
                                    borderRadius: "4.2px",
                                    border: "1px solid #1D3557"
                                },
                                color: "primary",
                                className: "resend-code-btn",
                                onClick: handleSubmitAndVerify,
                                children: [
                                    showRequestLoader ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        version: "1.1",
                                        id: "loader",
                                        style: {
                                            fill: "#1D3557"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                id: "one",
                                                d: "M5,25H0V0h5V25z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                id: "two",
                                                d: "M15,25h-5V0h5V25z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                id: "three",
                                                d: "M25,25h-5V0h5V25z"
                                            })
                                        ]
                                    }) : null,
                                    showRequestLoader ? "Please wait..." : "Resend Code"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: "m-15",
                                onClick: function() {
                                    setShowCodeInput(false);
                                    setCode("");
                                },
                                children: [
                                    "<< ",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            textDecorationLine: "underline"
                                        },
                                        children: "Update your email address"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : showCreatePassword ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pass-set-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "pass-set-heading",
                        children: "Set Your Password"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        className: "pass-set-desc",
                        children: [
                            "We are creating account for ",
                            email
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        textAlign: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "sign-up-with-google mt-30",
                                onClick: function() {
                                    handleToolsSignupWithGoogle();
                                    if (window.analytics) {
                                        window.analytics.track("Button Click", {
                                            label: "signup with Google"
                                        });
                                    } else {
                                        var payload = {
                                            email: email,
                                            name: "",
                                            schema: "",
                                            instance_type: utility_common/* USER_CLASSIFICATION.QWA_TOOLS */.Cf8.QWA_TOOLS,
                                            user_type: utility_common/* USER_CLASSIFICATION.QWA_TOOLS */.Cf8.QWA_TOOLS,
                                            label: "signup with Google"
                                        };
                                        (0,analyticsMeta/* segmentEventApi */.Ey)("Button Click", payload, "track");
                                    }
                                },
                                disabled: createGoogleAccountLoading,
                                children: createGoogleAccountLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                    size: 20
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            className: "google-svg",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "24",
                                            height: "25",
                                            viewBox: "0 0 24 25",
                                            fill: "none",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M23.04 12.6777C23.04 11.8623 22.9668 11.0782 22.8309 10.3254H12V14.7738H18.1891C17.9225 16.2113 17.1123 17.4293 15.8943 18.2448V21.1302H19.6109C21.7855 19.1282 23.04 16.18 23.04 12.6777Z",
                                                    fill: "#4285F4"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M11.9999 23.9162C15.1049 23.9162 17.7081 22.8864 19.6108 21.1301L15.8943 18.2446C14.8645 18.9346 13.5472 19.3423 11.9999 19.3423C9.00471 19.3423 6.46948 17.3194 5.56516 14.6012H1.72311V17.5807C3.61539 21.3392 7.50448 23.9162 11.9999 23.9162Z",
                                                    fill: "#34A853"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M5.56523 14.6015C5.33523 13.9115 5.20455 13.1745 5.20455 12.4165C5.20455 11.6585 5.33523 10.9215 5.56523 10.2315V7.25195H1.72318C0.944318 8.80445 0.5 10.5608 0.5 12.4165C0.5 14.2722 0.944318 16.0285 1.72318 17.581L5.56523 14.6015Z",
                                                    fill: "#FBBC05"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M11.9999 5.49025C13.6883 5.49025 15.2043 6.07047 16.3961 7.21002L19.6945 3.91161C17.7029 2.05593 15.0997 0.916382 11.9999 0.916382C7.50448 0.916382 3.61539 3.49343 1.72311 7.25184L5.56516 10.2314C6.46948 7.5132 9.00471 5.49025 11.9999 5.49025Z",
                                                    fill: "#EA4335"
                                                })
                                            ]
                                        }),
                                        " ",
                                        "Complete Sign up with Google"
                                    ]
                                })
                            }),
                            manualLogin ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "email-miss-match-msg",
                                align: "center",
                                children: "Error: Google email does not match payment email. Please select same email or create password manually."
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: "divider-section-container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        className: "divider-section-box"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: "divider-section-text",
                                        align: "center",
                                        children: "OR Choose a Password"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        className: "divider-section-box"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextField/* default */.Z, {
                        id: "password",
                        label: "Set a new password",
                        value: password,
                        type: "password",
                        whiteBg: true,
                        error: error === null || error === void 0 ? void 0 : error.password,
                        placeholder: "********",
                        errorMessage: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.password,
                        onChange: function(e) {
                            setPassword(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextField/* default */.Z, {
                        id: "password2",
                        label: "Re-enter your new password",
                        value: password2,
                        type: "password",
                        whiteBg: true,
                        error: error === null || error === void 0 ? void 0 : error.password2,
                        placeholder: "********",
                        errorMessage: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.password2,
                        onChange: function(e) {
                            setPassword2(e.target.value);
                        }
                    }),
                    passwordError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "error-text",
                        children: passwordError
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: "Password must contain"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Atleast 8 characters"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "One capital case letter, one small case letter"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "One numerical digit"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "One special character"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "complete-pmt-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "complete-pmt-btn",
                            disabled: createAccountLoading,
                            onClick: function() {
                                return handlePasswordSet();
                            },
                            children: createAccountLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                size: 20
                            }) : "Create Account"
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "create-account-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: " tools-verify-heading",
                        children: "Create Account Now"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        className: "mb-10 tools-verify-description",
                        children: [
                            "You have selected ",
                            planName,
                            " Plan \xa0",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "change-plan",
                                onClick: handleChangePlan,
                                children: "Change Plan"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "verify-tools-user-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                className: "mt-10 google-email-verify-btn",
                                onClick: handleVerifyWithEmail,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        className: "google-svg-icon",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "24",
                                        height: "25",
                                        viewBox: "0 0 24 25",
                                        fill: "none",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M23.04 12.6777C23.04 11.8623 22.9668 11.0782 22.8309 10.3254H12V14.7738H18.1891C17.9225 16.2113 17.1123 17.4293 15.8943 18.2448V21.1302H19.6109C21.7855 19.1282 23.04 16.18 23.04 12.6777Z",
                                                fill: "#4285F4"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M11.9999 23.9162C15.1049 23.9162 17.7081 22.8864 19.6108 21.1301L15.8943 18.2446C14.8645 18.9346 13.5472 19.3423 11.9999 19.3423C9.00471 19.3423 6.46948 17.3194 5.56516 14.6012H1.72311V17.5807C3.61539 21.3392 7.50448 23.9162 11.9999 23.9162Z",
                                                fill: "#34A853"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M5.56523 14.6015C5.33523 13.9115 5.20455 13.1745 5.20455 12.4165C5.20455 11.6585 5.33523 10.9215 5.56523 10.2315V7.25195H1.72318C0.944318 8.80445 0.5 10.5608 0.5 12.4165C0.5 14.2722 0.944318 16.0285 1.72318 17.581L5.56523 14.6015Z",
                                                fill: "#FBBC05"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M11.9999 5.49025C13.6883 5.49025 15.2043 6.07047 16.3961 7.21002L19.6945 3.91161C17.7029 2.05593 15.0997 0.916382 11.9999 0.916382C7.50448 0.916382 3.61539 3.49343 1.72311 7.25184L5.56516 10.2314C6.46948 7.5132 9.00471 5.49025 11.9999 5.49025Z",
                                                fill: "#EA4335"
                                            })
                                        ]
                                    }),
                                    " ",
                                    "\xa0 Create account with Google"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: "divider-container",
                                style: {
                                    maxWidth: "350px",
                                    margin: "21px auto"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                        className: "signup-divider",
                                        style: {
                                            height: "0.5px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "caption",
                                        children: "OR Create Account with Email"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                        className: "signup-divider",
                                        style: {
                                            height: "0.5px"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextField/* default */.Z, {
                                label: "Email address",
                                value: email,
                                type: "email",
                                whiteBg: true,
                                error: error === null || error === void 0 ? void 0 : error.email,
                                placeholder: "john.doe@quattr.com",
                                errorMessage: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.email,
                                onChange: function(e) {
                                    setEmail(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "name-container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextField/* default */.Z, {
                                        label: "First name",
                                        value: firstName,
                                        placeholder: "John",
                                        limitWidth: true,
                                        whiteBg: true,
                                        error: error === null || error === void 0 ? void 0 : error.firstName,
                                        errorMessage: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.firstName,
                                        onChange: function(e) {
                                            setFirstName(e.target.value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextField/* default */.Z, {
                                        label: "Last name",
                                        value: lastName,
                                        limitWidth: true,
                                        whiteBg: true,
                                        placeholder: "Doe",
                                        error: error === null || error === void 0 ? void 0 : error.lastName,
                                        errorMessage: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.lastName,
                                        onChange: function(e) {
                                            setLastName(e.target.value);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "checks-container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            checked: checked,
                                            onChange: function(event) {
                                                setCheckboxError("");
                                                setChecked(event.target.checked);
                                            },
                                            style: {
                                                color: checked ? "#51D497" : undefined,
                                                paddingTop: "0px",
                                                paddingBottom: "0px"
                                            },
                                            className: "".concat(checkboxError ? "error-text" : "")
                                        }),
                                        style: {
                                            alignItems: "center"
                                        },
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "secondaryText ".concat(checkboxError ? "error" : ""),
                                            style: {
                                                fontSize: "12px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    "I agree to Quattr’s",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        className: "".concat(checkboxError ? "error-text" : "text-green", " ", "link"),
                                                        href: "/content-ai/terms",
                                                        onClick: function(e) {
                                                            e.preventDefault();
                                                            if (window) {
                                                                window.parent.postMessage({
                                                                    action: "redirectURL",
                                                                    url: "/content-ai/terms"
                                                                }, "*");
                                                            } else {
                                                                router.push("/content-ai/terms");
                                                            }
                                                        },
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        style: {
                                                            fontSize: "12px"
                                                        },
                                                        children: [
                                                            " ",
                                                            "terms of service"
                                                        ]
                                                    }),
                                                    " ",
                                                    "&",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "".concat(checkboxError ? "error-text" : "text-green", " ", "link"),
                                                        href: "/privacy-policy",
                                                        onClick: function(e) {
                                                            e.preventDefault();
                                                            if (window) {
                                                                window.parent.postMessage({
                                                                    action: "redirectURL",
                                                                    url: "/privacy-policy"
                                                                }, "*");
                                                            } else {
                                                                router.push("/privacy-policy");
                                                            }
                                                        },
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        style: {
                                                            fontSize: "12px"
                                                        },
                                                        children: "privacy policy"
                                                    }),
                                                    "."
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            checked: receiveEmailsChecked,
                                            onChange: function(event) {
                                                setReceiveEmailsChecked(event.target.checked);
                                            },
                                            style: {
                                                color: receiveEmailsChecked ? "#51D497" : undefined,
                                                paddingTop: "0px",
                                                paddingBottom: "0px"
                                            }
                                        }),
                                        style: {
                                            alignItems: "center"
                                        },
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "secondaryText",
                                            style: {
                                                fontSize: "12px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: "I would like to receive marketing emails from Quattr."
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    fullWidth: true,
                                    variant: "contained",
                                    disabled: showRequestLoader,
                                    className: "verify-email-btn",
                                    onClick: handleSubmitAndVerify,
                                    children: [
                                        showRequestLoader ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            version: "1.1",
                                            id: "loader",
                                            style: {
                                                fill: "#1D3557"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "one",
                                                    d: "M5,25H0V0h5V25z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "two",
                                                    d: "M15,25h-5V0h5V25z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "three",
                                                    d: "M25,25h-5V0h5V25z"
                                                })
                                            ]
                                        }) : null,
                                        showRequestLoader ? "Please wait..." : "Verify Email with Code"
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_VerifyToolsUser = (VerifyToolsUser);

;// CONCATENATED MODULE: ./src/components/onboarding/ToolsOnboardingWrapper.tsx








var CONTINUE_USING_TEXT = "continue using Quattr";
var ToolsOnboardingWrapper = function(param) {
    var classes = param.classes, handleChangePlan = param.handleChangePlan;
    var qttr_tools_auth = js_cookie/* default.get */.Z.get("qttr_tools_auth");
    var use_locked_grace = js_cookie/* default.get */.Z.get("use_locked_grace");
    var ref = (0,react.useState)(false), showVerifyEmailPopup = ref[0], setShowVerifyEmailPopup = ref[1];
    var ref1 = (0,react.useState)({}), toolMeta = ref1[0], setToolMeta = ref1[1];
    var ref2 = (0,react.useState)(""), showSignUpPage = ref2[0], setShowSignUpPage = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), showBuyOnePass = ref3[0], setShowBuyOnePass = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), showBuyOnePassSuccess = ref4[0], setShowBuyOnePassSuccess = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), showSuccessEmailVerification = ref5[0], setShowSuccessEmailVerification = ref5[1];
    var isMobile = (0,uiHelpers/* useView */.Pl)("mobileOnly");
    var scrollToTop = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
        container: true,
        className: classes.root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.overallToolsWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.topHeadingsWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h1",
                            className: classes.topHeading,
                            children: "Quattr AI Tool Library"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h3",
                            className: classes.topSubHeading,
                            children: "The Go-to Resource for Fast, High Quality AI Content"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    className: classes.root,
                    style: {
                        height: "auto",
                        marginTop: isMobile ? "3vh" : "5vh"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            md: 6,
                            className: classes.sectionTwo,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "91",
                                    height: "95",
                                    viewBox: "0 0 91 95",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M19.0957 74.6656L24.4628 60.9711C8.80246 50.6488 2.12297 55.7295 1.38893 57.2349C-1.28043 62.7095 13.7346 71.4497 19.0957 74.6656Z",
                                            fill: "white",
                                            stroke: "#1D3557"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M56.4239 46.4347C44.5006 46.9933 32.8222 51.4933 24.9634 56.6747C18.1416 61.1723 16.1689 69.7368 19.9495 76.9806C25.148 86.9409 36.2249 98.4295 56.8377 92.6804C69.5711 89.1289 75.5464 79.8552 77.6222 70.3739C80.4506 57.4549 69.6344 45.8158 56.4239 46.4347Z",
                                            fill: "white",
                                            stroke: "#1D3557"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M71.8489 70.8069L76.5667 57.2969C91.6635 68.2764 90.5055 75.5247 89.4333 76.8113C85.5342 81.4903 75.8518 73.9521 71.8489 70.8069Z",
                                            fill: "white",
                                            stroke: "#1D3557"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M23.4501 12.0531C23.2856 11.507 23.1418 10.9987 23.0072 10.4932C22.7408 9.49259 23.9943 8.85214 24.645 9.65757C24.979 10.071 25.3105 10.496 25.6614 10.9633C26.0414 11.4693 25.8465 12.1938 25.2693 12.4531L24.8028 12.6626C24.2589 12.907 23.6221 12.6241 23.4501 12.0531Z",
                                            fill: "#1D3557"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                                            cx: "44.5346",
                                            cy: "60.7735",
                                            rx: "25.5186",
                                            ry: "8.58149",
                                            transform: "rotate(-15.0901 44.5346 60.7735)",
                                            fill: "#A5D7D9"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M32.7604 81.3651C33.5146 86.2988 35.2623 89.6883 36.4658 91.8217C42.2558 93.7517 53.6214 95.2529 66.0591 87.7473C65.0508 85.1898 64.245 82.9739 63.5026 80.7148C61.5893 74.8928 55.2019 71.7777 49.3134 73.4752C44.6641 74.8155 40.5421 75.5916 37.3729 75.9993C34.6341 76.3517 32.3432 78.6354 32.7604 81.3651Z",
                                            fill: "#51D597"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M45.6787 55.511C61.0208 50.0413 69.9633 35.2912 65.387 22.4553C60.8108 9.61944 44.554 3.85332 29.2118 9.32308C13.8697 14.7928 4.92727 29.5429 9.50349 42.3788C14.0797 55.2147 30.3365 60.9808 45.6787 55.511Z",
                                            fill: "#51D597",
                                            stroke: "#1D3557"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M14.3779 35.9233C14.3779 24.0642 24.6969 18.4781 29.3673 16.3561C34.0376 14.2341 46.3998 9.63506 55.0556 17.7217C59.0086 21.6849 64.6184 31.7898 52.3948 37.3937C50.3201 38.1365 47.2594 38.9927 44.3566 39.8764C41.0432 40.9832 34.3637 45.4106 30.5506 47.3871C18.1253 52.526 14.5752 41.5234 14.3779 35.9233Z",
                                            fill: "white",
                                            stroke: "#1D3557"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                            cx: "24.2423",
                                            cy: "36.2813",
                                            r: "6.29111",
                                            stroke: "#51D597",
                                            "stroke-width": "2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                            cx: "47.4024",
                                            cy: "25.9879",
                                            r: "6.29111",
                                            stroke: "#51D597",
                                            "stroke-width": "2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    variant: "h1",
                                    className: classes.sectionTwoMainHeading,
                                    children: [
                                        "Unlock Success with Quattr’s AI Tools",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* default */.Z, {
                                    className: classes.featureList,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                                            className: classes.featureItem,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                    className: classes.CheckCircleListItemIcon,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {
                                                        className: classes.featureIcon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body1",
                                                    className: classes.featureItemText,
                                                    children: "AI SEO Tools - Title Generator & more..."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                                            className: classes.featureItem,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                    className: classes.CheckCircleListItemIcon,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {
                                                        className: classes.featureIcon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body1",
                                                    className: classes.featureItemText,
                                                    children: "AI Writing Tools like Active-Passive Converter, Paragraph Generator & more..."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                                            className: classes.featureItem,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                    className: classes.CheckCircleListItemIcon,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {
                                                        className: classes.featureIcon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    variant: "body1",
                                                    className: classes.featureItemText,
                                                    children: [
                                                        "AI Optimization Tools - Heading Rewriter & more..",
                                                        " "
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.Z, {
                                            className: classes.featureItem,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                    className: classes.CheckCircleListItemIcon,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {
                                                        className: classes.featureIcon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    variant: "body1",
                                                    className: classes.featureItemText,
                                                    children: [
                                                        "3 Powerful Keyword Research Tools",
                                                        " "
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    variant: "body1",
                                    className: classes.brandsHeading,
                                    children: [
                                        "100K+ Users are Generating Content with Quattr AI Tools",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    className: classes.brandLogosContainer
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            md: 6,
                            className: classes.sectionOneForToolsWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_VerifyToolsUser, {
                                showStepper: false,
                                handleChangePlan: handleChangePlan
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var onboarding_ToolsOnboardingWrapper = (ToolsOnboardingWrapper);

;// CONCATENATED MODULE: ./src/components/onboarding/upgradeToolsPlan.tsx




var UpgradeToolsPlan = function(param) {
    var handlePlanSelection = param.handlePlanSelection, planPurchaseLoading = param.planPurchaseLoading, handleTermsOfUseClick = param.handleTermsOfUseClick;
    var CheckIconSvg = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "17",
            height: "18",
            viewBox: "0 0 17 18",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    "clip-path": "url(#clip0_2550_10440)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M11.7878 6.37267L7.33282 10.8277L5.21204 8.70692",
                            stroke: "#FFC72C",
                            strokeWidth: "1.5",
                            strokeMiterlimit: "10",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M16.3359 8.60016C16.3359 12.9278 12.8277 16.4361 8.5 16.4361C4.17234 16.4361 0.664062 12.9278 0.664062 8.60016C0.664062 4.2725 4.17234 0.764221 8.5 0.764221C12.8277 0.764221 16.3359 4.2725 16.3359 8.60016Z",
                            stroke: "#FFC72C",
                            strokeWidth: "1.5",
                            strokeMiterlimit: "10",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_2550_10440",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "17",
                            height: "17",
                            fill: "white",
                            transform: "translate(0 0.0999756)"
                        })
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "upgrade-plan-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "main-cards-container",
            children: common/* UPGRADE_PLANS_CONFIG.map */.Ib.map(function(item, index) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: "card ".concat(index == 1 ? "card recommended-card" : ""),
                    children: [
                        index == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "recommended-tag",
                            children: "RECOMMENDED"
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "type m-0",
                            children: item === null || item === void 0 ? void 0 : (ref = item.type) === null || ref === void 0 ? void 0 : ref.toUpperCase()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "amount",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "monthly m-0 discounted-amount",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "currency m-0",
                                        children: item === null || item === void 0 ? void 0 : item.currency
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "monthly-amount",
                                        children: item === null || item === void 0 ? void 0 : item.monthlyAmount
                                    }),
                                    "\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "mo",
                                        children: "USD"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "per",
                                        children: "/"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "mo",
                                        children: "mo"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "choose-plan-btn",
                            variant: "contained",
                            onClick: function() {
                                return handlePlanSelection(item === null || item === void 0 ? void 0 : item.type);
                            },
                            children: (planPurchaseLoading === null || planPurchaseLoading === void 0 ? void 0 : planPurchaseLoading[item === null || item === void 0 ? void 0 : item.type]) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                className: "",
                                size: 24
                            }) : "Start Now"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "description-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "section",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIconSvg, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: " m-0",
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: item === null || item === void 0 ? void 0 : item.creditsPerDay
                                                }),
                                                " Daily Credits"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "section",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIconSvg, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: " m-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "All"
                                                }),
                                                " ",
                                                item === null || item === void 0 ? void 0 : item.access
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "section",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIconSvg, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: " m-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: item === null || item === void 0 ? void 0 : item.validTill
                                                }),
                                                " reset to credit limit"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "section",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIconSvg, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: " m-0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: item === null || item === void 0 ? void 0 : item.noOfUser
                                                }),
                                                " User ",
                                                (item === null || item === void 0 ? void 0 : item.isAddMore) ? "(add more for $10 USD/user)" : null
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "usage-policy m-0",
                            children: [
                                "*Fair usage policy applies. Read",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "terms",
                                    onClick: function() {
                                        handleTermsOfUseClick();
                                        window.open("/content-ai/terms");
                                    },
                                    children: "terms of use"
                                }),
                                " ",
                                "for more."
                            ]
                        })
                    ]
                }, index);
            })
        })
    });
};
/* harmony default export */ var upgradeToolsPlan = (UpgradeToolsPlan);

;// CONCATENATED MODULE: ./src/components/onboarding/PricingSection.tsx







var PricingSection = function(param) {
    var classes = param.classes, handlePlanSelection = param.handlePlanSelection, planPurchaseLoading = param.planPurchaseLoading;
    var isMobile = (0,uiHelpers/* useView */.Pl)("mobileOnly");
    var router = (0,next_router.useRouter)();
    var handleExploreFreeTools = function() {
        router.push("/free-tools/title-generator");
        if (window.analytics) {
            window.analytics.track("Clicked Explore Free AI Tools", {
                option: "Explore Free AI Tools"
            });
        } else {
            (0,analyticsMeta/* segmentEventApi */.Ey)("Clicked Explore Free AI Tools", {
                option: "Explore Free AI Tools"
            }, "track");
        }
    };
    var handleTermsOfUseClick = function() {
        if (window.analytics) {
            window.analytics.track("Clicked Read Terms of Use", {
                option: "Read Terms of Use`"
            });
        } else {
            (0,analyticsMeta/* segmentEventApi */.Ey)("Clicked Read Terms of Use", {
                option: "Read Terms of Use`"
            }, "track");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
        container: true,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.overallToolsWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.topHeadingsWrapper,
                    children: [
                        !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "h1",
                            className: classes.topHeading,
                            children: [
                                "Unlock Success with Quick AI Tools",
                                " "
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h1",
                            className: classes.topHeading,
                            children: "Unlock Success with Quick AI Tools"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            className: classes.topSubHeadingForTools,
                            children: [
                                "The Go-to Resource for Fast, High Quality AI Content",
                                " "
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "upgrade-tools-plan-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(upgradeToolsPlan, {
                            planPurchaseLoading: planPurchaseLoading,
                            handlePlanSelection: handlePlanSelection,
                            handleTermsOfUseClick: handleTermsOfUseClick
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "explore-tools-section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: "explore-section-heading",
                                children: [
                                    "100K+ Users are Generating Content with Quick AI Tools",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "explore-section-heading-black",
                                children: "Explore What Quick AI Tools Can Do With Free Access"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: "explore-section-description",
                                children: [
                                    "Create your free account and start using our tools instantly. Use a corporate email to get 2X free credits every 8 hours. This waiting period ensures fair access for all users.",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: "explore-section-terms",
                                children: [
                                    "*Fair usage policy applies. Read",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "terms-of-use",
                                        onClick: function() {
                                            handleTermsOfUseClick();
                                            window.open("/content-ai/terms", "_blank");
                                        },
                                        children: "terms of use"
                                    }),
                                    " ",
                                    "for more.",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "explore-free-ai-tools-btn",
                                onClick: function() {
                                    return handleExploreFreeTools();
                                },
                                children: "Explore Free AI Tools"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var onboarding_PricingSection = (PricingSection);

// EXTERNAL MODULE: ./src/components/content-ai-tools/components/QuattrLogoSpinner.tsx
var QuattrLogoSpinner = __webpack_require__(53056);
// EXTERNAL MODULE: ./src/components/content-ai-tools/components/tools-common.ts
var tools_common = __webpack_require__(66727);
// EXTERNAL MODULE: ./src/components/content-ai-tools/components/QLoaderWithHeadingDescription.tsx
var QLoaderWithHeadingDescription = __webpack_require__(28925);
;// CONCATENATED MODULE: ./pages/get-started.tsx
/* eslint-disable @next/next/no-img-element */ 




































var useSignUpStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return {
        signUpWithGoogle: {
            borderRadius: "3.528px",
            background: "#2D3748",
            // width: '100%',
            padding: "0px 16px",
            color: "#FFF",
            height: "55px",
            textTransform: "inherit",
            fontFamily: "Roboto",
            fontSize: "19px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "normal",
            "&:hover": {
                backgroundColor: "#2D3748"
            },
            "&:disabled": {
                backgroundColor: "lightgray",
                color: "gray"
            }
        },
        signUpWithGoogleForTools: {
            width: "100%"
        },
        signUpSubHeading: {
            fontSize: "12px",
            fontWeight: 700
        },
        changeEmailAddress: {
            fontSize: "12",
            color: "#51D497",
            fontFamily: "Poppins",
            fontWeight: 400,
            textDecoration: "underline",
            cursor: "pointer"
        },
        alreadyExistHeading: {
            fontSize: "12px",
            fontWeight: 700,
            maxWidth: "282px",
            margin: "auto",
            marginTop: "20px"
        },
        svgStyle: {
            margin: "0px 8px"
        },
        gscWarning: {
            color: "#212121",
            textAlign: "left",
            fontFamily: "Poppins",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal"
        },
        gscText: {
            color: "#212121",
            fontFamily: "Poppins",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "normal"
        },
        // v2
        signUpCard: (_obj = {
            maxWidth: "382px",
            borderRadius: "10px",
            border: "2px solid #51D497",
            boxShadow: "none",
            padding: "40px 28px",
            textAlign: "center",
            margin: "auto",
            position: "relative"
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
            maxWidth: "100%",
            padding: "40px 15px"
        }), (0,_define_property/* default */.Z)(_obj, "&::before", (0,_define_property/* default */.Z)({
            content: '"NO CREDIT CARD NEEDED"',
            display: "block",
            position: "absolute",
            top: "-16px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "white",
            color: "#DB1A1A",
            border: "2px solid #DB1A1A",
            padding: "7px 14px",
            borderRadius: "20px",
            fontFamily: "Poppins",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "10px",
            textAlign: "center",
            width: "auto",
            maxWidth: "calc(100% - 40px)"
        }, theme.breakpoints.down("sm"), {
            display: "none"
        })), _obj),
        hideCreditCardMessage: {
            "&::before": {
                display: "none"
            }
        },
        emailInput: {
            marginBottom: theme.spacing(1)
        },
        signUpButton: {
            marginTop: theme.spacing(2),
            display: "flex",
            width: "100%",
            height: "39px",
            padding: "10.456px 16.265px",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "6.971px",
            // background: '#757575',
            textTransform: "capitalize",
            // color: '#DEDEDE',
            fontFamily: "Source Sans Pro",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "20.912px",
            background: "#51D497",
            color: "#1D3557",
            "&.MuiButton-containedPrimary:hover": {
                backgroundColor: "#51D497"
            }
        },
        dynamicWidthBtn: {
            maxWidth: "300px",
            margin: "17px auto"
        },
        outlined: {
            borderRadius: "10px",
            border: "2px solid #1D3557",
            background: "#F6F7F9",
            margin: "17px auto",
            maxWidth: "218px"
        },
        largeCTA: {
            height: "50px",
            color: "#1D3557",
            textAlign: "center",
            fontFamily: '"Source Sans Pro"',
            fontSize: "18.9px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "108%"
        },
        loginText: {
            color: "#1D3557",
            textAlign: "center",
            fontFamily: "Poppins",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "normal",
            marginTop: "9px"
        },
        loginLink: {
            color: "#51D497",
            fontFamily: "Poppins",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "normal",
            textDecoration: "none",
            marginTop: theme.spacing(2)
        },
        dividerContainer: {
            display: "flex",
            alignItems: "center",
            margin: "21px 0px",
            justifyContent: "center"
        },
        divider: {
            flexGrow: 1,
            background: "#757575"
        },
        dividerText: {
            margin: "0px 9px",
            color: "#757575",
            fontFamily: "Poppins",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal"
        },
        secondaryText: {
            color: "#757575",
            fontFamily: "Poppins",
            fontSize: "10px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal",
            textAlign: "left"
        },
        concentText: {
            color: "#757575",
            textAlign: "center",
            fontFamily: '"Source Sans Pro"',
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
            maxWidth: "424px",
            margin: "10px 7%"
        },
        termsCheckBox: {
            marginTop: "16px"
        },
        grayedOutContainer: {
            background: "#F6F7F9",
            padding: "31px 60px 30px 60px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        }
    };
});
var isValidDomain = function(domain) {
    var re = /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;
    return re.test(domain);
};
var isDomainMatch = function(email, enteredDomain) {
    // Extract the domain from the email
    var emailDomain = email.split("@")[1].toLowerCase();
    // Remove protocol (http:// or https://) and any paths from entered domain
    var normalizedEnteredDomain = enteredDomain.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split("/")[0].toLowerCase();
    // Check if the domains match
    return emailDomain === normalizedEnteredDomain;
};
var StepEnum = {
    SIGN_UP: "SIGN_UP",
    DETAILS: "DETAILS",
    CONFIRMATION: "CONFIRMATION",
    VERIFY_OTP: "VERIFY_OTP",
    CREATE_PASSWORD: "CREATE_PASSWORD",
    ACCOUNT_ALREADY_EXIST: "ACCOUNT_ALREADY_EXIST"
};
var OnboardingForm = function(param) {
    var parentClasses = param.parentClasses, headingText = param.headingText, postRedirects = param.postRedirects, setGoBack = param.setGoBack, setFullPageContentAiLoader = param.setFullPageContentAiLoader;
    var decodeHtmlEntities = function decodeHtmlEntities(text) {
        var textArea = document.createElement("textarea");
        textArea.innerHTML = text;
        return textArea.value;
    };
    var classes = useSignUpStyles();
    var questionStyles = (0,DescribeQuestion/* useQuestionsStyles */.b)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react.useState)(""), firstName = ref1[0], setFirstName = ref1[1];
    var ref2 = (0,react.useState)(""), lastName = ref2[0], setLastName = ref2[1];
    var ref3 = (0,react.useState)(""), code = ref3[0], setCode = ref3[1];
    var ref4 = (0,react.useState)(false), usedPersonalEmail = ref4[0], setUsedPersonalEmail = ref4[1];
    var ref5 = (0,react.useState)(false), usedCorpEmail = ref5[0], setUsedCorpEmail = ref5[1];
    var ref6 = (0,react.useState)(""), apiError = ref6[0], setApiError = ref6[1];
    var ref7 = (0,react.useState)("https://"), domain = ref7[0], setDomain = ref7[1];
    var user = (0,client/* useUser */.aF)().user;
    var ref8 = (0,react.useState)(false), loading = ref8[0], setLoading = ref8[1];
    var step_from_query = router.query.step || StepEnum.SIGN_UP;
    var reason_from_query = router.query.reason || "";
    var ref9 = (0,react.useState)(step_from_query), step = ref9[0], setStep = ref9[1];
    var ref10 = (0,react.useState)(false), isRequestApproved = ref10[0], setIsRequestApproved = ref10[1];
    var ref11 = (0,react.useState)(""), checkboxError = ref11[0], setCheckboxError = ref11[1];
    var ref12 = (0,react.useState)(false), checked = ref12[0], setChecked = ref12[1];
    var ref13 = (0,react.useState)(false), signUpWithGoogleLoader = ref13[0], setSignUpWithGoogleLoader = ref13[1];
    var ref14 = (0,react.useState)({}), error = ref14[0], setError = ref14[1];
    var ref15 = (0,react.useState)({}), errorMessage = ref15[0], setErrorMessage = ref15[1];
    var handleCheckboxChange = function(event) {
        setCheckboxError("");
        setChecked(event.target.checked);
    };
    (0,react.useEffect)(function() {
        if (reason_from_query) {
            var ref;
            var decodedString = decodeHtmlEntities(reason_from_query);
            var decodedUserInfo = JSON.parse(decodedString);
            if (decodedUserInfo && (decodedUserInfo === null || decodedUserInfo === void 0 ? void 0 : (ref = decodedUserInfo.user) === null || ref === void 0 ? void 0 : ref.email)) {
                setEmail(decodedUserInfo.user.email);
                setFirstName(decodedUserInfo.user.given_name);
                setLastName(decodedUserInfo.user.family_name);
                setUsedPersonalEmail(true);
                if (window.analytics) {
                    window.analytics.identify(decodedUserInfo.user.email, {
                        email: decodedUserInfo.user.email,
                        name: "".concat(decodedUserInfo.user.given_name, " ").concat(decodedUserInfo.user.family_name),
                        schema: "",
                        instance_type: "Content AI",
                        user_type: common/* CONTENT_AI_USER_TYPE */.Rq,
                        company_name: ""
                    });
                    window.analytics.track("Signup with Google initiated", {
                        emailType: "Personal",
                        email: decodedUserInfo.user.email,
                        name: "".concat(decodedUserInfo.user.given_name, " ").concat(decodedUserInfo.user.family_name)
                    });
                } else {
                    var payload = {
                        email: decodedUserInfo.user.email,
                        name: "".concat(decodedUserInfo.user.given_name, " ").concat(decodedUserInfo.user.family_name),
                        schema: "",
                        instance_type: "Content AI",
                        emailType: "Personal",
                        user_type: common/* CONTENT_AI_USER_TYPE */.Rq,
                        company_name: ""
                    };
                    (0,analyticsMeta/* segmentEventApi */.Ey)(null, payload, "identify");
                    (0,analyticsMeta/* segmentEventApi */.Ey)("Signup with Google initiated", payload, "track");
                }
            }
        }
    }, [
        reason_from_query
    ]);
    (0,react.useEffect)(function() {
        if (user && user.email && user.name && user.connection == "google-oauth2") {
            // tracking
            if (window.analytics) {
                window.analytics.identify(user.email, {
                    email: user.email,
                    name: user.name,
                    schema: "",
                    instance_type: "Content AI",
                    user_type: common/* CONTENT_AI_USER_TYPE */.Rq,
                    company_name: ""
                });
                window.analytics.track("Signup with Google initiated", {
                    emailType: "Corporate",
                    email: user.email,
                    name: user.name
                });
            } else {
                var payload = {
                    emailType: "Corporate",
                    email: user.email,
                    name: user.name,
                    schema: "",
                    instance_type: "Content AI",
                    user_type: common/* CONTENT_AI_USER_TYPE */.Rq,
                    company_name: ""
                };
                (0,analyticsMeta/* segmentEventApi */.Ey)(null, payload, "identify");
                (0,analyticsMeta/* segmentEventApi */.Ey)("Signup with Google initiated", payload, "track");
            }
            // setting states
            if ((user === null || user === void 0 ? void 0 : user.email) && (user === null || user === void 0 ? void 0 : user.given_name) && (user === null || user === void 0 ? void 0 : user.family_name)) {
                setEmail(user === null || user === void 0 ? void 0 : user.email);
                if (typeof (user === null || user === void 0 ? void 0 : user.given_name) == "string") {
                    setFirstName(user === null || user === void 0 ? void 0 : user.given_name);
                }
                if (typeof (user === null || user === void 0 ? void 0 : user.family_name) == "string") {
                    setLastName(user === null || user === void 0 ? void 0 : user.family_name);
                }
                setUsedCorpEmail(true);
            }
        }
    }, [
        user
    ]);
    (0,react.useEffect)(function() {
        if (step !== StepEnum.SIGN_UP) {
            setGoBack(false);
        }
    }, [
        step
    ]);
    (0,react.useEffect)(function() {
        console.log("ASDF", {
            step: step,
            user: user,
            email: email,
            reason_from_query: reason_from_query
        });
        if (step === StepEnum.DETAILS && (user || email || reason_from_query)) {
            var isGoogleCorpUser = user && user.email && user.name && user.connection == "google-oauth2";
            (0,analyticsMeta/* trackAnalyticsEvent */.ec)({
                eventName: "Viewed",
                payload: {
                    label: email && !reason_from_query && !isGoogleCorpUser ? "Enter domain - work email" : "Enter domain - google signup"
                }
            });
        }
    }, [
        step,
        user
    ]);
    (0,react.useEffect)(function() {
        var handleStorageEvent = function() {
            if (localStorage.getItem("signup-request-submitted") === "true") {
                setStep(StepEnum.CONFIRMATION);
            }
        };
        // Listen for storage events from other tabs
        window.addEventListener("storage", handleStorageEvent);
        // Cleanup function for the listener
        return function() {
            return window.removeEventListener("storage", handleStorageEvent);
        };
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        var isRequestSubmitted = sessionStorage.getItem("signup-request-submitted") || localStorage.getItem("signup-request-submitted");
        var decodedString = reason_from_query ? decodeHtmlEntities(reason_from_query) : "{}";
        var decodedUserInfo = JSON.parse(decodedString);
        if (isRequestSubmitted && decodedUserInfo && (decodedUserInfo === null || decodedUserInfo === void 0 ? void 0 : (ref = decodedUserInfo.user) === null || ref === void 0 ? void 0 : ref.email)) {
            setLoading(true);
            axios/* default.post */.Z.post("/api/join-content-ai/user-check", (0,_object_spread/* default */.Z)({}, decodedUserInfo), {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function(res) {
                var response = res.data;
                if (response && response.success) {
                    setIsRequestApproved(true);
                } else {
                    // logout user if request is already submitted
                    // this is specifically when user tries to do signup with google after submitting request and before his request is approved
                    window.location.href = "https://auth.quattr.com/v2/logout?client_id=".concat("EG9H83MUzcmpkBE30xNxngbEZMgo30fJ", "&returnTo=").concat(encodeURIComponent("".concat("https://www.quattr.com", "/get-started?tab=start-free-trial&&step=").concat(StepEnum.CONFIRMATION)));
                }
            }).finally(function() {
                setLoading(false);
            });
        } else if (isRequestSubmitted) {
            setStep(StepEnum.CONFIRMATION);
        }
    }, []);
    var handleSignUpNoWClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var step, newError, newErrorMessage, allValid, payload, plan_id, isInternalUser, payload1, payload2, payload3, payload4, payload5, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        step = _args.length > 0 && _args[0] !== void 0 ? _args[0] : StepEnum.SIGN_UP;
                        newError = (0,_object_spread/* default */.Z)({}, error);
                        newErrorMessage = (0,_object_spread/* default */.Z)({}, errorMessage);
                        allValid = true; // Flag to track if all validations pass
                        if (!(step === StepEnum.SIGN_UP)) {
                            _ctx.next = 26;
                            break;
                        }
                        setLoading(true);
                        if (email) {
                            _ctx.next = 10;
                            break;
                        }
                        {
                            newErrorMessage.email = "* Required";
                            newError.email = true;
                            allValid = false;
                        }
                        _ctx.next = 23;
                        break;
                    case 10:
                        if (email === null || email === void 0 ? void 0 : email.includes("@")) {
                            _ctx.next = 14;
                            break;
                        }
                        {
                            newErrorMessage.email = "Invalid Work Email";
                            newError.email = true;
                            allValid = false;
                        }
                        _ctx.next = 23;
                        break;
                    case 14:
                        newErrorMessage.email = "";
                        newError.email = false;
                        if (!allValid) {
                            _ctx.next = 23;
                            break;
                        }
                        if (window.analytics) {
                            window.analytics.identify(email, {
                                email: email,
                                name: "",
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq,
                                company_name: ""
                            });
                            window.analytics.track("ButtonClick - Verify Email", {
                                email: email,
                                name: ""
                            });
                        } else {
                            payload = {
                                email: email,
                                name: "",
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq,
                                company_name: ""
                            };
                            (0,analyticsMeta/* segmentEventApi */.Ey)(null, payload, "identify");
                            (0,analyticsMeta/* segmentEventApi */.Ey)("ButtonClick - Verify Email", payload, "track");
                        }
                        _ctx.next = 20;
                        return axios/* default.post */.Z.post("/api/join-content-ai/request-otp", {
                            email: email,
                            fullName: "".concat(firstName, " ").concat(lastName),
                            module: "CONTENT-AI-SETUP"
                        }, {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        });
                    case 20:
                        setCode("");
                        setStep(StepEnum.VERIFY_OTP); // Move to next step only if email is valid
                        (0,analyticsMeta/* trackAnalyticsEvent */.ec)({
                            eventName: "Viewed - Verify Otp Screen",
                            payload: {
                                label: "Viewed - Verify Otp Screen"
                            }
                        });
                    case 23:
                        setLoading(false);
                        _ctx.next = 76;
                        break;
                    case 26:
                        if (!(step === StepEnum.DETAILS)) {
                            _ctx.next = 76;
                            break;
                        }
                        if (!firstName) {
                            newErrorMessage.firstName = "* Required";
                            newError.firstName = true;
                        } else {
                            newErrorMessage.firstName = "";
                            newError.firstName = false;
                        }
                        if (!lastName) {
                            newErrorMessage.lastName = "* Required";
                            newError.lastName = true;
                        } else {
                            newErrorMessage.lastName = "";
                            newError.lastName = false;
                        }
                        if (!domain) {
                            newErrorMessage.domain = "* Required";
                            newError.domain = true;
                        } else if (!isValidDomain(domain)) {
                            newErrorMessage.domain = "Invalid Domain";
                            newError.domain = true;
                        } else {
                            newErrorMessage.domain = "";
                            newError.domain = false;
                        }
                        if (!checked) {
                            setCheckboxError(" Please indicate that you have read and agree to the Terms of Use and Privacy Policy!");
                        }
                        allValid = allValid && !newError.firstName && !newError.lastName && !newError.domain && checked;
                        if (!allValid) {
                            _ctx.next = 76;
                            break;
                        }
                        _ctx.prev = 33;
                        setLoading(true);
                        plan_id = sessionStorage.getItem("qttr-plan-selected");
                        isInternalUser = [
                            "mahesh.auti.ext@quattr.com",
                            "sanjoli.arora@quattr.com"
                        ].includes(email);
                        if (!usedCorpEmail) {
                            _ctx.next = 51;
                            break;
                        }
                        if (!(!isDomainMatch(email, domain) && !isInternalUser)) {
                            _ctx.next = 45;
                            break;
                        }
                        if (window.analytics) {
                            window.analytics.track("Forced Manual Request due to Domain Mismatch", {
                                email: email,
                                name: "",
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq
                            });
                        } else {
                            payload1 = {
                                email: email,
                                name: "",
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq
                            };
                            (0,analyticsMeta/* segmentEventApi */.Ey)("Forced Manual Request due to Domain Mismatch", payload1, "track");
                        }
                        _ctx.next = 42;
                        return axios/* default.post */.Z.post("/api/join-content-ai/force-manual-request", {
                            domain: domain,
                            plan_id: plan_id
                        }, {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        });
                    case 42:
                        localStorage.setItem("signup-request-submitted", "true");
                        window.location.href = "https://auth.quattr.com/v2/logout?client_id=".concat("EG9H83MUzcmpkBE30xNxngbEZMgo30fJ", "&returnTo=").concat(encodeURIComponent("".concat("https://www.quattr.com", "/get-started?tab=start-free-trial&&step=").concat(StepEnum.CONFIRMATION)));
                        return _ctx.abrupt("return");
                    case 45:
                        // domain matches
                        if (window.analytics) {
                            window.analytics.track("Auto Submitted Request", {
                                email: email,
                                name: "",
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq
                            });
                        } else {
                            payload2 = {
                                email: email,
                                name: "",
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq
                            };
                            (0,analyticsMeta/* segmentEventApi */.Ey)("Auto Submitted Request", payload2, "track");
                        }
                        _ctx.next = 48;
                        return axios/* default.post */.Z.post("/api/join-content-ai/setup-user", {
                            domain: domain,
                            plan_id: plan_id
                        }, {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        });
                    case 48:
                        (0,analyticsMeta/* setUserAttribute */.gT)("signup_route", "Request auto submit");
                        window.location.href = "/user-auth";
                        return _ctx.abrupt("return");
                    case 51:
                        if (!((0,validation_email/* isCorporateAndValidEmail */.U)(email) && isDomainMatch(email, domain))) {
                            _ctx.next = 59;
                            break;
                        }
                        if (window.analytics) {
                            window.analytics.track("shown verify Email screen", {
                                email: email,
                                name: "",
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq
                            });
                        } else {
                            payload3 = {
                                email: email,
                                name: "",
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq
                            };
                            (0,analyticsMeta/* segmentEventApi */.Ey)("shown verify Email screen", payload3, "track");
                        }
                        _ctx.next = 55;
                        return axios/* default.post */.Z.post("/api/join-content-ai/request-otp", {
                            email: email,
                            fullName: "".concat(firstName, " ").concat(lastName),
                            module: "CONTENT-AI-SETUP"
                        }, {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        });
                    case 55:
                        setStep(StepEnum.VERIFY_OTP);
                        setLoading(false);
                        _ctx.next = 65;
                        break;
                    case 59:
                        if (window.analytics) {
                            window.analytics.track("Submitted Manual Request", {
                                email: email,
                                name: "",
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq
                            });
                        } else {
                            payload4 = {
                                email: email,
                                name: "",
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq
                            };
                            (0,analyticsMeta/* segmentEventApi */.Ey)("Submitted Manual Request", payload4, "track");
                        }
                        localStorage.setItem("signup-request-submitted", "true");
                        _ctx.next = 63;
                        return axios/* default.post */.Z.post("/api/join-content-ai", {
                            firstName: firstName,
                            lastName: lastName,
                            email: email,
                            domain: domain,
                            page_source: "get-started"
                        }, {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        });
                    case 63:
                        (0,analyticsMeta/* setUserAttribute */.gT)("signup_route", "Manual Submission");
                        window.location.href = "https://auth.quattr.com/v2/logout?client_id=".concat("EG9H83MUzcmpkBE30xNxngbEZMgo30fJ", "&returnTo=").concat(encodeURIComponent("".concat("https://www.quattr.com", "/get-started?tab=start-free-trial&&step=").concat(StepEnum.CONFIRMATION)));
                    case 65:
                        (0,analyticsMeta/* setUserAttribute */.gT)("domain", domain);
                        _ctx.next = 74;
                        break;
                    case 68:
                        _ctx.prev = 68;
                        _ctx.t0 = _ctx["catch"](33);
                        console.error("Error While Creating User :", (0,lodash.get)(_ctx.t0, "response.data.errorMsg") || (0,lodash.get)(_ctx.t0, "response.data.data") || _ctx.t0);
                        setApiError((0,lodash.get)(_ctx.t0, "response.data.errorMsg") || (0,lodash.get)(_ctx.t0, "response.data.data") || "Oops Something Went Wrong. Please Try again!");
                        setLoading(false);
                        if (window.analytics) {
                            window.analytics.track("Encountered An error while setup", {
                                email: email,
                                name: "",
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq,
                                error: (0,lodash.get)(_ctx.t0, "response.data.errorMsg") || (0,lodash.get)(_ctx.t0, "response.data.data") || "Oops Something Went Wrong. Please Try again!"
                            });
                        } else {
                            payload5 = {
                                email: email,
                                name: "",
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq
                            };
                            (0,analyticsMeta/* segmentEventApi */.Ey)("Encountered An error while setup", payload5, "track");
                        }
                    case 74:
                        _ctx.prev = 74;
                        return _ctx.finish(74);
                    case 76:
                        setErrorMessage(newErrorMessage);
                        setError(newError);
                    case 78:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    33,
                    68,
                    74,
                    76
                ]
            ]);
        }));
        return function handleSignUpNoWClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAutoLogin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(password) {
            var state, auth0Obj, payload, result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        state = (0,v4/* default */.Z)(); // Generates a new, unique state for each session
                        sessionStorage.setItem("auth_state", state); // Store state in sessionStorage for later validation
                        auth0Obj = new auth0_min_esm/* default.WebAuth */.ZP.WebAuth({
                            domain: "https://auth.quattr.com",
                            clientID: "EG9H83MUzcmpkBE30xNxngbEZMgo30fJ",
                            connection: "qwa-users-prod-db",
                            scope: "openid profile email",
                            audience: "https://quattr.com/api/",
                            responseType: "code",
                            redirectUri: "".concat("https://www.quattr.com", "/user-auth"),
                            state: state
                        });
                        payload = {
                            email: email
                        };
                        _ctx.next = 7;
                        return auth0Obj.login({
                            email: payload.email,
                            realm: "qwa-users-prod-db",
                            password: password,
                            onRedirecting: function(doAuth) {
                                doAuth();
                            }
                        });
                    case 7:
                        result = _ctx.sent;
                        if (window.analytics) {
                            window.analytics.identify("".concat(payload === null || payload === void 0 ? void 0 : payload.email), {
                                email: payload === null || payload === void 0 ? void 0 : payload.email
                            });
                            window.analytics.track("Auto Login Success", {
                                option: "Auto Login Success",
                                email: payload === null || payload === void 0 ? void 0 : payload.email,
                                isQwaDashboard: true
                            });
                        } else {
                            (0,analyticsMeta/* segmentEventApi */.Ey)("Auto Login Success", {
                                option: "Auto Login Success",
                                email: payload === null || payload === void 0 ? void 0 : payload.email,
                                isQwaDashboard: true
                            }, "track");
                        }
                        _ctx.next = 16;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error("Error", _ctx.t0);
                        if (window.analytics) {
                            window.analytics.track("Unable to Auto Login", {
                                option: "Auto Login Error",
                                email: email,
                                isQwaDashboard: false
                            });
                        } else {
                            (0,analyticsMeta/* segmentEventApi */.Ey)("Unable to Auto Login", {
                                option: "Auto Login Error",
                                email: email,
                                isQwaDashboard: false
                            }, "track");
                        }
                        router.push("/login");
                    case 16:
                        _ctx.prev = 16;
                        setLoading(false);
                        return _ctx.finish(16);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11,
                    16,
                    19
                ]
            ]);
        }));
        return function handleAutoLogin(password) {
            return _ref.apply(this, arguments);
        };
    }();
    var sendSlackMessageIfFails = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(error, email) {
            var isPlainObject, fields, payload, payload1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        isPlainObject = function(obj) {
                            return Object.prototype.toString.call(obj) === "[object Object]";
                        };
                        fields = [
                            {
                                title: "Error Message",
                                value: error.message || "Unknown error",
                                short: false
                            },
                            {
                                title: "Stack Trace",
                                value: "```".concat(error.stack || "No stack trace available", "```"),
                                short: false
                            },
                            {
                                title: "User Email",
                                value: email || "No email provided",
                                short: false
                            }, 
                        ];
                        if (error.response) {
                            fields.push({
                                title: "Response Status",
                                value: "".concat(error.response.status),
                                short: true
                            });
                            if (isPlainObject(error.response.data)) {
                                fields.push({
                                    title: "Response Data",
                                    value: "```".concat(JSON.stringify(error.response.data, null, 2), "```"),
                                    short: false
                                });
                            } else if (typeof error.response.data === "string" && !error.response.data.startsWith("<")) {
                                fields.push({
                                    title: "Response Data",
                                    value: "```".concat(error.response.data, "```"),
                                    short: false
                                });
                            }
                        } else if (error.request) {
                            fields.push({
                                title: "Request",
                                value: "```".concat(JSON.stringify(error.request, null, 2), "```"),
                                short: false
                            });
                        }
                        payload = {
                            text: "Error While Content Ai Onboarding",
                            attachments: [
                                {
                                    color: "danger",
                                    fields: fields
                                }, 
                            ]
                        };
                        _ctx.next = 7;
                        return axios/* default.post */.Z.post("/api/post_slack_message", {
                            payload: payload
                        });
                    case 7:
                        _ctx.next = 15;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        payload1 = {
                            text: "Error sending slack message on get all daypass link fail",
                            attachments: [
                                {
                                    color: "danger",
                                    fields: [
                                        {
                                            title: "Error Message",
                                            value: _ctx.t0.message || "Unknown error",
                                            short: false
                                        }, 
                                    ]
                                }, 
                            ]
                        };
                        console.error("Error :: sending slack message on Content Ai Onboarding fail :: ".concat(_ctx.t0));
                        _ctx.next = 15;
                        return axios/* default.post */.Z.post("/api/post_slack_message", {
                            payload: payload1
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        }));
        return function sendSlackMessageIfFails(error, email) {
            return _ref.apply(this, arguments);
        };
    }();
    var setupContentAiAccount = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(password) {
            var ref, ref1, ref2, ref3, payload, res, payload1, payload2, payload3, payload4, payload5;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setLoading(true);
                        if (!(email && password && domain && firstName && lastName)) {
                            _ctx.next = 21;
                            break;
                        }
                        ;
                        if (window.analytics) {
                            window.analytics.track("ButtonClick - Create Account After Password Set", {
                                email: email,
                                firstName: firstName,
                                lastName: lastName,
                                name: "".concat(firstName, " ").concat(lastName),
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq
                            });
                        } else {
                            payload = {
                                email: email,
                                firstName: firstName,
                                lastName: lastName,
                                name: "".concat(firstName, " ").concat(lastName),
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq
                            };
                            (0,analyticsMeta/* segmentEventApi */.Ey)("ButtonClick - Create Account After Password Set", payload, "track");
                        }
                        _ctx.next = 7;
                        return axios/* default.post */.Z.post("/api/join-content-ai/setup-content-ai-user", {
                            email: email,
                            password: password,
                            firstName: firstName,
                            lastName: lastName
                        }, {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        });
                    case 7:
                        res = _ctx.sent;
                        if (!((res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.data) === "The user already exists.")) {
                            _ctx.next = 12;
                            break;
                        }
                        {
                            if (window.analytics) {
                                window.analytics.track("The User Already Exists.", {
                                    email: email,
                                    firstName: firstName,
                                    lastName: lastName,
                                    name: "".concat(firstName, " ").concat(lastName),
                                    schema: "",
                                    instance_type: "Content AI",
                                    user_type: common/* CONTENT_AI_USER_TYPE */.Rq,
                                    isQwaDashboard: false
                                });
                            } else {
                                payload1 = {
                                    email: email,
                                    firstName: firstName,
                                    lastName: lastName,
                                    name: "".concat(firstName, " ").concat(lastName),
                                    schema: "",
                                    instance_type: "Content AI",
                                    user_type: common/* CONTENT_AI_USER_TYPE */.Rq,
                                    isQwaDashboard: false
                                };
                                (0,analyticsMeta/* segmentEventApi */.Ey)("The User Already Exists.", payload1, "track");
                            }
                            setStep(StepEnum.ACCOUNT_ALREADY_EXIST);
                        }
                        _ctx.next = 21;
                        break;
                    case 12:
                        if (!(res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.created_at)) {
                            _ctx.next = 20;
                            break;
                        }
                        if (window.analytics) {
                            window.analytics.track("Account Created Successfully", {
                                email: email,
                                firstName: firstName,
                                lastName: lastName,
                                name: "".concat(firstName, " ").concat(lastName),
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq,
                                isQwaDashboard: false
                            });
                        } else {
                            payload2 = {
                                email: email,
                                firstName: firstName,
                                lastName: lastName,
                                name: "".concat(firstName, " ").concat(lastName),
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq,
                                isQwaDashboard: false
                            };
                            (0,analyticsMeta/* segmentEventApi */.Ey)("Account created successfully", payload2, "track");
                        }
                        (0,analyticsMeta/* setUserAttribute */.gT)("signup_route", "Corporate email verification");
                        setFullPageContentAiLoader(true);
                        _ctx.next = 18;
                        return handleAutoLogin(password);
                    case 18:
                        _ctx.next = 21;
                        break;
                    case 20:
                        if ((res === null || res === void 0 ? void 0 : (ref3 = res.data) === null || ref3 === void 0 ? void 0 : ref3.data) === "User metadata updated successfully") {
                            if (window.analytics) {
                                window.analytics.track("User metadata updated successfully", {
                                    email: email,
                                    firstName: firstName,
                                    lastName: lastName,
                                    name: "".concat(firstName, " ").concat(lastName),
                                    schema: "",
                                    instance_type: "Content AI",
                                    user_type: common/* CONTENT_AI_USER_TYPE */.Rq,
                                    reason: "tools user trying content ai signup",
                                    isQwaDashboard: false
                                });
                            } else {
                                payload3 = {
                                    email: email,
                                    firstName: firstName,
                                    lastName: lastName,
                                    name: "".concat(firstName, " ").concat(lastName),
                                    schema: "",
                                    instance_type: "Content AI",
                                    user_type: common/* CONTENT_AI_USER_TYPE */.Rq,
                                    reason: "tools user trying content ai signup",
                                    isQwaDashboard: false
                                };
                                (0,analyticsMeta/* segmentEventApi */.Ey)("User metadata updated successfully", payload3, "track");
                            }
                            setStep(StepEnum.ACCOUNT_ALREADY_EXIST);
                        } else {
                            if (window.analytics) {
                                window.analytics.track("Unable to Create Content Ai Account", {
                                    email: email,
                                    firstName: firstName,
                                    lastName: lastName,
                                    name: "".concat(firstName, " ").concat(lastName),
                                    schema: "",
                                    instance_type: "Content AI",
                                    user_type: common/* CONTENT_AI_USER_TYPE */.Rq,
                                    reason: "Something Went Wrong, While Creating Content Ai Account"
                                });
                            } else {
                                payload4 = {
                                    email: email,
                                    firstName: firstName,
                                    lastName: lastName,
                                    name: "".concat(firstName, " ").concat(lastName),
                                    schema: "",
                                    instance_type: "Content AI",
                                    user_type: common/* CONTENT_AI_USER_TYPE */.Rq,
                                    reason: "Something Went Wrong, While Creating Content Ai Account"
                                };
                                (0,analyticsMeta/* segmentEventApi */.Ey)("Unable to Create Content Ai Account", payload4, "track");
                            }
                            setApiError("Oops Something Went Wrong. Please Try again!");
                        }
                    case 21:
                        _ctx.next = 31;
                        break;
                    case 23:
                        _ctx.prev = 23;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error("Error While Creating User :", (0,lodash.get)(_ctx.t0, "response.data.errorMsg") || (0,lodash.get)(_ctx.t0, "response.data.data") || _ctx.t0);
                        setApiError((0,lodash.get)(_ctx.t0, "response.data.errorMsg") || (0,lodash.get)(_ctx.t0, "response.data.data") || "Oops Something Went Wrong. Please Try again!");
                        setLoading(false);
                        sendSlackMessageIfFails(_ctx.t0, email);
                        if (window.analytics) {
                            window.analytics.track("Encountered An error while setup", {
                                email: email,
                                name: "",
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq,
                                error: (0,lodash.get)(_ctx.t0, "response.data.errorMsg") || (0,lodash.get)(_ctx.t0, "response.data.data") || "Oops Something Went Wrong. Please Try again!"
                            });
                        } else {
                            payload5 = {
                                email: email,
                                name: "",
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq
                            };
                            (0,analyticsMeta/* segmentEventApi */.Ey)("Encountered An error while setup", payload5, "track");
                        }
                        setFullPageContentAiLoader(false);
                    case 31:
                        _ctx.prev = 31;
                        setLoading(false);
                        return _ctx.finish(31);
                    case 34:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    23,
                    31,
                    34
                ]
            ]);
        }));
        return function setupContentAiAccount(password) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleResendCode = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        (0,analyticsMeta/* trackAnalyticsEvent */.ec)({
                            eventName: "clicked on resend OTP",
                            payload: {
                                label: "clicked on resend OTP"
                            }
                        });
                        setLoading(true);
                        _ctx.next = 5;
                        return axios/* default.post */.Z.post("/api/join-content-ai/request-otp", {
                            email: email,
                            fullName: "".concat(firstName, " ").concat(lastName),
                            module: "CONTENT-AI-SETUP"
                        }, {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        });
                    case 5:
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log("error ", _ctx.t0);
                    case 10:
                        _ctx.prev = 10;
                        setLoading(false);
                        return _ctx.finish(10);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7,
                    10,
                    13
                ]
            ]);
        }));
        return function handleResendCode() {
            return _ref.apply(this, arguments);
        };
    }();
    var verifyOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var newError, newErrorMessage, ref, res, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        newError = (0,_object_spread/* default */.Z)({}, error);
                        newErrorMessage = (0,_object_spread/* default */.Z)({}, errorMessage);
                        (0,analyticsMeta/* trackAnalyticsEvent */.ec)({
                            eventName: "Clicked - Verify OTP",
                            payload: {
                                label: "Clicked - Verify OTP"
                            }
                        });
                        _ctx.prev = 3;
                        ;
                        if (!code) {
                            newErrorMessage.code = "* Required";
                            newError.code = true;
                        } else {
                            newErrorMessage.code = "";
                            newError.code = false;
                            (0,analyticsMeta/* trackAnalyticsEvent */.ec)({
                                eventName: "Entered Code",
                                eventFor: "customButton",
                                payload: {
                                    label: "Entered Code"
                                }
                            });
                        }
                        setLoading(true);
                        _ctx.next = 9;
                        return axios/* default.post */.Z.post("/api/join-content-ai/verify-otp", {
                            email: email,
                            otp: code,
                            fullName: "".concat(firstName, " ").concat(lastName),
                            firstName: firstName,
                            lastName: lastName
                        }, {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        });
                    case 9:
                        res = _ctx.sent;
                        (0,analyticsMeta/* trackAnalyticsEvent */.ec)({
                            eventName: "Verified Email with OTP",
                            payload: {
                                label: "Verified Email with OTP"
                            }
                        });
                        if ((res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.success) === true) {
                            ;
                            if ((res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.isExistingUser) === true) {
                                setStep(StepEnum.ACCOUNT_ALREADY_EXIST);
                                (0,analyticsMeta/* trackAnalyticsEvent */.ec)({
                                    eventName: "User Already Exist",
                                    payload: {
                                        label: "User Already Exist"
                                    }
                                });
                            } else {
                                (0,analyticsMeta/* setUserAttribute */.gT)("last_verified_at", new Date().toISOString());
                                setStep(StepEnum.CREATE_PASSWORD);
                                (0,analyticsMeta/* trackAnalyticsEvent */.ec)({
                                    eventName: "Viewed - Set Password Screen",
                                    payload: {
                                        label: "Viewed - Set Password Screen"
                                    }
                                });
                            }
                        }
                        _ctx.next = 20;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](3);
                        console.error("error : verifyOtp", _ctx.t0);
                        newErrorMessage.code = "Invalid OTP";
                        newError.code = true;
                        (0,analyticsMeta/* trackAnalyticsEvent */.ec)({
                            eventName: "Entered Invalid OTP",
                            payload: {
                                label: "Entered Invalid OTP"
                            }
                        });
                    case 20:
                        _ctx.prev = 20;
                        setLoading(false);
                        return _ctx.finish(20);
                    case 23:
                        setErrorMessage(newErrorMessage);
                        setError(newError);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    14,
                    20,
                    23
                ]
            ]);
        }));
        return function verifyOtp() {
            return _ref.apply(this, arguments);
        };
    }();
    var ResetPassword = function() {
        var ref = (0,react.useState)(""), password = ref[0], setPassword = ref[1];
        var ref1 = (0,react.useState)(""), reEnteredPassword = ref1[0], setReEnteredPassword = ref1[1];
        var ref2 = (0,react.useState)({}), error = ref2[0], setError = ref2[1];
        var ref3 = (0,react.useState)({}), errorMessage = ref3[0], setErrorMessage = ref3[1];
        var validatePassword = function(password) {
            var hasUpperCase = /[A-Z]/.test(password);
            var hasLowerCase = /[a-z]/.test(password);
            var hasNumbers = /\d/.test(password);
            var hasNonalphas = /\W/.test(password);
            var isValidLength = password.length >= 8;
            return hasUpperCase && hasLowerCase && hasNumbers && hasNonalphas && isValidLength;
        };
        var passwordsMatch = function(password, reEnteredPassword) {
            // Check if reEnteredPassword exists and if it matches the current password
            var passwordMatch = reEnteredPassword && password ? password === reEnteredPassword : false;
            return passwordMatch;
        };
        var handlePasswordChange = function(e) {
            var newPassword = e.target.value;
            setPassword(newPassword);
            if (!validatePassword(newPassword)) {
                setError((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, error), {
                    password: true
                }));
                setErrorMessage((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, errorMessage), {
                    password: "Password must be at least 8 characters long, include uppercase and lowercase letters, numbers, and special characters."
                }));
            } else {
                setError((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, error), {
                    password: false
                }));
                setErrorMessage((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, errorMessage), {
                    password: ""
                }));
            }
        };
        (0,react.useEffect)(function() {
            if (password && reEnteredPassword && !passwordsMatch(password, reEnteredPassword)) {
                setError((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, error), {
                    reEnteredPassword: true
                }));
                setErrorMessage((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, errorMessage), {
                    reEnteredPassword: "Passwords do not match."
                }));
            } else {
                setError((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, error), {
                    reEnteredPassword: false
                }));
                setErrorMessage((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, errorMessage), {
                    reEnteredPassword: ""
                }));
            }
        }, [
            password,
            reEnteredPassword
        ]);
        var handleReEnteredPasswordChange = function(e) {
            var newReEnteredPassword = e.target.value;
            setReEnteredPassword(newReEnteredPassword);
            if (!password) {
                setError((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, error), {
                    reEnteredPassword: true
                }));
                setErrorMessage((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, errorMessage), {
                    reEnteredPassword: "Passwords do not match."
                }));
            }
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
            className: "".concat(classes.signUpCard, " ").concat(classes.hideCreditCardMessage),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h5",
                    component: "h2",
                    className: parentClasses.heading,
                    children: "Set your password"
                }),
                email ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            className: classes.signUpSubHeading,
                            children: [
                                "We are creating account for ",
                                email
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: classes.changeEmailAddress,
                            onClick: function() {
                                return setStep(StepEnum.SIGN_UP);
                            },
                            children: "Change Email Address"
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextField/* default */.Z, {
                    label: "Set a new password",
                    value: password,
                    type: "password",
                    error: error === null || error === void 0 ? void 0 : error.password,
                    errorMessage: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.password,
                    onChange: handlePasswordChange
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextField/* default */.Z, {
                    label: "Re-enter new password",
                    value: reEnteredPassword,
                    type: "password",
                    error: error === null || error === void 0 ? void 0 : error.reEnteredPassword,
                    errorMessage: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.reEnteredPassword,
                    onChange: handleReEnteredPasswordChange
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    fullWidth: true,
                    variant: "contained",
                    disabled: loading || error.password || error.reEnteredPassword || !password || !reEnteredPassword || password !== reEnteredPassword,
                    color: "primary",
                    className: "".concat(classes.signUpButton, " ").concat(classes.dynamicWidthBtn),
                    onClick: function() {
                        return setupContentAiAccount(password);
                    },
                    children: [
                        loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            version: "1.1",
                            id: "loader",
                            style: {
                                fill: "#1D3557"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "one",
                                    d: "M5,25H0V0h5V25z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "two",
                                    d: "M15,25h-5V0h5V25z"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    id: "three",
                                    d: "M25,25h-5V0h5V25z"
                                })
                            ]
                        }) : null,
                        loading ? "Please wait..." : "Create Account"
                    ]
                }),
                apiError ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "".concat(parentClasses.subText, " ").concat(parentClasses.red),
                    children: apiError.includes("[object Object]") ? "Something Went wrong! Please try again" : apiError
                }) : null
            ]
        });
    };
    if (step === StepEnum.CREATE_PASSWORD) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResetPassword, {});
    }
    if (step === StepEnum.ACCOUNT_ALREADY_EXIST) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
            className: "".concat(classes.signUpCard, " ").concat(classes.hideCreditCardMessage),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h5",
                    component: "h2",
                    className: parentClasses.heading,
                    children: "You have an account with Quattr!"
                }),
                email ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        className: classes.alreadyExistHeading,
                        children: [
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "Looks like this email address has a Quattr account. Login to continue"
                            })
                        ]
                    })
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    fullWidth: true,
                    variant: "contained",
                    disabled: loading,
                    color: "primary",
                    className: "".concat(classes.signUpButton, " ").concat(classes.dynamicWidthBtn),
                    onClick: function() {
                        if (window.analytics) {
                            window.analytics.track("Clicked On Retry Login", {
                                option: "Clicked On Retry Login",
                                isQwaDashboard: false,
                                current_page: "/get-started",
                                reason: "Account Already Exist"
                            });
                        } else {
                            (0,analyticsMeta/* segmentEventApi */.Ey)("Clicked On Retry Login", {
                                option: "Auto Login Error",
                                isQwaDashboard: false,
                                current_page: "/get-started",
                                reason: "Account Already Exist"
                            }, "track");
                        }
                        router.push("/login");
                    },
                    children: "Login"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "caption",
                    className: classes.signUpSubHeading,
                    children: [
                        "Want to create new account? ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                color: "#51D497",
                                cursor: "pointer",
                                textDecoration: "underline"
                            },
                            onClick: function() {
                                if (window.analytics) {
                                    window.analytics.track("Clicked On Choose a Different Email", {
                                        option: "Clicked On Retry Login",
                                        isQwaDashboard: false,
                                        current_page: "/get-started",
                                        reason: "Account Already Exist"
                                    });
                                } else {
                                    (0,analyticsMeta/* segmentEventApi */.Ey)("Clicked On Choose a Different Email", {
                                        option: "Auto Login Error",
                                        isQwaDashboard: false,
                                        current_page: "/get-started",
                                        reason: "Account Already Exist"
                                    }, "track");
                                }
                                setStep(StepEnum.SIGN_UP);
                            },
                            children: "Change Email Address"
                        })
                    ]
                }),
                apiError ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "".concat(parentClasses.subText, " ").concat(parentClasses.red),
                    children: apiError.includes("[object Object]") ? "Something Went wrong! Please try again" : apiError
                }) : null
            ]
        });
    }
    if (step === StepEnum.VERIFY_OTP) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
            className: "".concat(classes.signUpCard, " ").concat(classes.hideCreditCardMessage),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h5",
                    component: "h2",
                    className: parentClasses.heading,
                    children: "Verify Your Email"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: classes.loginText,
                    children: "Head to your inbox & copy+paste the code below"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextField/* default */.Z, {
                            label: "Enter Code",
                            value: code,
                            placeholder: "000000",
                            fullWidth: true,
                            whiteBg: true,
                            error: error === null || error === void 0 ? void 0 : error.code,
                            isOtp: true,
                            errorMessage: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.code,
                            onChange: function(e) {
                                setCode(e.target.value);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: questionStyles.otherRoleTextContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    fullWidth: true,
                                    variant: "outlined",
                                    disabled: loading,
                                    style: {
                                        borderRadius: "4.2px",
                                        border: "1px solid #1D3557",
                                        backgroundColor: "#fff"
                                    },
                                    color: "primary",
                                    className: "".concat(classes.signUpButton, " ").concat(classes.dynamicWidthBtn, " ").concat(classes.outlined),
                                    onClick: handleResendCode,
                                    children: [
                                        loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            version: "1.1",
                                            id: "loader",
                                            style: {
                                                fill: "#1D3557"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "one",
                                                    d: "M5,25H0V0h5V25z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "two",
                                                    d: "M15,25h-5V0h5V25z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "three",
                                                    d: "M25,25h-5V0h5V25z"
                                                })
                                            ]
                                        }) : null,
                                        loading ? "Please wait..." : "Resend Code"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    fullWidth: true,
                                    variant: "contained",
                                    disabled: loading,
                                    color: "primary",
                                    className: "".concat(classes.signUpButton, " ").concat(classes.dynamicWidthBtn),
                                    onClick: verifyOtp,
                                    children: [
                                        loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            version: "1.1",
                                            id: "loader",
                                            style: {
                                                fill: "#1D3557"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "one",
                                                    d: "M5,25H0V0h5V25z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "two",
                                                    d: "M15,25h-5V0h5V25z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    id: "three",
                                                    d: "M25,25h-5V0h5V25z"
                                                })
                                            ]
                                        }) : null,
                                        loading ? "Please wait..." : "Verify"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    if (step === StepEnum.CONFIRMATION) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
            className: "".concat(classes.signUpCard, " ").concat(classes.hideCreditCardMessage),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h5",
                    component: "h2",
                    className: parentClasses.heading,
                    children: isRequestApproved ? "Your request has been already approved!" : "Quattr is reviewing your request!"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    className: classes.loginText,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        isRequestApproved ? "Please check your inbox for an activation email. " : "Please keep an eye out for an email about your request.",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        isRequestApproved ? "If you have already activated your account, you can Login using your email and password by clicking the following button." : "In meantime, explore our free AI tools"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    fullWidth: true,
                    variant: "contained",
                    color: "primary",
                    disabled: loading,
                    className: "".concat(classes.signUpButton),
                    onClick: function() {
                        if (isRequestApproved) {
                            if (window.analytics) {
                                window.analytics.track("Clicked on Login");
                            } else {
                                var payload = {
                                    email: email,
                                    name: "",
                                    schema: "",
                                    instance_type: "Content AI",
                                    user_type: common/* CONTENT_AI_USER_TYPE */.Rq
                                };
                                (0,analyticsMeta/* segmentEventApi */.Ey)("Clicked on Login", payload, "track");
                            }
                            window.location.href = "https://auth.quattr.com/v2/logout?client_id=".concat("EG9H83MUzcmpkBE30xNxngbEZMgo30fJ", "&returnTo=").concat(encodeURIComponent("".concat("https://www.quattr.com", "/login")));
                        } else {
                            if (window.analytics) {
                                window.analytics.track("Clicked on See All Free AI Tools");
                            } else {
                                var payload1 = {
                                    email: email,
                                    name: "",
                                    schema: "",
                                    instance_type: "Content AI",
                                    user_type: common/* CONTENT_AI_USER_TYPE */.Rq
                                };
                                (0,analyticsMeta/* segmentEventApi */.Ey)("Clicked on See All Free AI Tools", payload1, "track");
                            }
                            if (window && postRedirects) {
                                window.parent.postMessage({
                                    action: "redirectURL",
                                    url: "/free-tools"
                                }, "*");
                            } else {
                                router.push("/free-tools");
                            }
                        }
                    },
                    children: [
                        " ",
                        isRequestApproved ? "Login" : "See All Free AI Tools"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    className: classes.loginText,
                    style: {
                        fontWeight: 700,
                        fontSize: "12px"
                    },
                    children: [
                        "Or Learn More About",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/",
                            className: classes.loginLink,
                            onClick: function(e) {
                                e.preventDefault();
                                (0,analyticsMeta/* trackAnalyticsEvent */.ec)({
                                    eventName: "Click",
                                    eventFor: "link",
                                    payload: {
                                        label: "Quattr",
                                        position: "anchor text"
                                    }
                                });
                                if (window && postRedirects) {
                                    window.parent.postMessage({
                                        action: "redirectURL",
                                        url: "/"
                                    }, "*");
                                } else {
                                    router.push("/");
                                }
                            },
                            style: {
                                fontWeight: 700,
                                fontSize: "12px",
                                textDecorationLine: "underline"
                            },
                            children: "Quattr"
                        })
                    ]
                })
            ]
        });
    }
    return step === StepEnum.SIGN_UP ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
        className: "".concat(classes.signUpCard),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h5",
                component: "h2",
                className: parentClasses.heading,
                children: headingText ? headingText : "Create your account"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                className: classes.loginText,
                children: [
                    "Already have an account?",
                    " ",
                    postRedirects ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/login",
                        className: classes.loginLink,
                        onClick: function(e) {
                            e.preventDefault();
                            if (window) {
                                window.parent.postMessage({
                                    action: "redirectURL",
                                    url: "/login"
                                }, "*");
                            }
                        },
                        children: "Log in"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/login",
                        className: classes.loginLink,
                        children: "Log in"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                className: "".concat(classes.signUpWithGoogle, " mt-30"),
                onClick: function() {
                    setSignUpWithGoogleLoader(true);
                    if (window.analytics) {
                        window.analytics.track("ButtonClick - Signup With Google", {
                            isQwaDashboard: false
                        });
                    } else {
                        var payload = {
                            email: email,
                            name: "",
                            schema: "",
                            instance_type: "Content AI",
                            user_type: common/* CONTENT_AI_USER_TYPE */.Rq,
                            label: "signup with Google",
                            isQwaDashboard: false
                        };
                        (0,analyticsMeta/* segmentEventApi */.Ey)("ButtonClick", payload, "track");
                    }
                    if (window && postRedirects) {
                        (0,analyticsMeta/* trackAnalyticsEvent */.ec)({
                            eventName: "Redirected to Google Verify",
                            payload: {
                                label: "Redirected to Google Verify",
                                fromPath: "/get-started?tab=start-free-trial"
                            }
                        });
                        window.parent.postMessage({
                            action: "redirectURL",
                            url: "/api/google-signup"
                        }, "*");
                    } else {
                        (0,analyticsMeta/* trackAnalyticsEvent */.ec)({
                            eventName: "Redirected to Google Verify",
                            payload: {
                                label: "Redirected to Google Verify",
                                fromPath: "/get-started?tab=start-free-trial"
                            }
                        });
                        router.push("/api/google-signup");
                    }
                },
                disabled: signUpWithGoogleLoader,
                children: [
                    signUpWithGoogleLoader ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                        version: "1.1",
                        id: "loader",
                        style: {
                            fill: "#1D3557"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                id: "one",
                                d: "M5,25H0V0h5V25z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                id: "two",
                                d: "M15,25h-5V0h5V25z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                id: "three",
                                d: "M25,25h-5V0h5V25z"
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                        className: classes.svgStyle,
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "25",
                        viewBox: "0 0 24 25",
                        fill: "none",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M23.04 12.6777C23.04 11.8623 22.9668 11.0782 22.8309 10.3254H12V14.7738H18.1891C17.9225 16.2113 17.1123 17.4293 15.8943 18.2448V21.1302H19.6109C21.7855 19.1282 23.04 16.18 23.04 12.6777Z",
                                fill: signUpWithGoogleLoader ? "gray" : "#4285F4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M11.9999 23.9162C15.1049 23.9162 17.7081 22.8864 19.6108 21.1301L15.8943 18.2446C14.8645 18.9346 13.5472 19.3423 11.9999 19.3423C9.00471 19.3423 6.46948 17.3194 5.56516 14.6012H1.72311V17.5807C3.61539 21.3392 7.50448 23.9162 11.9999 23.9162Z",
                                fill: signUpWithGoogleLoader ? "#808080ba" : "#34A853"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M5.56523 14.6015C5.33523 13.9115 5.20455 13.1745 5.20455 12.4165C5.20455 11.6585 5.33523 10.9215 5.56523 10.2315V7.25195H1.72318C0.944318 8.80445 0.5 10.5608 0.5 12.4165C0.5 14.2722 0.944318 16.0285 1.72318 17.581L5.56523 14.6015Z",
                                fill: signUpWithGoogleLoader ? "gray" : "#FBBC05"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M11.9999 5.49025C13.6883 5.49025 15.2043 6.07047 16.3961 7.21002L19.6945 3.91161C17.7029 2.05593 15.0997 0.916382 11.9999 0.916382C7.50448 0.916382 3.61539 3.49343 1.72311 7.25184L5.56516 10.2314C6.46948 7.5132 9.00471 5.49025 11.9999 5.49025Z",
                                fill: signUpWithGoogleLoader ? "#808080ba" : "#EA4335"
                            })
                        ]
                    }),
                    "Sign up with Google"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: classes.dividerContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        className: classes.divider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "caption",
                        className: classes.dividerText,
                        children: "Or, sign up with your email"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        className: classes.divider
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                spacing: 2,
                className: "mt-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        sm: 6,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextField/* default */.Z, {
                            label: "First name",
                            value: firstName,
                            placeholder: "John",
                            error: error === null || error === void 0 ? void 0 : error.firstName,
                            errorMessage: errorMessage.firstName,
                            onChange: function(e) {
                                return setFirstName(e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        sm: 6,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextField/* default */.Z, {
                            label: "Last name",
                            value: lastName,
                            placeholder: "Doe",
                            error: error === null || error === void 0 ? void 0 : error.lastName,
                            errorMessage: errorMessage.lastName,
                            onChange: function(e) {
                                return setLastName(e.target.value);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextField/* default */.Z, {
                label: "Work email",
                value: email,
                type: "email",
                error: error === null || error === void 0 ? void 0 : error.email,
                errorMessage: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.email,
                onChange: function(e) {
                    setEmail(e.target.value);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "body2",
                className: classes.secondaryText,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: "Note:"
                    }),
                    " Select the email address connected to your domain's ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: " Google Search Console (GSC)"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.termsCheckBox,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        checked: checked,
                        onChange: handleCheckboxChange,
                        style: {
                            color: checked ? "#51D497" : undefined,
                            paddingTop: "0px"
                        },
                        className: "".concat(checkboxError ? parentClasses.red : "")
                    }),
                    style: {
                        alignItems: "start"
                    },
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " ".concat(classes.secondaryText, " ").concat(checkboxError ? parentClasses.red : ""),
                        style: {
                            fontSize: "12px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                "I agree to Quattr’s",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "".concat(checkboxError ? parentClasses.red : parentClasses.green, " ").concat(parentClasses.link),
                                    href: "/content-ai/terms",
                                    onClick: function(e) {
                                        e.preventDefault();
                                        if (window && postRedirects) {
                                            window.parent.postMessage({
                                                action: "redirectURL",
                                                url: "/content-ai/terms"
                                            }, "*");
                                        } else {
                                            if (window) {
                                                e.preventDefault();
                                                window.open("/content-ai/terms", "_blank");
                                            } else {
                                                router.push("/content-ai/terms");
                                            }
                                        }
                                    },
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    style: {
                                        fontSize: "12px"
                                    },
                                    children: [
                                        " ",
                                        "terms of service"
                                    ]
                                }),
                                " ",
                                "&",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "".concat(checkboxError ? parentClasses.red : parentClasses.green, " ").concat(parentClasses.link),
                                    href: "/privacy-policy",
                                    onClick: function(e) {
                                        e.preventDefault();
                                        if (window && postRedirects) {
                                            window.parent.postMessage({
                                                action: "redirectURL",
                                                url: "/privacy-policy"
                                            }, "*");
                                        } else {
                                            if (window) {
                                                e.preventDefault();
                                                window.open("/privacy-policy", "_blank");
                                            } else {
                                                router.push("/privacy-policy");
                                            }
                                        }
                                    },
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    style: {
                                        fontSize: "12px"
                                    },
                                    children: "privacy policy"
                                }),
                                "."
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                fullWidth: true,
                variant: "contained",
                color: "primary",
                disabled: loading || !firstName || !lastName || !email || !checked,
                className: classes.signUpButton,
                onClick: function() {
                    return handleSignUpNoWClick(StepEnum.SIGN_UP);
                },
                children: [
                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                        version: "1.1",
                        id: "loader",
                        style: {
                            fill: "#1D3557"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                id: "one",
                                d: "M5,25H0V0h5V25z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                id: "two",
                                d: "M15,25h-5V0h5V25z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                id: "three",
                                d: "M25,25h-5V0h5V25z"
                            })
                        ]
                    }) : null,
                    "Verify email"
                ]
            })
        ]
    }) : null;
};
var bookMeeting = function(param) {
    var classes = param.classes, setShowCalendly = param.setShowCalendly;
    var ref = (0,react.useState)({
        firstName: "",
        lastName: "",
        email: "",
        companyName: "",
        companySize: "",
        website: "https://"
    }), fields = ref[0], setFields = ref[1];
    var ref1 = (0,react.useState)({
        firstName: "",
        lastName: "",
        email: "",
        companyName: "",
        companySize: "",
        website: ""
    }), errors = ref1[0], setErrors = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setLoading = ref2[1];
    var ownClasses = useSignUpStyles();
    var rollbar = (0,useRollbar/* useRollbar */.F)();
    var handleFieldChange = function(field, value) {
        setFields((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fields), (0,_define_property/* default */.Z)({}, field, value)));
        setErrors((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, errors), (0,_define_property/* default */.Z)({}, field, "")));
    };
    var validateFields = function() {
        var tempErrors = {};
        var isValid = true;
        // Email Regex
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        // URL Regex (simplified for demonstration)
        var urlRegex = /^(https?:\/\/)?(www\.)?[a-z0-9]+(\.[a-z]+)+[\/\w .-]*\/?$/;
        if (!fields.firstName) {
            tempErrors.firstName = "First name is required";
            isValid = false;
        }
        if (!fields.lastName) {
            tempErrors.lastName = "Last name is required";
            isValid = false;
        }
        if (!fields.email || !emailRegex.test(fields.email)) {
            tempErrors.email = "Enter a valid email address";
            isValid = false;
        }
        if (!fields.companyName) {
            tempErrors.companyName = "Company name is required";
            isValid = false;
        }
        if (!fields.companySize) {
            tempErrors.companySize = "Please select the company size";
            isValid = false;
        }
        if (!fields.website || !urlRegex.test(fields.website)) {
            tempErrors.website = "Enter a valid website URL";
            isValid = false;
        }
        setErrors(tempErrors);
        return isValid;
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var formValues;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        _ctx.prev = 1;
                        if (!validateFields()) {
                            _ctx.next = 14;
                            break;
                        }
                        setLoading(true);
                        formValues = {
                            firstname: fields.firstName,
                            lastname: fields.lastName,
                            email: fields.email,
                            company: fields.companyName,
                            company_size__dropdown_: fields.companySize,
                            website: fields.website
                        };
                        if (setShowCalendly) {
                            setShowCalendly(true);
                        }
                        localStorage.setItem("is_book_meeting_form_submitted", "true");
                        localStorage.setItem("book-demo-email", fields.email);
                        localStorage.setItem("book-demo-name", "".concat(fields.firstName, " ").concat(fields.lastName));
                        if (window.analytics) {
                            window.analytics.identify(fields.email, {
                                email: fields.email,
                                name: "".concat(fields.firstName, " ").concat(fields.lastName),
                                schema: "",
                                instance_type: "Content AI",
                                user_type: common/* CONTENT_AI_USER_TYPE */.Rq,
                                company_name: ""
                            });
                        }
                        (0,analyticsMeta/* trackAnalyticsEvent */.ec)({
                            eventName: "Submitted the book demo form",
                            payload: (0,_object_spread/* default */.Z)({
                                label: "Submitted the book demo form"
                            }, formValues)
                        });
                        if (!utility_common/* isProductionEnv */.n5S) {
                            _ctx.next = 14;
                            break;
                        }
                        _ctx.next = 14;
                        return hubSpot/* default.sendDataToForm */.ZP.sendDataToForm(hubSpot/* FormConfigMap.bookMeetingForm */.GN.bookMeetingForm, (0,_object_spread/* default */.Z)({}, formValues), undefined).catch(function(error) {
                            console.error("Error sending data to HubSpot in the Request a Demo form", error);
                            rollbar.warning("Error sending data to HubSpot in the Request a Demo form", error);
                        });
                    case 14:
                        _ctx.next = 19;
                        break;
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error("handleSubmit::", _ctx.t0);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    16
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.innerWrap,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
            className: "".concat(ownClasses.signUpCard, " ").concat(ownClasses.hideCreditCardMessage),
            style: {
                padding: "19px 28px 3px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h5",
                    component: "h2",
                    className: classes.heading,
                    children: "Tell us about yourself"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    spacing: 2,
                    className: "mt-20",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            sm: 6,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextField/* default */.Z, {
                                label: "First name",
                                value: fields.firstName,
                                placeholder: "John",
                                error: !!errors.firstName,
                                errorMessage: errors.firstName,
                                onChange: function(e) {
                                    return handleFieldChange("firstName", e.target.value);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            sm: 6,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextField/* default */.Z, {
                                label: "Last name",
                                value: fields.lastName,
                                placeholder: "Doe",
                                error: !!errors.lastName,
                                errorMessage: errors.lastName,
                                onChange: function(e) {
                                    return handleFieldChange("lastName", e.target.value);
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextField/* default */.Z, {
                    label: "Email address",
                    value: fields.email,
                    placeholder: "john.doe@example.com",
                    error: !!errors.email,
                    errorMessage: errors.email,
                    onChange: function(e) {
                        return handleFieldChange("email", e.target.value);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextField/* default */.Z, {
                    label: "Company name",
                    value: fields.companyName,
                    placeholder: "Example Corp",
                    error: !!errors.companyName,
                    errorMessage: errors.companyName,
                    onChange: function(e) {
                        return handleFieldChange("companyName", e.target.value);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(onboarding_CustomSelect, {
                    label: "Company Size",
                    value: fields.companySize,
                    onChange: function(e) {
                        return handleFieldChange("companySize", e.target.value);
                    },
                    error: !!errors.companySize,
                    errorMessage: errors.companySize,
                    info: "Select the size of your company",
                    options: [
                        {
                            value: "1-50 Employees",
                            label: "1-50 employees"
                        },
                        {
                            value: "51-250 Employees",
                            label: "51-250 employees"
                        },
                        {
                            value: "251-1000 Employees",
                            label: "251-1000 employees"
                        },
                        {
                            value: "1001+ Employees",
                            label: "1001+ employees"
                        }, 
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextField/* default */.Z, {
                    label: "Website domain address",
                    value: fields.website,
                    placeholder: "https://www.example.com",
                    error: !!errors.website,
                    info: "Website Domain address is the home page link or URL of the website you run and operate.",
                    errorMessage: errors.website,
                    onChange: function(e) {
                        return handleFieldChange("website", e.target.value);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    fullWidth: true,
                    variant: "contained",
                    className: "".concat(ownClasses.signUpButton, " ").concat(ownClasses.dynamicWidthBtn),
                    color: "primary",
                    disabled: isLoading,
                    style: {
                        marginTop: "7px",
                        textTransform: "unset"
                    },
                    onClick: handleSubmit,
                    children: "Book a Demo"
                })
            ]
        })
    });
};
var GetStarted = function(param) {
    var classes = param.classes, setGoBack = param.setGoBack, setFullPageContentAiLoader = param.setFullPageContentAiLoader;
    var router = (0,next_router.useRouter)();
    var plan_id = router.query.plan || "individual-monthly";
    var request_submitted = router.query.request_submitted;
    var isNoCorpEmail = router.query.nocorp;
    (0,react.useEffect)(function() {
        if (plan_id && typeof plan_id == "string") {
            sessionStorage.setItem("qttr-plan-selected", plan_id);
        }
    }, [
        plan_id
    ]);
    var ownClasses = useSignUpStyles();
    if (request_submitted) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.innerWrap,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: classes.heading,
                        children: "Your request has been received"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "".concat(classes.heading, " ").concat(classes.heading2, " ").concat(classes.green),
                        children: "The Quattr team is working on setting up your account."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: classes.subText,
                        children: "Please keep an eye out for an email in your inbox. We will share your login details soon."
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.innerWrap,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagGenerator["default"], {
                metaUrl: "".concat("https://www.quattr.com").concat(router.asPath),
                metaTitle: "Get started with Quattr's Content AI",
                metaDescription: "Sign up with your Google account now to get access to Content AI. Write, optimize, and rank high with ease and speed."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingForm, {
                parentClasses: classes,
                headingText: "",
                postRedirects: false,
                setGoBack: setGoBack,
                setFullPageContentAiLoader: setFullPageContentAiLoader
            })
        ]
    });
};
var getStartedWrapperStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return {
        mainWrapper: (0,_define_property/* default */.Z)({
            display: "flex",
            flexDirection: "row",
            height: "calc(100vh - 60px)"
        }, theme.breakpoints.down("sm"), {
            flexDirection: "column",
            marginTop: "0px",
            height: "unset"
        }),
        topHeadingsWrapper: {
            marginTop: "56px"
        },
        aiToolsMainWrapper: (0,_define_property/* default */.Z)({
            height: "100vh",
            overflowY: "scroll",
            width: "100%"
        }, theme.breakpoints.down("sm"), {
            marginTop: "0px",
            height: "unset",
            overflowY: "unset",
            width: "unset"
        }),
        tabsWrapper: (0,_define_property/* default */.Z)({
            background: "#ECF2FC",
            textAlign: "center",
            maxWidth: "400px",
            minWidth: "400px",
            height: "100vh"
        }, theme.breakpoints.down("sm"), {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            maxWidth: "unset",
            minWidth: "unset",
            width: "100%",
            height: "unset"
        }),
        stickyTabsWrapper: {
            position: "sticky",
            top: "56px",
            zIndex: 9
        },
        headingWrapper: (0,_define_property/* default */.Z)({
            margin: "44px 30px 24px"
        }, theme.breakpoints.down("sm"), {
            margin: "16px 12px 0px"
        }),
        tabsHeading: (0,_define_property/* default */.Z)({
            color: "#1D3557",
            textAlign: "center",
            fontFamily: "Poppins",
            fontSize: "28px",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "140%"
        }, theme.breakpoints.down("sm"), {
            fontSize: "24px",
            margin: "0px"
        }),
        secondaryText: (0,_define_property/* default */.Z)({
            color: "#1D3557",
            fontFamily: '"Source Sans Pro"',
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "140%"
        }, theme.breakpoints.down("sm"), {
            fontSize: "18px"
        }),
        tabs: (0,_define_property/* default */.Z)({
            width: "100%"
        }, theme.breakpoints.down("sm"), {
            width: "unset",
            margin: "auto",
            "& div ": {
                display: "flex",
                overflow: "hidden !important",
                flexWrap: "wrap !important",
                justifyContent: "center !important",
                maxWidth: "100%",
                paddingBottom: "3px"
            },
            "& .MuiTabs-scrollButtonsDesktop": {
                display: "none !important"
            }
        }),
        tab: (_obj = {
            textTransform: "unset",
            minWidth: "100%",
            width: "100%",
            padding: "23px 15px 23px 23px",
            border: "2px solid #1D3557",
            opacity: 1,
            margin: "7.5px 0px"
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
            color: " #1D3557",
            fontFamily: "Source Sans Pro",
            fontWeight: 400,
            fontSize: "12px",
            minWidth: "unset",
            width: "unset",
            border: "unset",
            margin: "7.5px 0px 0px",
            padding: "7px 15px",
            minHeight: "unset"
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(360), {
            fontSize: "12px",
            padding: "5px 8px"
        }), _obj),
        blackCheck: {
            height: "35px",
            width: "35px",
            margin: "0px",
            marginRight: "25px"
        },
        toolsSvg: {
            height: "55px",
            width: "55px",
            margin: "0px",
            padding: "0px",
            marginRight: "25px"
        },
        tabHeading: {
            color: "#1D3557",
            fontFamily: "Poppins",
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "140%",
            margin: "0px"
        },
        indicator: {
            backgroundColor: "transparent"
        },
        tabSelected: (0,_define_property/* default */.Z)({
            background: "#FFF",
            boxShadow: "0px 5px 4px 2px rgba(29, 53, 87, 0.25)",
            border: "2px solid #fff"
        }, theme.breakpoints.down("sm"), {
            fontWeight: 600,
            boxShadow: "unset",
            borderRadius: "10px 10px 0 0"
        }),
        tabIcon: {
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "unset"
        },
        loaderWrapper: {
            position: "relative",
            "& .MuiGrid-root": {
                height: "auto"
            }
        },
        loader: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 9999
        },
        loaderText: {
            color: "#1D3557",
            textAlign: "center",
            fontFamily: "Poppins",
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: 700,
            whiteSpace: "pre-line"
        },
        loaderTextDescription: {
            color: "#1D3557",
            textAlign: "center",
            fontFamily: "Poppins",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 700,
            whiteSpace: "pre-line"
        },
        overlay: {
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            background: "radial-gradient(circle, white, white 10%, rgba(255, 255, 255, 0.5) 90%, transparent)",
            zIndex: 9998
        },
        hidden: {
            display: "none"
        }
    };
});
var updateUrlParameter = function(parameterName, parameterValue) {
    // Construct a URLSearchParams object from the current URL query string
    var searchParams = new URLSearchParams(window.location.search);
    // Update the parameter value or add it if it doesn't exist
    searchParams.set(parameterName, parameterValue);
    // Construct the new URL
    var newUrl = "".concat(window.location.pathname, "?").concat(searchParams.toString());
    // Use window.history.pushState() to change the URL without reloading the page
    window.history.pushState({
        path: newUrl
    }, "", newUrl);
};
var GetStartedWrapped = function() {
    var ref = (0,react.useState)("start-free-trial"), tabName = ref[0], setTabName = ref[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var toolUsed = js_cookie/* default.get */.Z.get("ToolUsed") || false;
        if (!router.query.tab && toolUsed) {
            setTabName("ai-tools");
            setValue(2);
        }
    }, [
        router.query.tab
    ]);
    var tab = router.query.tab || tabName;
    var tabIndex = tab === "start-free-trial" ? 0 : tab === "book-demo" ? 1 : 2;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(tabIndex), 2), value = ref1[0], setValue = ref1[1];
    var classes = (0,OnboardingDesignWrapper/* useOnboardingStyles */.M4)();
    var ownClasses = getStartedWrapperStyles();
    var theme = (0,useTheme/* default */.Z)();
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("sm"));
    var ref2 = (0,react.useState)(false), showCalendly = ref2[0], setShowCalendly = ref2[1];
    var ref3 = (0,react.useState)(false), showToolsVerifyForm = ref3[0], setShowToolsVerifyForm = ref3[1];
    var ref4 = (0,react.useState)(true), showPricingAndPlans = ref4[0], setShowPricingAndPlans = ref4[1];
    var ref5 = (0,react.useState)({}), planPurchaseLoading = ref5[0], setPlanPurchaseLoading = ref5[1];
    var ref6 = (0,react.useState)(false), fullScreenLoader = ref6[0], setFullScreenLoader = ref6[1];
    var ref7 = (0,react.useState)(false), fullPageContentAiLoader = ref7[0], setFullPageContentAiLoader = ref7[1];
    var session = (0,customHooks/* useSession */.kP)();
    var Router = (0,next_router.useRouter)();
    var _query = router.query, id = _query.id, state = _query.state;
    var qttr_tools_auth = js_cookie/* default.get */.Z.get("qttr_tools_auth");
    var isFromUnlockOption = Object.keys(Router.query).includes("unlock-options");
    var isSignUpNow = Object.keys(Router.query).includes("signup-now");
    var toolState = Object.keys(Router.query).includes("toolState");
    (0,react.useEffect)(function() {
        var is_book_meeting_form_submitted = localStorage.getItem("is_book_meeting_form_submitted");
        if (is_book_meeting_form_submitted) {
            setShowCalendly(true);
        }
    }, []);
    var handleChange = function(event, newValue) {
        setValue(newValue);
        updateUrlParameter("tab", newValue == 1 ? "book-demo" : newValue == 0 ? "start-free-trial" : "ai-tools");
        (0,analyticsMeta/* trackAnalyticsEvent */.ec)({
            eventName: "Tab View - ".concat(newValue == 1 ? "book-demo" : newValue == 0 ? "start-free-trial" : "ai-tools"),
            payload: {
                label: "Tab View - ".concat(newValue == 1 ? "book-demo" : newValue == 0 ? "start-free-trial" : "ai-tools"),
                isQwaDashboard: false
            }
        });
        if (isMobile && window.scrollY >= 90) {
            window.scrollTo(0, 90);
        } else {
            window.scrollTo(0, 0);
        }
    };
    var handleGoBack = function() {
        var previousUrl = localStorage.getItem("previousUrl");
        if (previousUrl) {
            // Modify the URL to add or update query parameters as needed
            var newUrl = new URL(previousUrl, window.location.origin);
            if (!qttr_tools_auth) {
                newUrl.searchParams.set("verifyEmail", "true"); // Add or modify query params here
            }
            if (isFromUnlockOption) {
                newUrl.searchParams.set("unlock-options", "true");
            } else if (isSignUpNow) {
                newUrl.searchParams.set("signup-now", "true");
            }
            // Use Router.push or Router.replace to navigate
            Router.push(newUrl.pathname + newUrl.search);
        } else {
            // Fallback to home
            Router.push("/");
        }
    };
    var handlePlanSelection = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(plan) {
            var qttr_tools_auth, params, ref, ref1, ref2, headerEncoded, payloadEncoded, signatureEncoded, payload, result, ref3, ref4;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        qttr_tools_auth = js_cookie/* default.get */.Z.get("qttr_tools_auth");
                        params = {};
                        _ctx.prev = 2;
                        ;
                        if (qttr_tools_auth) {
                            ref2 = (0,_sliced_to_array/* default */.Z)(qttr_tools_auth.split("."), 3), headerEncoded = ref2[0], payloadEncoded = ref2[1], signatureEncoded = ref2[2];
                            payload = JSON.parse(atob(payloadEncoded));
                            params = {
                                planType: plan,
                                redirect_url: "".concat("https://www.quattr.com", "/get-started?tab=ai-tools"),
                                email: payload === null || payload === void 0 ? void 0 : payload.email,
                                firstName: payload === null || payload === void 0 ? void 0 : payload.firstName,
                                lastName: payload === null || payload === void 0 ? void 0 : payload.lastName
                            };
                        } else {
                            params = {
                                planType: plan,
                                redirect_url: "".concat("https://www.quattr.com", "/get-started?tab=ai-tools")
                            };
                        }
                        setPlanPurchaseLoading(function(prevState) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), (0,_define_property/* default */.Z)({}, plan, true));
                        });
                        _ctx.next = 8;
                        return axios/* default.post */.Z.post("/api/join-content-ai/get-ai-paid-plan-user-link", params);
                    case 8:
                        result = _ctx.sent;
                        if (result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.url) {
                            ;
                            if (window.analytics) {
                                window.analytics.track("Redirected To chargeBee For (".concat(plan, " Plan)"), {
                                    option: "chargeBee : ".concat(plan, " Plan"),
                                    isQwaDashboard: false
                                });
                            } else {
                                (0,analyticsMeta/* segmentEventApi */.Ey)("Redirected To chargeBee For (".concat(plan, " Plan)"), {
                                    option: "chargeBee : ".concat(plan, " Plan"),
                                    isQwaDashboard: false
                                }, "track");
                            }
                            window.location.href = result === null || result === void 0 ? void 0 : (ref3 = result.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.url;
                        }
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](2);
                        console.error("Error :: chargebee redirect for paid tools user", _ctx.t0);
                    case 15:
                        _ctx.prev = 15;
                        setPlanPurchaseLoading(function(prevState) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), (0,_define_property/* default */.Z)({}, plan, false));
                        });
                        return _ctx.finish(15);
                    case 18:
                        if (window.analytics) {
                            window.analytics.track("Clicked Start Now (".concat(plan, " Plan)"), {
                                option: plan,
                                isQwaDashboard: false
                            });
                        } else {
                            (0,analyticsMeta/* segmentEventApi */.Ey)("Clicked Start Now (".concat(plan, " Plan)"), {
                                option: plan,
                                isQwaDashboard: false
                            }, "track");
                        }
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    12,
                    15,
                    18
                ]
            ]);
        }));
        return function handlePlanSelection(plan) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleExistingUserVerify = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data, email, isExistingUser) {
            var ref, ref1, ref2, ref3, ref4, payload;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        payload = {
                            email: email,
                            planId: data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : (ref1 = ref.hosted_page) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.content) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subscription) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscription_items) === null || ref4 === void 0 ? void 0 : ref4[0].item_price_id,
                            qwa_tools_subscription_status: common/* SUBSCRIPTION_STATUS.SUBSCRIPTION_ACTIVATED */.qq.SUBSCRIPTION_ACTIVATED
                        };
                        try {
                            setFullScreenLoader(true);
                            if (isExistingUser) {
                                setFullScreenLoader(false);
                                if (window === null || window === void 0 ? void 0 : window.analytics) {
                                    window.analytics.track("Redirected to Login", {
                                        option: "Redirected to Login",
                                        isQwaDashboard: false
                                    });
                                } else {
                                    (0,analyticsMeta/* segmentEventApi */.Ey)("Redirected to Login", {
                                        option: "Redirected to Login",
                                        isQwaDashboard: false
                                    }, "track");
                                }
                                router.push("/login");
                            } else {
                                setFullScreenLoader(false);
                                setShowPricingAndPlans(false);
                                setShowToolsVerifyForm(true);
                                if (window === null || window === void 0 ? void 0 : window.analytics) {
                                    window.analytics.track("Viewed Set Password Screen", {
                                        option: "Viewed Set Password Screen",
                                        userProps: payload,
                                        isQwaDashboard: false
                                    });
                                } else {
                                    (0,analyticsMeta/* segmentEventApi */.Ey)("Viewed Set Password Screen", {
                                        option: "Viewed Set Password Screen",
                                        userProps: payload,
                                        isQwaDashboard: false
                                    }, "track");
                                }
                            }
                        } catch (error) {
                            console.error("Error: handleExistingUserVerify", error);
                            if (window === null || window === void 0 ? void 0 : window.analytics) {
                                window.analytics.track("Error checking Existing User", {
                                    option: "Error checking Existing User",
                                    userProps: payload,
                                    isQwaDashboard: false
                                });
                            } else {
                                (0,analyticsMeta/* segmentEventApi */.Ey)("Error Checking Existing User", {
                                    option: "Error checking Existing User",
                                    userProps: payload,
                                    isQwaDashboard: false
                                }, "track");
                            }
                        } finally{
                            setFullScreenLoader(false);
                        }
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleExistingUserVerify(data, email, isExistingUser) {
            return _ref.apply(this, arguments);
        };
    }();
    var identifyAndTrack = (0,lodash.debounce)(function(sessionPayload, result) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46;
        if (window.analytics) {
            var ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59, ref60, ref61, ref62, ref63, ref64, ref65, ref66, ref67, ref68, ref69, ref70, ref71, ref72, ref73, ref74, ref75, ref76, ref77, ref78, ref79;
            window.analytics.identify(sessionPayload === null || sessionPayload === void 0 ? void 0 : sessionPayload.email, {
                email: sessionPayload === null || sessionPayload === void 0 ? void 0 : sessionPayload.email,
                name: "".concat(sessionPayload === null || sessionPayload === void 0 ? void 0 : sessionPayload.firstName, " ").concat(sessionPayload === null || sessionPayload === void 0 ? void 0 : sessionPayload.lastName),
                schema: "",
                instance_type: "Ai Tools",
                user_type: utility_common/* USER_CLASSIFICATION.QWA_TOOLS */.Cf8.QWA_TOOLS,
                company_name: ""
            });
            window.analytics.track("Tools Plan Purchase Verified (".concat(result === null || result === void 0 ? void 0 : (ref47 = result.data) === null || ref47 === void 0 ? void 0 : (ref48 = ref47.data) === null || ref48 === void 0 ? void 0 : (ref49 = ref48.hosted_page) === null || ref49 === void 0 ? void 0 : (ref50 = ref49.content) === null || ref50 === void 0 ? void 0 : (ref51 = ref50.subscription) === null || ref51 === void 0 ? void 0 : (ref52 = ref51.subscription_items) === null || ref52 === void 0 ? void 0 : ref52[0].item_price_id, ")"), {
                option: "Tools Plan Purchase Verified (".concat(result === null || result === void 0 ? void 0 : (ref53 = result.data) === null || ref53 === void 0 ? void 0 : (ref54 = ref53.data) === null || ref54 === void 0 ? void 0 : (ref55 = ref54.hosted_page) === null || ref55 === void 0 ? void 0 : (ref56 = ref55.content) === null || ref56 === void 0 ? void 0 : (ref57 = ref56.subscription) === null || ref57 === void 0 ? void 0 : (ref58 = ref57.subscription_items) === null || ref58 === void 0 ? void 0 : ref58[0].item_price_id, ")"),
                email: result === null || result === void 0 ? void 0 : (ref59 = result.data) === null || ref59 === void 0 ? void 0 : (ref60 = ref59.data) === null || ref60 === void 0 ? void 0 : (ref61 = ref60.hosted_page) === null || ref61 === void 0 ? void 0 : (ref62 = ref61.content) === null || ref62 === void 0 ? void 0 : (ref63 = ref62.customer) === null || ref63 === void 0 ? void 0 : ref63.email,
                planId: result === null || result === void 0 ? void 0 : (ref64 = result.data) === null || ref64 === void 0 ? void 0 : (ref65 = ref64.data) === null || ref65 === void 0 ? void 0 : (ref66 = ref65.hosted_page) === null || ref66 === void 0 ? void 0 : (ref67 = ref66.content) === null || ref67 === void 0 ? void 0 : (ref68 = ref67.subscription) === null || ref68 === void 0 ? void 0 : (ref69 = ref68.subscription_items) === null || ref69 === void 0 ? void 0 : ref69[0].item_price_id,
                firstName: result === null || result === void 0 ? void 0 : (ref70 = result.data) === null || ref70 === void 0 ? void 0 : (ref71 = ref70.data) === null || ref71 === void 0 ? void 0 : (ref72 = ref71.hosted_page) === null || ref72 === void 0 ? void 0 : (ref73 = ref72.content) === null || ref73 === void 0 ? void 0 : (ref74 = ref73.customer) === null || ref74 === void 0 ? void 0 : ref74.first_name,
                lastName: result === null || result === void 0 ? void 0 : (ref75 = result.data) === null || ref75 === void 0 ? void 0 : (ref76 = ref75.data) === null || ref76 === void 0 ? void 0 : (ref77 = ref76.hosted_page) === null || ref77 === void 0 ? void 0 : (ref78 = ref77.content) === null || ref78 === void 0 ? void 0 : (ref79 = ref78.customer) === null || ref79 === void 0 ? void 0 : ref79.last_name,
                isQwaDashboard: false
            });
        } else {
            var ref80, ref81, ref82, ref83, ref84, ref85, ref86, ref87, ref88, ref89, ref90, ref91;
            (0,analyticsMeta/* segmentEventApi */.Ey)("Tools Plan Purchase Verified (".concat(result === null || result === void 0 ? void 0 : (ref80 = result.data) === null || ref80 === void 0 ? void 0 : (ref81 = ref80.data) === null || ref81 === void 0 ? void 0 : (ref82 = ref81.hosted_page) === null || ref82 === void 0 ? void 0 : (ref83 = ref82.content) === null || ref83 === void 0 ? void 0 : (ref84 = ref83.subscription) === null || ref84 === void 0 ? void 0 : (ref85 = ref84.subscription_items) === null || ref85 === void 0 ? void 0 : ref85[0].item_price_id, ")"), {
                option: "Tools Plan Purchase Verified (".concat(result === null || result === void 0 ? void 0 : (ref86 = result.data) === null || ref86 === void 0 ? void 0 : (ref87 = ref86.data) === null || ref87 === void 0 ? void 0 : (ref88 = ref87.hosted_page) === null || ref88 === void 0 ? void 0 : (ref89 = ref88.content) === null || ref89 === void 0 ? void 0 : (ref90 = ref89.subscription) === null || ref90 === void 0 ? void 0 : (ref91 = ref90.subscription_items) === null || ref91 === void 0 ? void 0 : ref91[0].item_price_id, ")"),
                payload: sessionPayload,
                isQwaDashboard: false
            }, "track");
        }
        (0,analyticsMeta/* trackAnalyticsEvent */.ec)({
            eventName: "Revenue tracking - Plan Purchase",
            payload: {
                userDetails: sessionPayload,
                plan_id: result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.hosted_page) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.content) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscription) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.subscription_items) === null || ref5 === void 0 ? void 0 : ref5[0].item_price_id,
                $price: (result === null || result === void 0 ? void 0 : (ref6 = result.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.hosted_page) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.content) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.subscription) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.subscription_items) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[0]) === null || ref12 === void 0 ? void 0 : ref12.amount) / 100,
                $revenue: (result === null || result === void 0 ? void 0 : (ref13 = result.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.data) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.hosted_page) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.content) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.subscription) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.subscription_items) === null || ref18 === void 0 ? void 0 : (ref19 = ref18[0]) === null || ref19 === void 0 ? void 0 : ref19.amount) / 100,
                $currency: "USD",
                $revenueType: "Plan Purchase",
                $productId: result === null || result === void 0 ? void 0 : (ref20 = result.data) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.data) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.hosted_page) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.content) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.subscription) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.subscription_items) === null || ref25 === void 0 ? void 0 : ref25[0].item_price_id,
                $quantity: 1,
                current_term_start: (0,utility_common/* formatUnixDate */.WEC)(result === null || result === void 0 ? void 0 : (ref26 = result.data) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.data) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.hosted_page) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.content) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.subscription) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.subscription_items) === null || ref31 === void 0 ? void 0 : (ref32 = ref31[0]) === null || ref32 === void 0 ? void 0 : ref32.current_term_start),
                current_term_end: (0,utility_common/* formatUnixDate */.WEC)(result === null || result === void 0 ? void 0 : (ref33 = result.data) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.data) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.hosted_page) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.content) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.subscription) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.subscription_items) === null || ref38 === void 0 ? void 0 : (ref39 = ref38[0]) === null || ref39 === void 0 ? void 0 : ref39.current_term_end),
                next_billing_at: (0,utility_common/* formatUnixDate */.WEC)(result === null || result === void 0 ? void 0 : (ref40 = result.data) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.data) === null || ref41 === void 0 ? void 0 : (ref42 = ref41.hosted_page) === null || ref42 === void 0 ? void 0 : (ref43 = ref42.content) === null || ref43 === void 0 ? void 0 : (ref44 = ref43.subscription) === null || ref44 === void 0 ? void 0 : (ref45 = ref44.subscription_items) === null || ref45 === void 0 ? void 0 : (ref46 = ref45[0]) === null || ref46 === void 0 ? void 0 : ref46.next_billing_at),
                label: "Revenue tracking - Plan Purchase",
                isQwaDashboard: false
            }
        });
    }, 3000);
    var handlePaymentVerify = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id) {
            var result, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, sessionPayload;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setFullScreenLoader(true);
                        _ctx.next = 4;
                        return axios/* default.post */.Z.post("/api/join-content-ai/verify-ai-tools-plan", {
                            id: id,
                            isQwaDashboard: false
                        });
                    case 4:
                        result = _ctx.sent;
                        if (result.data) {
                            ;
                            sessionPayload = {
                                planId: result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.hosted_page) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.content) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.subscription) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.subscription_items) === null || ref5 === void 0 ? void 0 : ref5[0].item_price_id,
                                email: result === null || result === void 0 ? void 0 : (ref6 = result.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.hosted_page) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.content) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.customer) === null || ref10 === void 0 ? void 0 : ref10.email,
                                firstName: result === null || result === void 0 ? void 0 : (ref11 = result.data) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.hosted_page) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.content) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.customer) === null || ref15 === void 0 ? void 0 : ref15.first_name,
                                lastName: result === null || result === void 0 ? void 0 : (ref16 = result.data) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.data) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.hosted_page) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.content) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.customer) === null || ref20 === void 0 ? void 0 : ref20.last_name
                            };
                            sessionStorage.setItem("tools-user-auth", JSON.stringify(sessionPayload));
                            (0,tools_common/* setCookie */.d)("qttr_tools_daypass_auth", "", false, true);
                            identifyAndTrack(sessionPayload, result);
                            handleExistingUserVerify(result.data, result === null || result === void 0 ? void 0 : (ref21 = result.data) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.data) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.hosted_page) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.content) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.customer) === null || ref25 === void 0 ? void 0 : ref25.email, result === null || result === void 0 ? void 0 : (ref26 = result.data) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.data) === null || ref27 === void 0 ? void 0 : ref27.isExistingUser);
                        }
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error("Error : handlePaymentVerify", _ctx.t0);
                        if (window.analytics) {
                            window.analytics.track("Tools Plan Purchase Verification Error", {
                                option: "Tools Plan Purchase Verification Error",
                                isQwaDashboard: false
                            });
                        } else {
                            (0,analyticsMeta/* segmentEventApi */.Ey)("Tools Plan Purchase Verification Error", {
                                option: "Tools Plan Purchase Verification Error",
                                isQwaDashboard: false
                            }, "track");
                        }
                    case 12:
                        _ctx.prev = 12;
                        return _ctx.finish(12);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8,
                    12,
                    14
                ]
            ]);
        }));
        return function handlePaymentVerify(id) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (id && [
            "succeeded",
            "requested"
        ].includes(state)) {
            handlePaymentVerify(id);
        }
    }, [
        id
    ]);
    (0,react.useEffect)(function() {
        var toolsUser = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("tools-user-auth");
        if (toolsUser && toolState && session) {
            var ref, ref1;
            var sessionUser = toolsUser ? JSON.parse(toolsUser) : null;
            var sessionEmail = session === null || session === void 0 ? void 0 : (ref = session.session) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.email;
            var paymentEmail = sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.email;
            if (sessionEmail && paymentEmail) {
                if (sessionEmail === paymentEmail) {
                    router.push("/user-auth");
                } else {
                    (0,authActions.signOut)({
                        callbackUrl: "/get-started?tab=ai-tools&&manualLogin=true",
                        redirect: true
                    });
                // router.push('/get-started?tab=ai-tools&&manualLogin=true');
                }
            }
        }
    }, [
        session,
        toolState
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if ((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.manualLogin) === "true") {
            setShowToolsVerifyForm(true);
            setShowPricingAndPlans(false);
            if (window.analytics) {
                window.analytics.track("Emails doesn't matching", {
                    label: "Shown manual login as payment email and google email not matching"
                });
            } else {
                var payload = {
                    instance_type: utility_common/* USER_CLASSIFICATION.QWA_TOOLS */.Cf8.QWA_TOOLS,
                    label: "Shown manual login as payment email and google email not matching"
                };
                (0,analyticsMeta/* segmentEventApi */.Ey)("Emails doesn't matching", payload, "track");
            }
        }
    }, [
        router
    ]);
    var handleChangePlanClick = function() {
        setShowPricingAndPlans(true);
        setShowToolsVerifyForm(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBar/* default */.Z, {
                color: "transparent",
                elevation: 0,
                position: "fixed",
                className: classes.appBar,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
                    className: "dflex j-content-space-bet",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: isMobile ? "https://qwa-assets.s3.us-east-2.amazonaws.com/home-logo.svg" : "https://qwa-assets.s3.us-east-2.amazonaws.com/home-logo-white.svg",
                                alt: "Logo",
                                className: classes.logo
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                            style: {
                                color: isMobile ? "" : "#FFF",
                                cursor: "pointer"
                            },
                            onClick: handleGoBack
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(ownClasses.topHeadingsWrapper, " ").concat(ownClasses.mainWrapper),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: ownClasses.tabsWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: ownClasses.headingWrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: ownClasses.tabsHeading,
                                        children: isMobile ? "How to get started?" : "How would you like to get started?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: ownClasses.secondaryText,
                                        children: "Select the best option for your needs."
                                    }),
                                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                        style: {
                                            margin: "7px 20px",
                                            backgroundColor: "#757575"
                                        }
                                    })
                                ]
                            }),
                            !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                                orientation: isMobile ? "horizontal" : "vertical",
                                variant: "scrollable",
                                value: value,
                                classes: {
                                    indicator: ownClasses.indicator
                                },
                                onChange: handleChange,
                                className: ownClasses.tabs,
                                "aria-label": "Responsive tabs",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                        className: ownClasses.tab,
                                        classes: {
                                            selected: ownClasses.tabSelected
                                        },
                                        icon: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: ownClasses.tabIcon,
                                            children: "Content AI for Websites"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: ownClasses.tabIcon,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: ownClasses.blackCheck,
                                                    src: "https://qwa-assets.s3.us-east-2.amazonaws.com/get-started-magic-pen-large.svg",
                                                    alt: "onboarding-background"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    style: {
                                                        textAlign: "left"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            className: ownClasses.tabHeading,
                                                            children: "Use Content AI for Website"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            className: ownClasses.secondaryText,
                                                            children: [
                                                                "For Content Marketers, SEOs, Copywriters, & Business Owners.",
                                                                " "
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                        className: ownClasses.tab,
                                        classes: {
                                            selected: ownClasses.tabSelected
                                        },
                                        icon: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: ownClasses.tabIcon,
                                            children: "Book Demo for AI SEO Suite"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: ownClasses.tabIcon,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: ownClasses.blackCheck,
                                                    src: "https://qwa-assets.s3.us-east-2.amazonaws.com/get-started-calendar.svg",
                                                    alt: "onboarding-background"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    style: {
                                                        textAlign: "left"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            className: ownClasses.tabHeading,
                                                            children: "Book Demo of AI SEO Suite"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            className: ownClasses.secondaryText,
                                                            children: [
                                                                "SEO Platform for Enterprises, Global Brands, & Startups.",
                                                                " "
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                        className: ownClasses.tab,
                                        classes: {
                                            selected: ownClasses.tabSelected
                                        },
                                        icon: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: ownClasses.tabIcon,
                                            children: "Quick AI Tools"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: ownClasses.tabIcon,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                    className: ownClasses.toolsSvg,
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "35",
                                                    height: "35",
                                                    viewBox: "0 0 35 35",
                                                    fill: "none",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            "fill-rule": "evenodd",
                                                            "clip-rule": "evenodd",
                                                            d: "M4.97493 1.097C5.35906 0.712873 5.88005 0.49707 6.4233 0.49707H24.9606C25.5034 0.497549 26.0248 0.713485 26.4085 1.09742L31.4162 6.10512C31.6069 6.29554 31.7581 6.52172 31.8612 6.77069C31.9643 7.01967 32.0173 7.28654 32.017 7.556V17.4999C32.017 18.104 31.5274 18.5937 30.9233 18.5937C30.3192 18.5937 29.8295 18.104 29.8295 17.4999V7.61205L29.8699 7.6524C29.8572 7.63957 29.8471 7.62437 29.8401 7.60765C29.8332 7.59099 29.8296 7.57315 29.8295 7.55514V7.61205L24.9021 2.68457H24.9606C24.9239 2.68454 24.8877 2.67003 24.8617 2.64422M24.8617 2.64422L24.9021 2.68457H6.5625V2.54537C6.5625 2.58229 6.54783 2.61769 6.52173 2.6438C6.49562 2.6699 6.46021 2.68457 6.4233 2.68457H6.5625V32.3153H6.4233C6.46021 32.3153 6.49562 32.3299 6.52173 32.356C6.54784 32.3821 6.5625 32.4175 6.5625 32.4545V32.3153H16.6051C17.2092 32.3153 17.6989 32.8049 17.6989 33.409C17.6989 34.0131 17.2092 34.5028 16.6051 34.5028H6.4233C5.88006 34.5028 5.35906 34.287 4.97493 33.9028C4.5908 33.5187 4.375 32.9977 4.375 32.4545V2.54537C4.375 2.00212 4.5908 1.48113 4.97493 1.097",
                                                            fill: "#1D3557"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M14.8155 20.9999L18.4613 18.9583L16.4197 22.6041L18.4613 26.2499L14.8155 24.2083L11.1697 26.2499L13.2113 22.6041L11.1697 18.9583L14.8155 20.9999Z",
                                                            fill: "#1D3557"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M23.0247 24.9564L20.8014 22.7331L22.7331 20.8014L24.9564 23.0247L23.0247 24.9564ZM22.0862 19.954L19.9541 22.0862C19.5987 22.4233 19.5987 23.0156 19.9541 23.3709L30.5875 34.0043C30.9428 34.3597 31.5351 34.3597 31.8722 34.0043L34.0044 31.8722C34.3597 31.535 34.3597 30.9428 34.0044 30.5874L23.371 19.954C23.0156 19.5987 22.4233 19.5987 22.0862 19.954Z",
                                                            fill: "#1D3557"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M13.344 11.2676L8.75002 11.9592L12.3056 8.969L11.614 4.375L14.6042 7.93056L19.1982 7.239L15.6426 10.2292L16.3342 14.8232L13.344 11.2676Z",
                                                            fill: "#1D3557"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M22.852 16.0502L18.9583 16.6364L21.9719 14.102L21.3857 10.2083L23.9201 13.2218L27.8139 12.6357L24.8003 15.1701L25.3864 19.0638L22.852 16.0502Z",
                                                            fill: "#1D3557"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    style: {
                                                        textAlign: "left"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            className: ownClasses.tabHeading,
                                                            children: "Start with Quick AI Tools"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            className: ownClasses.secondaryText,
                                                            children: [
                                                                "Complete Projects Faster with Uninterrupted Access to 19 AI Tools",
                                                                " "
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: isMobile ? "".concat(ownClasses.tabsWrapper, " ").concat(ownClasses.stickyTabsWrapper) : ownClasses.hidden,
                        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                            orientation: isMobile ? "horizontal" : "vertical",
                            variant: "scrollable",
                            value: value,
                            classes: {
                                indicator: ownClasses.indicator
                            },
                            onChange: handleChange,
                            className: ownClasses.tabs,
                            "aria-label": "Responsive tabs",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                    className: ownClasses.tab,
                                    classes: {
                                        selected: ownClasses.tabSelected
                                    },
                                    icon: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: ownClasses.tabIcon,
                                        children: "Content AI for Websites"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: ownClasses.tabIcon,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: ownClasses.blackCheck,
                                                src: "https://qwa-assets.s3.us-east-2.amazonaws.com/get-started-magic-pen-large.svg",
                                                alt: "onboarding-background"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    textAlign: "left"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        className: ownClasses.tabHeading,
                                                        children: "Use Content AI for Website"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        className: ownClasses.secondaryText,
                                                        children: [
                                                            "For Content Marketers, SEOs, Copywriters, & Business Owners.",
                                                            " "
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                    className: ownClasses.tab,
                                    classes: {
                                        selected: ownClasses.tabSelected
                                    },
                                    icon: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: ownClasses.tabIcon,
                                        children: "Book Demo for AI SEO Suite"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: ownClasses.tabIcon,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: ownClasses.blackCheck,
                                                src: "https://qwa-assets.s3.us-east-2.amazonaws.com/get-started-calendar.svg",
                                                alt: "onboarding-background"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    textAlign: "left"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        className: ownClasses.tabHeading,
                                                        children: "Book Demo of AI SEO Suite"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        className: ownClasses.secondaryText,
                                                        children: [
                                                            "SEO Platform for Enterprises, Global Brands, & Startups.",
                                                            " "
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                    className: ownClasses.tab,
                                    classes: {
                                        selected: ownClasses.tabSelected
                                    },
                                    icon: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: ownClasses.tabIcon,
                                        children: "Quick AI Tools"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: ownClasses.tabIcon,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                className: ownClasses.toolsSvg,
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "35",
                                                height: "35",
                                                viewBox: "0 0 35 35",
                                                fill: "none",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        "fill-rule": "evenodd",
                                                        "clip-rule": "evenodd",
                                                        d: "M4.97493 1.097C5.35906 0.712873 5.88005 0.49707 6.4233 0.49707H24.9606C25.5034 0.497549 26.0248 0.713485 26.4085 1.09742L31.4162 6.10512C31.6069 6.29554 31.7581 6.52172 31.8612 6.77069C31.9643 7.01967 32.0173 7.28654 32.017 7.556V17.4999C32.017 18.104 31.5274 18.5937 30.9233 18.5937C30.3192 18.5937 29.8295 18.104 29.8295 17.4999V7.61205L29.8699 7.6524C29.8572 7.63957 29.8471 7.62437 29.8401 7.60765C29.8332 7.59099 29.8296 7.57315 29.8295 7.55514V7.61205L24.9021 2.68457H24.9606C24.9239 2.68454 24.8877 2.67003 24.8617 2.64422M24.8617 2.64422L24.9021 2.68457H6.5625V2.54537C6.5625 2.58229 6.54783 2.61769 6.52173 2.6438C6.49562 2.6699 6.46021 2.68457 6.4233 2.68457H6.5625V32.3153H6.4233C6.46021 32.3153 6.49562 32.3299 6.52173 32.356C6.54784 32.3821 6.5625 32.4175 6.5625 32.4545V32.3153H16.6051C17.2092 32.3153 17.6989 32.8049 17.6989 33.409C17.6989 34.0131 17.2092 34.5028 16.6051 34.5028H6.4233C5.88006 34.5028 5.35906 34.287 4.97493 33.9028C4.5908 33.5187 4.375 32.9977 4.375 32.4545V2.54537C4.375 2.00212 4.5908 1.48113 4.97493 1.097",
                                                        fill: "#1D3557"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M14.8155 20.9999L18.4613 18.9583L16.4197 22.6041L18.4613 26.2499L14.8155 24.2083L11.1697 26.2499L13.2113 22.6041L11.1697 18.9583L14.8155 20.9999Z",
                                                        fill: "#1D3557"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M23.0247 24.9564L20.8014 22.7331L22.7331 20.8014L24.9564 23.0247L23.0247 24.9564ZM22.0862 19.954L19.9541 22.0862C19.5987 22.4233 19.5987 23.0156 19.9541 23.3709L30.5875 34.0043C30.9428 34.3597 31.5351 34.3597 31.8722 34.0043L34.0044 31.8722C34.3597 31.535 34.3597 30.9428 34.0044 30.5874L23.371 19.954C23.0156 19.5987 22.4233 19.5987 22.0862 19.954Z",
                                                        fill: "#1D3557"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M13.344 11.2676L8.75002 11.9592L12.3056 8.969L11.614 4.375L14.6042 7.93056L19.1982 7.239L15.6426 10.2292L16.3342 14.8232L13.344 11.2676Z",
                                                        fill: "#1D3557"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M22.852 16.0502L18.9583 16.6364L21.9719 14.102L21.3857 10.2083L23.9201 13.2218L27.8139 12.6357L24.8003 15.1701L25.3864 19.0638L22.852 16.0502Z",
                                                        fill: "#1D3557"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    textAlign: "left"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        className: ownClasses.tabHeading,
                                                        children: "Start with Quick AI Tools"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        className: ownClasses.secondaryText,
                                                        children: [
                                                            "Complete Projects Faster with Uninterrupted Access to 18 AI Tools",
                                                            " "
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }) : null
                    }),
                    value == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: fullPageContentAiLoader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "quattr-spinner-logo",
                                style: {
                                    display: "flex",
                                    position: "relative",
                                    height: "84vh",
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QLoaderWithHeadingDescription/* QLoaderWithHeadingDescription */.y, {
                                    heading: "Please wait & do not refresh screen.",
                                    description: "We are creating your Content AI account & ensuring you enjoy all its perks.",
                                    classes: ownClasses
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingDesignWrapper/* default */.ZP, {
                            component: GetStarted,
                            classes: classes,
                            user: {},
                            setFullPageContentAiLoader: setFullPageContentAiLoader
                        })
                    }) : value == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OnboardingDesignWrapper/* BookDemoWrapper */.s3, {
                        component: bookMeeting,
                        setShowCalendly: setShowCalendly,
                        showCalendly: showCalendly,
                        classes: classes,
                        user: {}
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: ownClasses.aiToolsMainWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: ownClasses.loaderWrapper,
                            children: [
                                fullScreenLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuattrLogoSpinner/* QuattrLogoSpinner */.h, {
                                    text: "Please wait & do not refresh screen.\n We are verifying your purchase & ensuring you have a seamless journey.",
                                    classes: ownClasses
                                }),
                                showToolsVerifyForm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(onboarding_ToolsOnboardingWrapper, {
                                    handleChangePlan: handleChangePlanClick,
                                    classes: classes
                                }) : showPricingAndPlans ? /*#__PURE__*/ (0,jsx_runtime.jsx)(onboarding_PricingSection, {
                                    planPurchaseLoading: planPurchaseLoading,
                                    handlePlanSelection: handlePlanSelection,
                                    classes: classes
                                }) : null
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
// export const getServerSideProps = withPageAuthRequired();
/* harmony default export */ var get_started = (GetStartedWrapped);


/***/ }),

/***/ 93867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useQuestionsStyles; }
/* harmony export */ });
/* unused harmony export DescribeQuestion */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41120);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66306);
/* harmony import */ var _onboarding_OnboardingDesignWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4977);








var useQuestionsStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
    var _obj;
    return {
        qwaFormWrapper: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "relative"
        },
        errorHeading: {
            color: "#C01818",
            textAlign: "center",
            fontFamily: "Poppins",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "normal",
            paddingBottom: "24px"
        },
        appealMessage: {
            color: "#1D3557",
            textAlign: "center",
            fontFamily: "Poppins",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "normal"
        },
        appealMessageDescription: {
            color: "#1D3557",
            textAlign: "center",
            fontFamily: "Poppins",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "normal"
        },
        maxHeaderWidth: {
            maxWidth: "275px",
            margin: "auto !important",
            paddingTop: "20px"
        },
        questionsWrapper: {
            background: "#F6F7F9",
            padding: "24px 20px"
        },
        questionsWrapperForTools: {
            maxWidth: "390px",
            background: "#F6F7F9",
            padding: "24px 20px"
        },
        questionDescription: {
            color: "#1D3557",
            textAlign: "center",
            fontFamily: "Poppins",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "160%"
        },
        buttonOption: {
            borderRadius: "4.2px",
            border: "1.05px solid #1D3557",
            padding: "16.8px 33.6px",
            justifyContent: "center",
            alignItems: "center",
            color: "#1D3557",
            textAlign: "center",
            fontFamily: "Source Sans Pro",
            fontSize: "18.9px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "108%",
            textTransform: "capitalize"
        },
        buttonsWrapper: {
            gap: "16px",
            display: "flex",
            flexDirection: "column",
            margin: "16px 0px"
        },
        otherRoleTextContainer: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: theme.spacing(2)
        }, theme.breakpoints.down("xs"), {
            flexDirection: "column-reverse",
            gap: "unset"
        }),
        inputTextAlignment: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: theme.spacing(2)
        }, theme.breakpoints.down("xs"), {
            flexDirection: "column",
            gap: "unset"
        }),
        buttonsContainerForToolsWrapper: (_obj = {
            display: "flex",
            alignItems: "center",
            gap: "0px"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("xs"), {
            flexDirection: "column-reverse",
            gap: "unset"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, "flexDirection", "column-reverse"), _obj),
        submitButton: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            display: "flex",
            width: "200px",
            padding: "16.8px 33.6px",
            justifyContent: "center",
            alignItems: "center",
            gap: "10.5px",
            flexShrink: 0,
            borderRadius: "4.2px",
            border: "1.05px solid #1D3557",
            background: "#1D3557",
            color: "#FFFFFF",
            textTransform: "capitalize",
            textAlign: "center",
            fontFamily: '"Source Sans Pro"',
            fontSize: "18.9px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "108%",
            "&:hover": {
                backgroundColor: "#1D3557"
            }
        }, theme.breakpoints.down("xs"), {
            width: "100%",
            marginTop: "15px"
        }),
        secondaryText: {
            color: "#757575",
            fontFamily: "Poppins",
            fontSize: "10px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal",
            textAlign: "left"
        },
        studentQualityDesc: {
            color: "#1D3557",
            textAlign: "center",
            fontFamily: '"Source Sans Pro"',
            fontSize: "13px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "108%"
        },
        updateEmailLink: {
            color: "#1D3557",
            fontFamily: "Poppins",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "normal",
            cursor: "pointer",
            textAlign: "center"
        },
        termsText: {
            color: "#1D3557",
            textAlign: "center",
            fontFamily: '"Source Sans Pro"',
            fontSize: "12px",
            fontStyle: "normal",
            fontweight: 400
        },
        termsLink: {
            fontFamily: '"Source Sans Pro"',
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "108%",
            textDecorationLine: "underline",
            cursor: "pointer"
        }
    };
});
var DescribeQuestion = function(param) {
    var setIsDescriberQuestionAnswered = param.setIsDescriberQuestionAnswered, isClickedOnLockedOption = param.isClickedOnLockedOption, setIsUseLockedGraceAvailable = param.setIsUseLockedGraceAvailable, handleOpen = param.handleOpen, isReachedMaxLimit = param.isReachedMaxLimit, toolMeta = param.toolMeta;
    var ref = useState(false), showOtherInput = ref[0], setShowOtherInput = ref[1];
    var ref1 = useState(""), otherValue = ref1[0], setOtherValue = ref1[1];
    var handleSelectAnswer = function(option) {
        var isStudent = [
            "Student or Academia"
        ].includes(option);
        var redirectUser = false;
        setIsDescriberQuestionAnswered(option);
        setCookie("tool_usr_desc", option, true);
        if (isStudent) {
            handleOpen(true);
        } else {
            redirectUser = true;
        }
        trackAnalyticsEvent({
            eventName: "Job role question answered",
            payload: _object_spread({
                label: "Job role question answered",
                component_name: COMPONENT_NAMES.contentai_ai_tools,
                screen_name: SCREEN_NAMES.contentai_ai_tools,
                answer: option
            }, toolMeta)
        });
        setUserAttribute("role", option);
        if (redirectUser) {
            var ref, ref1;
            var UrlToRedirect = isClickedOnLockedOption ? "/get-started?unlock-options" : "/get-started?signup-now";
            localStorage.setItem("previousUrl", window === null || window === void 0 ? void 0 : (ref = window.parent) === null || ref === void 0 ? void 0 : (ref1 = ref.location) === null || ref1 === void 0 ? void 0 : ref1.href);
            trackAnalyticsEvent({
                eventName: "Prompted to Sign Up",
                counterName: "Prompted to Sign Up",
                isAddCount: true,
                isAnonymousUser: true,
                payload: _object_spread({
                    label: "Prompted to Sign Up",
                    reason: isClickedOnLockedOption ? "Clicked on Locked Option" : "Reached your maximum usage limit",
                    component_name: COMPONENT_NAMES.contentai_ai_tools,
                    screen_name: SCREEN_NAMES.contentai_ai_tools
                }, toolMeta)
            });
            window.parent.postMessage({
                action: "redirectURL",
                url: UrlToRedirect
            }, "*");
        }
    };
    var onboardingStyles = useOnboardingStyles();
    var questionStyles = useQuestionsStyles();
    useEffect(function() {
        trackAnalyticsEvent({
            eventName: "Job role question shown",
            payload: _object_spread({
                label: "Job role question shown",
                component_name: COMPONENT_NAMES.contentai_ai_tools,
                screen_name: SCREEN_NAMES.contentai_ai_tools
            }, toolMeta)
        });
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            isReachedMaxLimit ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        className: "".concat(questionStyles.appealMessage, " m-15"),
                        children: "Answer a Question to Get Additional Free Usage"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        className: questionStyles.errorHeading,
                        children: "You’ve reached your maximum usage limit"
                    })
                ]
            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        className: "".concat(questionStyles.appealMessage, " m-15"),
                        children: "Answer the question to access this feature"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        className: questionStyles.errorHeading,
                        children: "You have clicked on a locked option"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: questionStyles.questionsWrapper,
                style: {
                    background: "#F6F7F9"
                },
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h5",
                        component: "h2",
                        className: onboardingStyles.heading,
                        style: {
                            lineHeight: "160%"
                        },
                        children: "What describes you best?"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        style: {
                            margin: "16px 0px 0px 0px",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                onClick: function() {
                                    handleSelectAnswer("Student or Academia");
                                },
                                style: {
                                    width: "100%"
                                },
                                className: questionStyles.buttonOption,
                                children: "Student or Academia*"
                            }),
                            /*#__PURE__*/ _jsx(FormHelperText, {
                                className: questionStyles.studentQualityDesc,
                                children: "*This selection does not qualify for any special pricing or discounts."
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: questionStyles.buttonsWrapper,
                        children: [
                            [
                                "Business Owner",
                                "Marketing Professional",
                                "SEO or Content Marketer"
                            ].map(function(i) {
                                return /*#__PURE__*/ _jsx(_Fragment, {
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        onClick: function() {
                                            handleSelectAnswer(i);
                                        },
                                        className: questionStyles.buttonOption,
                                        children: i
                                    })
                                });
                            }),
                            !showOtherInput && /*#__PURE__*/ _jsx(Button, {
                                onClick: function() {
                                    return setShowOtherInput(true);
                                },
                                className: questionStyles.buttonOption,
                                children: "Other (Please type role name in English)"
                            }),
                            showOtherInput && /*#__PURE__*/ _jsxs("div", {
                                className: questionStyles.otherRoleTextContainer,
                                children: [
                                    /*#__PURE__*/ _jsx(TextField, {
                                        className: questionStyles.questionDescription,
                                        placeholder: "Type role name in English",
                                        variant: "outlined",
                                        fullWidth: true,
                                        value: otherValue,
                                        onChange: function(e) {
                                            return setOtherValue(e.target.value);
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(Button, {
                                        onClick: function() {
                                            if (otherValue) {
                                                handleSelectAnswer(otherValue);
                                            }
                                        },
                                        className: questionStyles.submitButton,
                                        children: "Submit"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 28925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ QLoaderWithHeadingDescription; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22318);
/* harmony import */ var _public_Spinner_Logo_gif__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55175);



var QLoaderWithHeadingDescription = function(param) {
    var classes = param.classes, _heading = param.heading, heading = _heading === void 0 ? "" : _heading, _description = param.description, description = _description === void 0 ? "" : _description;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classes.overlay,
                style: {
                    zIndex: 9,
                    position: "relative"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classes.loader,
                style: {
                    zIndex: 9
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: _public_Spinner_Logo_gif__WEBPACK_IMPORTED_MODULE_1__/* ["default"].src */ .Z.src,
                        alt: "Loading..."
                    }),
                    heading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: classes.loaderText,
                        children: heading
                    }) : null,
                    description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: classes.loaderTextDescription,
                        children: description
                    }) : null
                ]
            })
        ]
    });
};


/***/ }),

/***/ 53056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ QuattrLogoSpinner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22318);
/* harmony import */ var _public_Spinner_Logo_gif__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55175);



var QuattrLogoSpinner = function(param) {
    var classes = param.classes, _text = param.text, text = _text === void 0 ? "" : _text;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classes.overlay,
                style: {
                    zIndex: 9
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classes.loader,
                style: {
                    zIndex: 9
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: _public_Spinner_Logo_gif__WEBPACK_IMPORTED_MODULE_1__/* ["default"].src */ .Z.src,
                        alt: "Loading..."
                    }),
                    text ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: classes.loaderText,
                        children: text
                    }) : null
                ]
            })
        ]
    });
};


/***/ }),

/***/ 27290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ customInputUseStyles; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39803);
/* harmony import */ var _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96394);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64436);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(868);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30585);
/* harmony import */ var _material_ui_icons_Info__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18362);











var customInputUseStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    var _obj;
    return {
        formControl: {
            position: "relative",
            width: "100%",
            margin: "0px 0px 15px 0px"
        },
        infoIcon: {
            position: "absolute",
            top: "-17px",
            // top: '-25px', // Changed to position tooltip above the icon
            left: "146px",
            "& .MuiSvgIcon-root": {
                fontSize: "1rem"
            }
        },
        inputLabel: {
            position: "absolute",
            left: 0,
            top: -30,
            color: "#1D3557",
            fontFamily: "Poppins",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "normal"
        },
        centerAlignLabel: {
            width: "100%",
            textAlign: "center",
            color: "#1D3557",
            fontWeight: 700
        },
        textField: {
            marginTop: theme.spacing(2),
            "& .MuiOutlinedInput-input": {
                padding: "12.5px 12px"
            }
        },
        maxWidth: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            maxWidth: "245px"
        }, theme.breakpoints.down("sm"), {
            maxWidth: "unset"
        }),
        centeredContent: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "498px"
        }, theme.breakpoints.down("sm"), {
            width: "100%"
        }),
        centeredContentForTools: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%"
        }, theme.breakpoints.down("sm"), {
            width: "100%"
        }),
        otpTextField: {
            "& input": (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                // height: "19.422px",
                width: "400px",
                textAlign: "center",
                paddingLeft: theme.spacing(4)
            }, theme.breakpoints.down("sm"), {
                width: "100%"
            })
        },
        otpTextFieldForTools: {
            "& input": (_obj = {
                // height: "19.422px",
                minWidth: "230px",
                textAlign: "center",
                paddingLeft: theme.spacing(4)
            }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("md"), {
                width: "100%"
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, theme.breakpoints.up(450), {
                minWidth: "450px"
            }), _obj)
        },
        selectFormControl: {
            width: "100%"
        },
        staticLabel: {
            top: "-27px",
            left: "-10px"
        },
        selectEmpty: {
            marginTop: "15px",
            textAlign: "left",
            "& .MuiOutlinedInput-input": {
                padding: "12.5px 12px"
            }
        },
        placeholder: {
            color: "#979797",
            fontFamily: "inherit",
            fontSize: "13.942px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "24.398px",
            float: "left"
        }
    };
});
// Updated component to make it reusable
var CustomInput = function(_param) {
    var label = _param.label, _id = _param.id, id = _id === void 0 ? "work-email" : _id, _type = _param.type, type = _type === void 0 ? "text" : _type, onChange = _param.onChange, _error = _param.error, error = _error === void 0 ? false : _error, _errorMessage = _param.errorMessage, errorMessage = _errorMessage === void 0 ? "" : _errorMessage, _isOtp = _param.isOtp, isOtp = _isOtp === void 0 ? false : _isOtp, _isOnToolsVerify = _param.isOnToolsVerify, isOnToolsVerify = _isOnToolsVerify === void 0 ? false : _isOnToolsVerify, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "label",
        "id",
        "type",
        "onChange",
        "error",
        "errorMessage",
        "isOtp",
        "isOnToolsVerify"
    ]);
    var classes = customInputUseStyles();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), tooltipOpen = ref[0], setTooltipOpen = ref[1];
    var tooltipRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var handleTooltipToggle = function() {
        setTooltipOpen(!tooltipOpen);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleClickOutside = function(event) {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
                setTooltipOpen(false); // Close tooltip if click is outside
            }
        };
        // Add when the tooltip is open and remove when it is closed
        if (props.info && tooltipOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        tooltipOpen
    ]);
    var inputProps = isOtp ? {
        inputProps: {
            maxLength: 6,
            inputMode: "numeric",
            pattern: "[0-9]*"
        },
        className: "".concat(classes.textField, " ").concat(isOnToolsVerify ? classes.otpTextFieldForTools : classes.otpTextField, " ").concat(props.whiteBg ? "bg-white" : "")
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        error: error,
        className: "".concat(classes.formControl, " ").concat(props.limitWidth ? classes.maxWidth : "", " ").concat(isOtp && !isOnToolsVerify ? classes.centeredContent : isOnToolsVerify ? classes.centeredContentForTools : "", " ").concat(props.fullWidth ? "w-100" : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                htmlFor: id,
                className: "".concat(classes.inputLabel, " ").concat(isOtp ? classes.centerAlignLabel : ""),
                children: label
            }),
            props.info && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                title: props.info,
                placement: "top",
                open: tooltipOpen,
                classes: {
                    tooltip: "m-0"
                },
                arrow: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    ref: tooltipRef,
                    className: classes.infoIcon,
                    onClick: handleTooltipToggle,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Info__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                })
            }),
            !isOnToolsVerify ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                id: id,
                className: "".concat(classes.textField, " ").concat(props.whiteBg ? "bg-white" : ""),
                variant: "outlined",
                onChange: onChange,
                type: isOtp ? "tel" : type,
                InputLabelProps: {
                    shrink: true
                },
                // InputProps={{
                //     startAdornment: <InputAdornment position="start">https://</InputAdornment>,
                //   }}
                error: error
            }, inputProps, props)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                id: id,
                className: "".concat(classes.textField, " ").concat(props.whiteBg ? "bg-white" : ""),
                variant: "outlined",
                onChange: onChange,
                type: isOtp ? "tel" : type,
                // InputLabelProps={{ shrink: true }}
                // InputProps={{
                //     startAdornment: <InputAdornment position="start">https://</InputAdornment>,
                //   }}
                error: error
            }, inputProps, props)),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                id: "".concat(id, "-error-text"),
                children: errorMessage
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomInput);


/***/ }),

/***/ 4977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M4": function() { return /* binding */ useOnboardingStyles; },
/* harmony export */   "s3": function() { return /* binding */ BookDemoWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core_List__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(62822);
/* harmony import */ var _material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50998);
/* harmony import */ var _material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(46869);
/* harmony import */ var _material_ui_icons_CheckCircle__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(81395);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31955);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14310);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(55517);
/* harmony import */ var _utility_services_uiHelpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4465);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66306);
/* harmony import */ var _pages_get_started__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98901);
/* harmony import */ var _content_ai_tools_components_QuattrLogoSpinner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53056);
/* eslint-disable @next/next/no-img-element */ 
















var useOnboardingStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(theme) {
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6;
    return {
        root: (_obj = {
            display: "flex",
            justifyContent: "center",
            margin: "0 auto",
            height: "100vh",
            overflow: "scroll"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("lg"), {
            maxWidth: "1440px"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("sm"), {
            width: "auto",
            height: "unset"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, theme.breakpoints.between("sm", "md"), {
            width: "auto",
            height: "unset"
        }), _obj),
        freeTrialRoot: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            display: "flex",
            justifyContent: "center",
            margin: "0 auto",
            height: "100vh",
            overflow: "scroll"
        }, theme.breakpoints.down(1150), {
            flexDirection: "column-reverse",
            alignItems: "center",
            gap: "40px",
            width: "auto",
            height: "unset"
        }),
        startFreeTrialWrapper: (_obj1 = {
            display: "flex",
            justifyContent: "center",
            margin: "0 auto",
            height: "100vh",
            overflowY: "scroll",
            border: "1px solid red",
            flexDirection: "row"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj1, theme.breakpoints.up("lg"), {
            maxWidth: "1440px"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj1, theme.breakpoints.down("sm"), {
            width: "auto",
            height: "unset"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj1, theme.breakpoints.down("md"), {
            width: "auto",
            height: "unset"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj1, theme.breakpoints.between("md", "lg"), {
            width: "auto",
            height: "unset",
            flexDirection: "row",
            gap: "40px",
            alignItems: "center"
        }), _obj1),
        noteDescription: {
            color: "#1D3557",
            fontFamily: "Poppins",
            fontSize: "14px",
            fontWeight: 500,
            padding: "0 20px",
            textAlign: "center",
            marginTop: "30px"
        },
        noteText: {
            color: "red",
            textAlign: "center"
        },
        buyPlanDescription: {
            color: "#1D3557",
            fontFamily: "Poppins",
            fontSize: "14px",
            fontWeight: 500,
            padding: "0 20px",
            textAlign: "center",
            marginBottom: "20px"
        },
        buyPlan: {
            color: "#51D497",
            textDecoration: "underline",
            textAlign: "center",
            cursor: "pointer"
        },
        overallToolsWrapper: {
            padding: "0 24px"
        },
        sectionOne: (_obj2 = {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj2, theme.breakpoints.down("sm"), {
            width: "100%",
            padding: theme.spacing(2),
            order: 1
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj2, theme.breakpoints.up("md"), {
            width: "417px"
        }), _obj2),
        freeTrialSectionOne: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        },
        sectionOneForToolsWrapper: (_obj3 = {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            border: "2px solid #51D497",
            background: "#F6F7F9",
            borderRadius: "10px",
            margin: "0 32px",
            maxWidth: "540px"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj3, theme.breakpoints.down("sm"), {
            width: "100%",
            padding: theme.spacing(2),
            order: 1,
            margin: "0px"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj3, theme.breakpoints.up("md"), {
            width: "417px"
        }), _obj3),
        sectionTwo: (_obj4 = {
            // flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            position: "relative",
            padding: "0 20px"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj4, theme.breakpoints.down("sm"), {
            order: 2,
            padding: theme.spacing(2),
            alignItems: "center",
            marginTop: "30px"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj4, "&::after", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            content: "''",
            display: "block",
            width: "400px",
            height: "330px",
            backgroundImage: "url('https://qwa-assets.s3.us-east-2.amazonaws.com/up-right-arrow-bg.svg')",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            position: "absolute",
            top: "-10%",
            zIndex: -1,
            right: "25%",
            transform: "rotate(7.831deg)"
        }, theme.breakpoints.down("sm"), {
            // display: 'none'
            width: "80%",
            top: "5%",
            right: "25%"
        })), _obj4),
        freeTrialSectionOneTwo: (_obj5 = {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            position: "relative",
            padding: "0 20px",
            maxWidth: "590px"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj5, theme.breakpoints.down(1410), {
            width: "auto"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj5, "&::after", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            content: "''",
            display: "block",
            width: "400px",
            height: "330px",
            backgroundImage: "url('https://qwa-assets.s3.us-east-2.amazonaws.com/up-right-arrow-bg.svg')",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            position: "absolute",
            top: "-10%",
            zIndex: -1,
            right: "25%",
            transform: "rotate(7.831deg)"
        }, theme.breakpoints.down("sm"), {
            width: "80%",
            top: "5%",
            right: "25%"
        })), _obj5),
        sectionTwoMainHeading: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            color: "#1D3557",
            textAlign: "center",
            fontFamily: "Poppins",
            fontSize: "42px",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "140%"
        }, theme.breakpoints.down("sm"), {
            fontSize: "28px"
        }),
        sectionTwoMainSubHeading: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            color: "#1D3557",
            fontFamily: "Poppins",
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "140%",
            textAlign: "center",
            maxWidth: "415px",
            marginTop: "30px"
        }, theme.breakpoints.down("sm"), {
            fontSize: "16px"
        }),
        topHeadingsWrapper: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            marginTop: "60px"
        }, theme.breakpoints.down("sm"), {
            marginTop: "24px",
            padding: "0 10px"
        }),
        topHeading: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            color: "#51D497",
            textAlign: "center",
            fontFamily: "Poppins",
            fontSize: "48px",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "140%"
        }, theme.breakpoints.down("sm"), {
            fontSize: "23px",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "140%",
            padding: "0px 16px",
            marginBottom: "10px"
        }),
        topSubHeading: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            color: "#1D3557",
            fontFamily: "Poppins",
            fontSize: "28px",
            textAlign: "center",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "200%"
        }, theme.breakpoints.down("sm"), {
            fontSize: "21px",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "140%",
            marginBottom: "10px"
        }),
        topDescription: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            color: "#1D3557",
            fontSize: "18px",
            fontWeight: 500,
            textAlign: "center"
        }, theme.breakpoints.down("sm"), {
            fontSize: "14px",
            marginBottom: "14px"
        }),
        topDescriptionAnchor: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            color: "#51D497",
            fontSize: "18px",
            textDecoration: "underline",
            cursor: "pointer"
        }, theme.breakpoints.down("sm"), {
            fontSize: "14px"
        }),
        topDescriptionNote: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            color: "#1D3557",
            fontSize: "14px",
            fontFamily: "Poppins",
            fontWeight: 500,
            textAlign: "center"
        }, theme.breakpoints.down("sm"), {
            fontSize: "11px"
        }),
        topSubHeadingForTools: (_obj6 = {
            color: "#1D3557",
            fontFamily: "Poppins",
            fontSize: "28px",
            textAlign: "center",
            fontStyle: "normal",
            fontWeight: 800,
            marginBottom: "10px",
            lineHeight: "100%"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj6, theme.breakpoints.down("sm"), {
            fontSize: "19px",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "140%",
            padding: "0px 16px"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj6, theme.breakpoints.down(360), {
            fontSize: "18px",
            lineHeight: "120%",
            padding: "0px 10px"
        }), _obj6),
        orDivider: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            color: "#1D3557",
            fontFamily: "Poppins",
            fontSize: "21px",
            textAlign: "center",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "200%"
        }, theme.breakpoints.down("sm"), {
            fontSize: "21px",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "140%",
            padding: "0px 16px"
        }),
        // bg_image_small: {
        //   position: 'absolute',
        //   bottom: '15px',
        //   right: '15px',
        //   [theme.breakpoints.down('sm')]: {
        //     display: 'none',
        //   },
        // },
        appBar: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            zIndex: theme.zIndex.drawer + 1,
            padding: "15px 30px",
            background: "#1D3557"
        }, theme.breakpoints.down("sm"), {
            position: "fixed",
            // alignItems: 'center',
            paddingBottom: "0px",
            background: "#FFF",
            padding: "0px"
        }),
        logo: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            width: "118px",
            height: "36.48px",
            maxHeight: 55,
            cursor: "pointer"
        }, theme.breakpoints.down("sm"), {
            width: "77px",
            height: "23.99px"
        }),
        innerWrap: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            paddingTop: "20px",
            display: "flex",
            width: "417px",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "24px"
        }, theme.breakpoints.down("sm"), {
            width: "100%",
            maxWidth: "382px"
        }),
        heading: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            color: "#1D3557",
            fontFamily: "Poppins",
            fontSize: "28px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "normal",
            margin: "0px"
        }, theme.breakpoints.down("sm"), {
            fontSize: "24px"
        }),
        heading2: {
            fontSize: "22px"
        },
        subText: {
            color: "#212121",
            textAlign: "left",
            fontFamily: "Poppins",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal"
        },
        cmwBanner: {
            padding: "0px",
            margin: "0px",
            fontWeight: "bold",
            fontSize: "12px"
        },
        link: {
            color: "#212121",
            fontFamily: "Poppins",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "normal",
            textDecorationLine: "underline"
        },
        primary_action: {
            height: "64px",
            padding: "10.456px 16.265px",
            justifyContent: "center",
            alignItems: "center",
            gap: "11.618px",
            alignSelf: "stretch",
            borderRadius: "6.971px",
            background: "#51D497",
            color: "#1D3557",
            fontFamily: "Poppins",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "20.912px",
            textTransform: "capitalize",
            "&:hover": {
                backgroundColor: "#51D497"
            }
        },
        red: {
            color: "red"
        },
        green: {
            color: "#50D396"
        },
        // new design v1
        featureList: {
            padding: 0,
            margin: theme.spacing(2, 0)
        },
        featureItem: {
            display: "flex",
            alignItems: "center"
        },
        featureItemText: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            color: "#1D3557",
            fontFamily: "Source Sans Pro",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "160%"
        }, theme.breakpoints.down("sm"), {
            fontSize: "14px"
        }),
        featureIcon: {
            marginRight: theme.spacing(1),
            width: "12px",
            height: "12px",
            color: "#51D497"
        },
        brandsHeading: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            color: "#51D497",
            textAlign: "center",
            fontFamily: "Poppins, sans-serif",
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "normal",
            margin: "15px 0px"
        }, theme.breakpoints.down("sm"), {
            fontSize: "16px",
            marginTop: "20px",
            marginBottom: "20px"
        }),
        brandLogo: {
            // Additional styles for the logos if needed
            margin: theme.spacing(1)
        },
        brandLogosContainer: {
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            flexWrap: "wrap"
        },
        CheckCircleListItemIcon: {
            minWidth: "10px"
        },
        goBack: {
            color: "#1D3557",
            textAlign: "center",
            fontFamily: "Poppins",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "140%",
            width: "289px",
            height: "48px",
            flexShrink: 0,
            borderRadius: "10px",
            border: "2px solid #1D3557",
            textTransform: "capitalize"
        },
        usageLimit: {
            color: "#1D3557",
            textAlign: "center",
            fontFamily: '"Source Sans Pro"',
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "140%"
        },
        startFreeTrial: {
            color: "#1D3557",
            textAlign: "center",
            fontFamily: "Poppins",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "140%",
            width: "289px",
            height: "48px",
            flexShrink: 0,
            borderRadius: "10px",
            background: "#51D497",
            textTransform: "capitalize"
        },
        exploreToolsSection: {
            display: "flex",
            flexDirection: "column",
            maxWidth: "400px",
            margin: "auto",
            textAlign: "center"
        },
        exploreFreeAiToolsBtn: {
            borderRadius: "4.2px",
            background: "#51D497",
            textTransform: "none",
            padding: "16.8px 33.6px"
        }
    };
});
var CONSTANTS = {
    brandLogos: [
        {
            src: "https://qwa-assets.s3.us-east-2.amazonaws.com/coursera+2.svg",
            alt: "Coursera Logo"
        },
        {
            src: "https://qwa-assets.s3.us-east-2.amazonaws.com/wp-engine-1+1.svg",
            alt: "WP Engine Logo"
        },
        {
            src: "https://qwa-assets.s3.us-east-2.amazonaws.com/simpplr-logo+1.svg",
            alt: "Simpplr Logo"
        },
        {
            src: "https://qwa-assets.s3.us-east-2.amazonaws.com/Marriott-International-Logo-1993-2016+1.svg",
            alt: "Marriot Logo"
        },
        {
            src: "https://qwa-assets.s3.us-east-2.amazonaws.com/McAfee+1.svg",
            alt: "McAfee Logo"
        }, 
    ]
};
var OnboardingComponent = function(param) {
    var classes = param.classes, children = param.children, showGoBack = param.showGoBack;
    var isMobile = (0,_utility_services_uiHelpers__WEBPACK_IMPORTED_MODULE_3__/* .useView */ .Pl)("mobileOnly");
    var signupStyles = (0,_pages_get_started__WEBPACK_IMPORTED_MODULE_6__.useSignUpStyles)();
    var Router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var qttr_tools_auth = js_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("qttr_tools_auth");
    var isFromUnlockOption = Object.keys(Router.query).includes("unlock-options");
    var isSignUpNow = Object.keys(Router.query).includes("signup-now");
    var scrollToTop = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var handleGoBack = function() {
        var previousUrl = localStorage.getItem("previousUrl");
        if (previousUrl) {
            // Modify the URL to add or update query parameters as needed
            var newUrl = new URL(previousUrl, window.location.origin);
            if (!qttr_tools_auth) {
                newUrl.searchParams.set("verifyEmail", "true"); // Add or modify query params here
            }
            if (isFromUnlockOption) {
                newUrl.searchParams.set("unlock-options", "true");
            } else if (isSignUpNow) {
                newUrl.searchParams.set("signup-now", "true");
            }
            // Use Router.push or Router.replace to navigate
            Router.push(newUrl.pathname + newUrl.search);
        } else {
            // Fallback if no previous URL was stored
            Router.back();
        }
    };
    var goBackAndContinueLabel = !qttr_tools_auth ? isFromUnlockOption ? "Verify Email & Unlock" : "Verify Email & Use Tools" : "Go Back & Use Another Tool";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        container: true,
        className: classes.root,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: classes.topHeadingsWrapper,
                    style: {
                        padding: "0 20px"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            variant: "h1",
                            className: classes.topHeading,
                            children: isFromUnlockOption ? "Unlock All Options with Quattr’s Content AI " : isSignUpNow ? "Go Beyond Free Tools - Try Quattr’s Content AI" : "Generate 10X Clicks with Content AI"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            variant: "h3",
                            className: classes.topSubHeading,
                            children: isFromUnlockOption ? "The Content Copilot for SEO & Marketing Teams" : isSignUpNow ? "The Content Copilot for SEO & Marketing Teams" : "Built for Growth & Marketing Teams"
                        }),
                        !isFromUnlockOption && !isSignUpNow ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    className: classes.topDescription,
                                    children: [
                                        "Write, optimize & rank high with ease and speed. Learn more about",
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: classes.topDescriptionAnchor,
                                            onClick: function() {
                                                return Router.push("/content-ai");
                                            },
                                            children: "Quattr Content AI"
                                        }),
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    className: classes.topDescriptionNote,
                                    children: "Note: Your Content AI free trial account does not grant you additional access to AI Tools."
                                })
                            ]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: classes.freeTrialRoot,
                    style: {
                        height: "auto",
                        marginTop: isMobile ? "3vh" : "5vh"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            item: true,
                            className: classes.freeTrialSectionOneTwo,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    variant: "h1",
                                    className: classes.sectionTwoMainHeading,
                                    children: "What to expect from your 2-week free trial?"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    variant: "h3",
                                    className: classes.sectionTwoMainSubHeading,
                                    children: "Revolutionize your SEO & Content Production now!"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_List__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    className: classes.featureList,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            className: classes.featureItem,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                    className: classes.CheckCircleListItemIcon,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_CheckCircle__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        className: classes.featureIcon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    variant: "body1",
                                                    className: classes.featureItemText,
                                                    children: "Connect your Google Search Console account to get all your keyword data"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            className: classes.featureItem,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                    className: classes.CheckCircleListItemIcon,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_CheckCircle__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        className: classes.featureIcon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    variant: "body1",
                                                    className: classes.featureItemText,
                                                    children: "Optimize published pages for high SEO rankings"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            className: classes.featureItem,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                    className: classes.CheckCircleListItemIcon,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_CheckCircle__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        className: classes.featureIcon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    variant: "body1",
                                                    className: classes.featureItemText,
                                                    children: "Conduct unlimited keyword research on topics"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            className: classes.featureItem,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                    className: classes.CheckCircleListItemIcon,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_CheckCircle__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        className: classes.featureIcon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    variant: "body1",
                                                    className: classes.featureItemText,
                                                    children: "Create new high-quality content faster"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    variant: "body1",
                                    className: classes.brandsHeading,
                                    children: "Top SEO and content marketing teams trust Quattr"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    className: classes.brandLogosContainer,
                                    children: CONSTANTS.brandLogos.map(function(brandLogo) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: brandLogo.src,
                                            alt: brandLogo.alt,
                                            className: classes.brandLogo
                                        }, brandLogo.src);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            item: true,
                            className: classes.freeTrialSectionOne,
                            children: [
                                children,
                                isMobile && (isFromUnlockOption || isSignUpNow) && showGoBack && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "center-align",
                                    style: {
                                        margin: "3vh 0px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            onClick: function() {
                                                (0,_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_5__/* .trackAnalyticsEvent */ .ec)({
                                                    eventFor: "button",
                                                    buttonText: "",
                                                    counterName: "Clicked on ".concat(goBackAndContinueLabel),
                                                    isAddCount: true,
                                                    isAnonymousUser: true,
                                                    payload: {
                                                        label: "Clicked on ".concat(goBackAndContinueLabel),
                                                        component_name: _constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_5__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                                        screen_name: _constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_5__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools
                                                    }
                                                });
                                                handleGoBack();
                                            },
                                            className: classes.goBack,
                                            children: goBackAndContinueLabel
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                            className: classes.usageLimit,
                                            children: [
                                                "(",
                                                isFromUnlockOption && !qttr_tools_auth ? "Unlock the option & use free tool" : "usage limits will apply",
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                (!isMobile || !showGoBack) && (isFromUnlockOption || isSignUpNow) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "center-align",
                    style: {
                        margin: "4vh 0px"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            className: signupStyles.dividerContainer,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                    className: signupStyles.divider,
                                    style: {
                                        maxWidth: "93px"
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    variant: "caption",
                                    className: signupStyles.dividerText,
                                    children: "OR keep using free tools instead"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                    className: signupStyles.divider,
                                    style: {
                                        maxWidth: "93px"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            onClick: function() {
                                (0,_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_5__/* .trackAnalyticsEvent */ .ec)({
                                    eventFor: "button",
                                    buttonText: "",
                                    counterName: "Clicked on ".concat(goBackAndContinueLabel),
                                    isAddCount: true,
                                    isAnonymousUser: true,
                                    payload: {
                                        label: "Clicked on ".concat(goBackAndContinueLabel),
                                        component_name: _constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_5__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                                        screen_name: _constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_5__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools
                                    }
                                });
                                handleGoBack();
                            },
                            className: classes.goBack,
                            children: goBackAndContinueLabel
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            className: classes.usageLimit,
                            children: [
                                "(",
                                isFromUnlockOption && !qttr_tools_auth ? "Unlock the option & use free tool" : "usage limits will apply",
                                ")"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var CalendlyEmbed = function(param) {
    var calendlyLink = param.calendlyLink;
    var handleCalendlyEvent = // Function to handle postMessage events from Calendly
    function handleCalendlyEvent(e) {
        // Check if the event is from Calendly
        if (e.data.event && e.origin === "https://calendly.com") {
            // Check for the specific event type
            console.log("e.data.event==>", e.data.event);
            if (e.data.event == "calendly.event_type_viewed") {
                setIsLoaded(true);
            }
            (0,_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_5__/* .trackAnalyticsEvent */ .ec)({
                eventName: "Calendly - ".concat(e.data.event),
                payload: {
                    label: "Calendly - ".concat(e.data.event)
                }
            });
        }
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), name = ref[0], setName = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoaded = ref1[0], setIsLoaded = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), email = ref2[0], setEmail = ref2[1];
    // Add the event listener when the component mounts
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        window.addEventListener("message", handleCalendlyEvent);
        var email = localStorage.getItem("book-demo-email") || "";
        var name = localStorage.getItem("book-demo-name") || "";
        setName(name);
        setEmail(email);
        // Remove the event listener when the component unmounts
        return function() {
            window.removeEventListener("message", handleCalendlyEvent);
        };
    }, []);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        var head = document.querySelector("head");
        var script = document.createElement("script");
        script.setAttribute("src", "https://assets.calendly.com/assets/external/widget.js");
        if (head) {
            head.appendChild(script);
        }
        return function() {
            if (head) {
                head.removeChild(script);
            }
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            position: "relative"
        },
        children: [
            !isLoaded && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "634px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#fff",
                    zIndex: 10
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_content_ai_tools_components_QuattrLogoSpinner__WEBPACK_IMPORTED_MODULE_7__/* .QuattrLogoSpinner */ .h, {
                        classes: {}
                    }),
                    "Loading calendar..."
                ]
            }),
            name && email && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "calendly-inline-widget",
                "data-url": "".concat(calendlyLink, "?name=").concat(encodeURIComponent(name), "&email=").concat(encodeURIComponent(email)),
                style: {
                    minHeight: "634px"
                }
            })
        ]
    });
};
var BookDemoComponent = function(param) {
    var classes = param.classes, children = param.children, showGoBack = param.showGoBack, showCalendly = param.showCalendly;
    var isMobile = (0,_utility_services_uiHelpers__WEBPACK_IMPORTED_MODULE_3__/* .useView */ .Pl)("mobileOnly");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        container: true,
        className: classes.root,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: classes.topHeadingsWrapper,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            variant: "h1",
                            className: classes.topHeading,
                            children: "Test Drive Quattr AI SEO Suite"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            variant: "h3",
                            className: classes.topSubHeading,
                            children: "The Ultimate AI SEO Platform for Enterprises, Global Brands, & Startups"
                        })
                    ]
                }),
                showCalendly ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CalendlyEmbed, {
                    calendlyLink: "https://calendly.com/anuragsinghal/eu" || 0
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    container: true,
                    className: classes.root,
                    style: {
                        height: "auto",
                        marginTop: isMobile ? "3vh" : "5vh"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            item: true,
                            xs: 12,
                            md: 6,
                            className: classes.sectionTwo,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    variant: "h1",
                                    className: classes.sectionTwoMainHeading,
                                    children: "Book a Free Demo"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    variant: "h3",
                                    className: classes.sectionTwoMainSubHeading,
                                    children: "Explore how Quattr’s features can help your brand rank faster!"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_List__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    className: classes.featureList,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            className: classes.featureItem,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                    className: classes.CheckCircleListItemIcon,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_CheckCircle__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        className: classes.featureIcon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    variant: "body1",
                                                    className: classes.featureItemText,
                                                    children: "Get Real-time SEO Reporting & Analytics"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            className: classes.featureItem,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                    className: classes.CheckCircleListItemIcon,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_CheckCircle__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        className: classes.featureIcon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    variant: "body1",
                                                    className: classes.featureItemText,
                                                    children: "Compare Ranking Factors with Competitors"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            className: classes.featureItem,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                    className: classes.CheckCircleListItemIcon,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_CheckCircle__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        className: classes.featureIcon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    variant: "body1",
                                                    className: classes.featureItemText,
                                                    children: "Scale Content with Generative AI"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_ListItem__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            className: classes.featureItem,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_ListItemIcon__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                    className: classes.CheckCircleListItemIcon,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_CheckCircle__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        className: classes.featureIcon
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    variant: "body1",
                                                    className: classes.featureItemText,
                                                    children: "Automate 30+ Key SEO Tasks & Audits"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    variant: "body1",
                                    className: classes.brandsHeading,
                                    children: "Global brands trust & use Quattr"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    className: classes.brandLogosContainer,
                                    children: CONSTANTS.brandLogos.map(function(brandLogo) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: brandLogo.src,
                                            alt: brandLogo.alt,
                                            className: classes.brandLogo
                                        }, brandLogo.src);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Grid__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            item: true,
                            xs: 12,
                            md: 6,
                            className: classes.sectionOne,
                            children: children
                        })
                    ]
                })
            ]
        })
    });
};
var BookDemoWrapper = function(param) {
    var Component = param.component, classes = param.classes, user = param.user, setShowCalendly = param.setShowCalendly, showCalendly = param.showCalendly;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), showGoBack = ref[0], setGoBack = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BookDemoComponent, {
        classes: classes,
        showGoBack: showGoBack,
        showCalendly: showCalendly,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
            classes: classes,
            setGoBack: setGoBack,
            user: user,
            setShowCalendly: setShowCalendly
        })
    });
};
var OnboardingStylesWrapper = function(param) {
    var Component = param.component, classes = param.classes, user = param.user, _setFullPageContentAiLoader = param.setFullPageContentAiLoader, setFullPageContentAiLoader = _setFullPageContentAiLoader === void 0 ? function(a) {} : _setFullPageContentAiLoader;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), showGoBack = ref[0], setGoBack = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OnboardingComponent, {
        classes: classes,
        showGoBack: showGoBack,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
            classes: classes,
            setGoBack: setGoBack,
            user: user,
            setFullPageContentAiLoader: setFullPageContentAiLoader
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (OnboardingStylesWrapper);


/***/ }),

/***/ 65154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_helmet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64593);





var MetaTagGenerator = function(param) {
    var metaTitle = param.metaTitle, metaDescription = param.metaDescription, metaImage = param.metaImage, metaUrl = param.metaUrl, forceNoIndex = param.forceNoIndex, noFollow = param.noFollow, noCanonical = param.noCanonical;
    var commonMeta = [
        {
            name: "viewport",
            content: "width=device-width, initial-scale=1"
        },
        {
            name: "description",
            content: metaDescription || "World's top brands rely on Quattr for growing web traffic from search engines. Lower your overall cost per acquisition and break free from competition"
        },
        {
            property: "og:locale",
            content: "en_US"
        },
        {
            property: "og:type",
            content: "website"
        }, 
    ];
    if ([
        "production"
    ].includes("production" || 0) && forceNoIndex) {
        commonMeta.push({
            property: "robots",
            content: noFollow ? "noindex, nofollow" : "noindex"
        }, {
            property: "googlebot",
            content: noFollow ? "noindex, nofollow" : "noindex"
        }, {
            name: "robots",
            content: noFollow ? "noindex, nofollow" : "noindex"
        }, {
            name: "googlebot",
            content: noFollow ? "noindex, nofollow" : "noindex"
        });
    }
    var metaData = [
        "production"
    ].includes("production" || 0) ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(commonMeta).concat([
        {
            property: "og:title",
            content: metaTitle || "Quattr Inc | Grow Your Web Traffic 2X Faster"
        },
        {
            property: "og:description",
            content: metaDescription || "World's top brands rely on Quattr for growing web traffic from search engines. Lower your overall cost per acquisition and break free from competition"
        },
        {
            property: "og:url",
            content: metaUrl || "https://www.quattr.com"
        },
        {
            property: "og:site_name",
            content: "Quattr"
        },
        {
            property: "og:image",
            content: metaImage ? "https:".concat(metaImage) : "https://www.quattr.com/og-image_A.jpg"
        },
        {
            property: "og:image:secure_url",
            content: metaImage ? "https:".concat(metaImage) : "https://www.quattr.com/og-image_A.jpg"
        },
        {
            property: "og:image:width",
            content: "1369"
        },
        {
            property: "og:image:height",
            content: "1027"
        },
        {
            name: "twitter:card",
            content: "summary_large_image"
        },
        {
            name: "twitter:domain",
            content: "quattr.com"
        },
        {
            name: "twitter:url",
            content: metaUrl || "https://www.quattr.com"
        },
        {
            name: "twitter:description",
            content: metaDescription || "World's top brands rely on Quattr for growing web traffic from search engines. Lower your overall cost per acquisition and break free from competition"
        },
        {
            name: "twitter:title",
            content: metaTitle || "Quattr Inc | Grow Your Web Traffic 2X Faster"
        },
        {
            name: "twitter:site",
            content: "@Quattr"
        },
        {
            name: "twitter:image",
            content: metaImage ? "https:".concat(metaImage) : "https://www.quattr.com/og-image_A.jpg"
        },
        {
            name: "twitter:image:src",
            content: metaImage ? "https:".concat(metaImage) : "https://www.quattr.com/og-image_A.jpg"
        },
        {
            name: "twitter:creator",
            content: "@Quattr"
        }, 
    ]) : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(commonMeta).concat([
        {
            property: "robots",
            content: noFollow ? "noindex, nofollow" : "noindex"
        },
        {
            property: "googlebot",
            content: noFollow ? "noindex, nofollow" : "noindex"
        },
        {
            name: "robots",
            content: noFollow ? "noindex, nofollow" : "noindex"
        },
        {
            name: "googlebot",
            content: noFollow ? "noindex, nofollow" : "noindex"
        },
        {
            property: "og:title",
            content: metaTitle || "[".concat("production", "] Quattr Inc | Grow Your Web Traffic 2X Faster")
        }, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: metaTitle || ([
                            "production"
                        ].includes("production" || 0) ? "Quattr Inc | Grow Your Web Traffic 2X Faster" : "[".concat("production", "] Quattr Inc | Grow Your Web Traffic 2X Faster"))
                    }),
                    [
                        "production"
                    ].includes("production" || 0) && !noCanonical ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: metaUrl || "https://www.quattr.com"
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_helmet__WEBPACK_IMPORTED_MODULE_3__/* .Helmet */ .q, {
                htmlAttributes: {
                    lang: "en"
                },
                meta: metaData
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MetaTagGenerator);


/***/ }),

/***/ 30831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ isCorporateAndValidEmail; }
/* harmony export */ });
/* harmony import */ var _constants_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31196);

var isCorporateAndValidEmail = function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var str = e.toLowerCase();
    if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(str)) {
        return false;
    }
    var allowedPersonalEmails = [
        "maheshauti00@gmail.com",
        "sanjoli1097@gmail.com",
        "bmmc1990@gmail.com"
    ];
    if (allowedPersonalEmails.includes(str)) {
        return true;
    }
    // Check for ISP domains
    var emailDomain = str.split("@")[1]; // Extract domain from email
    if (_constants_common__WEBPACK_IMPORTED_MODULE_0__/* .ISPDomains.includes */ .Tc.includes(emailDomain)) {
        return false; // ISP domain found
    }
    var nonCorporateDomains = [
        "gmail.com",
        "outlook.com",
        "hotmail.com",
        "yahoo.com",
        "me.com",
        "icloud.com",
        "msn.com",
        "live.com",
        "proton.me",
        ".edu",
        "ac.in", 
    ];
    if (nonCorporateDomains.some(function(domain) {
        if (domain === ".edu") {
            // e.g 00208922@uca.edu.sv
            return new RegExp("\\.edu(\\..+)?$").test(str);
        }
        return str.endsWith(domain);
    })) {
        return false;
    }
    return true;
};


/***/ })

}]);